export default [
    {
        "title": "Quantum Visions",
        "summary": "Based on mathematical visualizations, we work out High-Quality visualizations for entanglement, atomic physics, and particle physics.",
        "description": "<p>Based on mathematical visualizations, we work out High-Quality visualizations for entanglement, atomic physics, and particle physics.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Stefan Heusler",
                "second": "stefan.heusler@uni-muenster.de"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "English",
            "German"
        ],
        "topic": [
            "Quantum Physics"
        ],
        "org": [
            "University of M\u00fcnster"
        ],
        "city": [
            "M\u00fcnster"
        ],
        "country": [
            "Germany"
        ],
        "target": [
            "Secondary school students",
            "Secondary school teachers"
        ],
        "type": [
            "Videos"
        ],
        "id": "defd430f-33db-4d78-aaef-651ba6536b15"
    },
    {
        "title": "Quantum SpinOff - Connecting schools with high-tech research and entrepreneurship",
        "summary": "The Quantum Spinoff project brings science teachers and their pupils in direct contact with research and entrepreneurship in the high-tech nano sector, with the goal of educating a new generation of scientifically literate European citizens and inspiring young people to choose science and technology careers.",
        "description": "<p>Teams of pupils, guided by their science teachers create a responsible and socially relevant valorization of a scientific paper in collaboration with actual researchers and entrepreneurs. They first study quantum physics in school through the Quantum SpinOff learning stations: they follow a conceptual approach and use for instance the analogy between musical standing waves and quantization of electron waves in the atom. The learning path is also supported by hands-on experiments like the measurement of Planck\u2019s constant with LEDs, the measurement of the emission lines of hydrogen, etc. After this conceptual introduction, the pupils come in contact with the real world of quantum technology: they visit high-tech research labs and compete for the European Quantum Spin-Off Prize. Scientific and technological insights, creativity and responsible entrepreneurship are all taken into account by a jury of experts. Science teachers are trained in international and national workshops to support the inquiry learning process of their pupils. The project won the Scientix Resources Award in the Category: STEM-learning materials for students. It received a final score of 80% by the European Commission and it was mentioned in a list of interesting practices as an annex to the report \u201cScience education for responsible citizenship\u201d, prepared by a Science Education Expert Group (SEEG) nominated by the Commission. The aim of this report was to support the preparation of the new Science Education policy initiatives and policy options and to develop specific actions to be included in the Science with and for Society (SwafS) work programs. You can find the Quantum Spinoff project also in the Scientix portal.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Erica Andreotti",
                "second": "erica.andreotti@ucll.be"
            },
            {
                "first": "Renaat Frans",
                "second": "renaat.frans@ucll.be"
            },
            {
                "first": "Lise Verbraeken",
                "second": "lise.verbraeken@ucll.be"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Physics",
            "Quantum Technology",
            "Innovation & Entrepreneurship"
        ],
        "org": [
            "UC Leuven Limburg"
        ],
        "city": [],
        "country": [
            "Belgium"
        ],
        "target": [
            "Primary school teachers",
            "Secondary school teachers"
        ],
        "type": [
            "Platform",
            "Report",
            "Teaching material",
            "Other"
        ],
        "id": "8cbdda30-914b-496e-827f-1ae088d8706b"
    },
    {
        "title": "QuantumLab",
        "summary": "Interactive screen experiments on quantum optics.",
        "description": "",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Jan-Peter Meyn",
                "second": "jan-peter.meyn@physik.uni-erlangen.de"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "English",
            "German"
        ],
        "topic": [
            "Quantum Physics",
            "Quantum Technology"
        ],
        "org": [
            "Friedrich-Alexander-Universit\u00e4t Erlangen-Nurnberg"
        ],
        "city": [
            "Erlangen"
        ],
        "country": [
            "Germany"
        ],
        "target": [
            "Secondary school students",
            "Secondary school teachers"
        ],
        "type": [
            "Experiments",
            "Platform",
            "Other"
        ],
        "id": "18335849-9b6a-415a-91cd-6191b1fbdc3f"
    },
    {
        "title": "Quantum Tour",
        "summary": "Enter the fascinating world of quantum physics through this unique platform!",
        "description": "<p>The <em>Quantum Tour</em> is an exciting way to learn about Quantum Physics and its underlying applications that seeks to bring the world of quantum physics closer to society in general and in particular to non-academic audiences. This virtual tour takes place on an ingenious platform that is segmented in areas inspired by the ICFO building. There you can find animations and videos in which several Group Leaders and young researchers of ICFO have participated.&nbsp; We invite you to explore the platform to gain an overview of some of the core research developments in this field as well as of some of the applications. this platform has been created by ICFO with the support of the AXA Research Fund Chair.</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "ICFO Outreach team",
                "second": "outreach@icfo.eu"
            }
        ],
        "level": [
            "Outreach"
        ],
        "lang": [
            "English",
            "Spanish",
            "Catalan"
        ],
        "topic": [
            "Quantum Physics"
        ],
        "org": [
            "ICFO"
        ],
        "city": [
            "Barcelona"
        ],
        "country": [
            "Spain"
        ],
        "target": [],
        "type": [
            "Platform",
            "Videos"
        ],
        "id": "ab0d7b15-2bc1-4be5-a441-2c3845b0a6ce"
    },
    {
        "title": "Molecule Interferometry in a Simulated Interactive Research Experiment",
        "summary": "This site hosts 2 Simulated Interactive Research Experiments: a) Molecule diffraction at a nanomechanical grating, b) Molecule interferometry in a KDTL/LUMI interferometer. All data and measurements that one can do simulate very closely real-world data, based on physically realistic models.",
        "description": "<p>Both experiments are currently unique systems, built and operated by the Quantum Nanophysics Group at the University of Vienna to demonstrate and exploit the wave-particle duality of complex things. To make these experiments available to the widest possible audience, these experiments were reproduced in a photo-realistic 3D virtual version, which can be manipulated in the same ways that you would manipulate the real-world experiment. All data and measurements that one can do simulate very closely real-world data, based on physically realistic models.</p>\r\n\r\n<p>These Simulated Interactive Research Experiments are largely based on the PhD work of Mathias Tomandl and are described in more detail here. M. Tomandl, T. Mieling, C.M. Losert-Valiente Kroon, M. Hopf, and M. Arndt, Simulated interactive research experiments as educational tools for advanced science, Scientific Reports 5, 14108 (2015).</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Markus Arndt",
                "second": "markus.arndt@univie.ac.at"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education",
            "Outreach"
        ],
        "lang": [],
        "topic": [
            "Quantum Physics"
        ],
        "org": [
            "University of Vienna, Quantum Nanophysics Group"
        ],
        "city": [
            "Vienna"
        ],
        "country": [
            "Austria"
        ],
        "target": [
            "Primary school students",
            "Primary school teachers",
            "Secondary school students",
            "Secondary school teachers",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Experiments",
            "Simulations"
        ],
        "id": "08d885b9-e76d-460c-808b-bc556b7392d7"
    },
    {
        "title": "Diffraction of organic molecules at an alga",
        "summary": "This is an Animated Video Abstract to illustrated the physics of matter-wave diffraction with complex organic molecules as quantum particles, diffracted a the skeleton of an alga.",
        "description": "<p>This illustrates the idea behind the wave-particle duality, which is shown here in an unusual setting, to illustrate the universality of quantum phenomena: Entire dye molecules are diffracted as quantum waves at a nanoscale material grating. The unusual aspect here is that even the skeleton of a natural alga - amphipleura pellucida - can serve as a diffraction grating. This is a video abstract that went along with the respective publication in M. Sclafani, T. J. Juffmann, C. Knobloch, M. Arndt, Quantum coherent propagation of complex molecules through the frustule of the alga Amphipleura pellucida, New Journal of Physics 15, 083004 (2013), DOI: 10.1088/1367-2630/15/8/083004</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Markus Arndt",
                "second": "markus.arndt@univie.ac.at"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education",
            "Outreach"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Physics"
        ],
        "org": [
            "University of Vienna, Quantum Nanophysics Group"
        ],
        "city": [
            "Vienna"
        ],
        "country": [
            "Austria"
        ],
        "target": [
            "Primary school students",
            "Primary school teachers",
            "Secondary school students",
            "Secondary school teachers",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Videos"
        ],
        "id": "613a9ac0-b919-41a7-b889-7859caa1f65e"
    },
    {
        "title": "Quantencomputing Kompakt - Spukhafte Fernwirkung und Teleportation endlich verst\u00e4ndlich",
        "summary": "The book illustrates (Idealized) Experiments to prove entanglement and \"spooky action at a distance\", and the quantum algorithm for teleportation. It does not require more than basic school knowledge in mathematics and does not require knowledge of physics.",
        "description": "<p>The book uses a new method illustrating the algorithm, not in 8-dimensional space, but using the 8 corners of a cube.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [],
        "level": [
            "Primary and Secondary School",
            "Higher education",
            "Lifelong learning and (re)training",
            "Outreach"
        ],
        "lang": [
            "German"
        ],
        "topic": [],
        "org": [
            "Technische Hochschule Mittelhessen"
        ],
        "city": [
            "Gie\u00dfen"
        ],
        "country": [
            "Germany"
        ],
        "target": [
            "Entrepreneurs",
            "Professionals",
            "Technicians",
            "Primary school teachers",
            "Secondary school students",
            "Secondary school teachers",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Book",
            "Publication"
        ],
        "id": "f64e54dc-e2f7-4e4e-9bd9-f85419ab5d3d"
    },
    {
        "title": "QPlayLearn",
        "summary": "QPlayLearn is an online multimedia open platform to learn about quantum science and technologies in a playful way.",
        "description": "<p>QPlayLearn's mission is to provide multi-level education on quantum science and technologies to everyone, regardless of their age and background. We use innovative interactive tools to make the learning process more effective and fun, and accessible at different levels, without giving away scientific correctness. QPlayLearn includes games that teach the basics of quantum physics as well as explanations by global experts focussing on the terminology and concepts of the field in easy-to-understand terms. QPlayLearn offers content of a different level for target groups of different types, from primary school students all the way to physics students in universities. It is also useful for companies who want to understand the potential of the emergent quantum industry, journalists and policymakers who want to understand what quantum technologies are about, and all science enthusiasts who are excited about the second quantum revolution.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Sabrina Maniscalco",
                "second": "contact@qplaylearn.com"
            }
        ],
        "level": [
            "Outreach"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Quantum Metrology",
            "Quantum Physics",
            "Quantum Sensing",
            "Quantum Simulation",
            "Quantum Technology"
        ],
        "org": [
            "Aalto University and University of Helsinki"
        ],
        "city": [
            "Helsinki"
        ],
        "country": [
            "Finland"
        ],
        "target": [],
        "type": [
            "Games",
            "Illustrations",
            "Platform",
            "Presentations",
            "Videos"
        ],
        "id": "45c16a9b-4a95-4740-9790-4546c9cbe152"
    },
    {
        "title": "Quantum Composer",
        "summary": "Quantum Composer is an interactive tool for visualizing and simulating quantum mechanical concepts and systems.",
        "description": "<p>Quantum Composer is an interactive tool for visualizing and simulating quantum mechanical concepts and systems. It consists of a graphical user interface where one can drag-and-drop nodes to create a flow-based simulation. The powerful and versatile quantum visualizations make it relevant for use in education and research. We provide a suite of exercises suitable for students from high school through to the graduate level. See arXiv paper here: https://arxiv.org/abs/2006.07263</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Jacob Sherson",
                "second": "sherson@phys.au.dk"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Physics",
            "Quantum Simulation"
        ],
        "org": [
            "Aarhus University"
        ],
        "city": [
            "Aarhus"
        ],
        "country": [
            "Denmark"
        ],
        "target": [
            "Primary school students",
            "Primary school teachers",
            "Secondary school students",
            "Secondary school teachers",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Experiments",
            "Platform",
            "Publication",
            "Simulations"
        ],
        "id": "c2c4713d-4929-4c50-bda5-f8b5be0ee23c"
    },
    {
        "title": "Quantum Moves 2",
        "summary": "In Quantum Moves 2, players help researchers to solve and understand real problems in cutting-edge quantum research.",
        "description": "<p>In the game, players can find and optimize their solutions to the scientific problems. This helps us to determine both what problems players are best at solving and the strategies they use to tackle them. See our arXiv paper on our initial results here: https://arxiv.org/abs/2004.03296 (accepted to Phys. Rev. Research).</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Jacob Sherson",
                "second": "sherson@phys.au.dk"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education",
            "Outreach"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Physics"
        ],
        "org": [
            "Aarhus University"
        ],
        "city": [
            "Aarhus"
        ],
        "country": [
            "Denmark"
        ],
        "target": [
            "Primary school students",
            "Primary school teachers",
            "Secondary school students",
            "Secondary school teachers",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Games"
        ],
        "id": "a5caca93-4580-457c-a4f8-2d60b32e3357"
    },
    {
        "title": "Teaching Materials (IDIFO)",
        "summary": "Materials produced for the biannual Master program Didactic Innovation in Physics and Guidance (IDIFO): on teaching/learning proposals for Quantum Physics in secondary school.",
        "description": "",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Marisa Michelini",
                "second": "marisa.michelini@uniud.it"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "Italian"
        ],
        "topic": [
            "Quantum Physics",
            "Teaching"
        ],
        "org": [
            "University of Udine"
        ],
        "city": [],
        "country": [
            "Italy"
        ],
        "target": [
            "Secondary school teachers"
        ],
        "type": [
            "Book",
            "Publication",
            "Report",
            "Teaching material"
        ],
        "id": "fe6809fe-edf5-4cf0-a146-c3da320a5c30"
    },
    {
        "title": "Quantum mechanics for high-school students",
        "summary": "Resources for teaching quantum information to high-school students. It includes course outlines and recommended reading materials.",
        "description": "<p><br />\r\n&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Piotr Migda\u0142",
                "second": "piotr@quantumflytrap.com"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Quantum Physics",
            "Quantum Technology"
        ],
        "org": [
            "Quantum Flytrap"
        ],
        "city": [],
        "country": [
            "Poland"
        ],
        "target": [
            "Primary school teachers",
            "Secondary school teachers",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Teaching material"
        ],
        "id": "eb6888a0-c34f-42e6-b4bd-533930659cd7"
    },
    {
        "title": "Quantum Lab - Virtual Optical Table",
        "summary": "Quantum \"LEGO Bricks\". An in-browser simulation & visualization of quantum mechanics. The go-to place for learning quantum before the quantum computing revolution takes off.",
        "description": "<p>Quantum Game is an in-browser simulation &amp; visualization of quantum mechanics. We aim to become the go-to place for learning quantum before the quantum computing revolution takes off. Our first product is \u201cquantum LEGO bricks\u201d - an educational sandbox and a puzzle game. It can be used to set the first steps in the quantum world, teach at any level, and prototype new experiments. The sandbox and game consist of a virtual optical table with drag &amp; drop elements, with the ability to create arbitrary setups. Within this environment, it is possible to recreate interference or quantum cryptography protocols. show entanglement, Bell test, quantum teleportation, and the many-worlds interpretation.<br />\r\n&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Piotr Migda\u0142",
                "second": "piotr@quantumflytrap.com"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education",
            "Outreach"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Physics",
            "Quantum Simulation"
        ],
        "org": [
            "Quantum Flytrap"
        ],
        "city": [],
        "country": [
            "Poland"
        ],
        "target": [
            "Primary school students",
            "Primary school teachers",
            "Secondary school students",
            "Secondary school teachers",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Games",
            "Illustrations",
            "Platform",
            "Simulations",
            "Teaching material"
        ],
        "id": "1aa727fe-b199-4252-8cab-7bd1a88e5500"
    },
    {
        "title": "Quantum Theory: An Information Processing Approach",
        "summary": "This book offers a unique, topical approach to quantum theory at the beginning university level. Material can be covered in a one-semester course, it contains 80 classrooms, tested exercises with solutions, and a manual available online. Tutorial material like chapter summaries, further reading, and navigational aids are in the ebook.",
        "description": "<p>Recent advances in quantum technology - from quantum computers and simulators to secure communication and metrology - have not only opened up a whole new world of practical applications but also changed our understanding of quantum theory itself. This text, for the first time, introduces quantum theory entirely from this new perspective. It does away with the traditional approach to quantum theory as a theory of microscopic matter and instead focuses on quantum theory as a framework for information processing. Accordingly, the emphasis is on concepts like measurement, probability, statistical correlations, and transformations, rather than on waves and particles. This affords a simple, direct route to quantum theory, all the way to some of its most fascinating conceptual issues. Since it requires only minimal mathematics and virtually no prior knowledge of physics, it is accessible to younger undergraduates and students of neighbouring disciplines. The text offers a unique blend of insights both into the physical foundations and the practical application of quantum theory. It begins with a discussion of experimental evidence that forces us to abandon the classical description and to critically re-examine such basic notions as measurement, probability, and state. The thorough investigation of these concepts leads to the alternative framework of quantum theory, set in complex Hilbert space. The requisite mathematics is developed carefully and always linked to its operational meaning. This part of the text culminates in an exploration of some of the most vexing foundational issues of quantum theory, regarding locality, non-contextuality, and realism. The second half of the text explains how the peculiar features of quantum theory may be harnessed to tackle information processing tasks that are intractable or even impossible classically. It provides the essential tools for understanding and designing the pertinent protocols, and discusses a diverse range of examples representative of current quantum technology. These include standard examples like the secure distribution of cryptographic keys, as well as less known applications such as entanglement-assisted metrology. Throughout the text, there is a wealth of classroom-tested and at times unconventional exercises. Oxford University Press, 2021ISBN 9780192896308 (hardback), 9780192896315 (paperback)<br />\r\n-----------------------------------<br />\r\nOrganization name: RheinMain University of Applied Sciences<br />\r\n-----------------------------------<br />\r\nOrganization country: Germany<br />\r\n-----------------------------------<br />\r\nOrganization city: R\u00fcsselsheim<br />\r\n-----------------------------------</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Jochen Rau",
                "second": "jochen.rau@hs-rm.de"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Information",
            "Quantum Physics"
        ],
        "org": [
            "RheinMain University of Applied Sciences"
        ],
        "city": [
            "R\u00fcsselsheim"
        ],
        "country": [
            "Germany"
        ],
        "target": [
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Book"
        ],
        "id": "55759b5c-35d4-4a39-9380-4de6fbea0dec"
    },
    {
        "title": "Science-based games",
        "summary": "A collaborative list of science-based games.",
        "description": "<p>A collaborative list of science-based games. It consists of games that - capture parts of real scientific phenomena (including social science, medicine, etc), - are actually playable (you can play them for fun, not ones \"for classroom only\"). Sublists include games related to Physics, Chemistry, Biology, Computer Science, Health, Mathematics, Sociology and economy, Humanities.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Piotr Migda\u0142",
                "second": "piotr@quantumflytrap.com"
            }
        ],
        "level": [
            "Outreach"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Physics"
        ],
        "org": [
            "Quantum Flytrap"
        ],
        "city": [],
        "country": [
            "Poland"
        ],
        "target": [],
        "type": [
            "Games",
            "Other"
        ],
        "id": "52fb819b-2ec5-4a5e-a207-9c481461505a"
    },
    {
        "title": "Quantum Odyssey: we made learning quantum computing fun",
        "summary": "We developed a new way to learn quantum computing, without prerequisites such as linear algebra and complex numbers.",
        "description": "<p>By rethinking the way quantum algorithms are designed today and the methods used to teach quantum computation, a small startup has developed a fully visual and gamified method to learn quantum physics and design quantum computing algorithms. The learning method proposed by Quark Interactive replaces Dirac\u2019s bra-ket notation and linear algebra used today, with a fun and visual puzzle-building approach to be used in learning or discovering new quantum algorithms. This new method is capable of faithfully representing algorithm building using the universal quantum gate model framework. One of the biggest challenges in the industry today is training the new generation of cross-disciplinary learners to become quantum computing savvy. Quarks Interactive aims towards simplifying the background needed by the learner to discover quantum algorithms, \u200bspecifically by removing the entry barrier of a relatively high level of mathematics. Thus, the learning process becomes fun and engaging. The software made by the young startup has been tested in schools through the Innovate UK BB/T018666/1 grant and is further refined through this grant to become suitable for teaching the foundations of quantum computing to children of ages 12 and above.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Nita Laurentiu",
                "second": "laurentiu_nita@quarksinteractive.com"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Physics",
            "Quantum Technology"
        ],
        "org": [
            "Quarks Interactive"
        ],
        "city": [
            "Miercurea Ciuc"
        ],
        "country": [
            "Romania"
        ],
        "target": [
            "Entrepreneurs",
            "Professionals",
            "Technicians",
            "Secondary school students",
            "Secondary school teachers",
            "BSc students",
            "MSc students",
            "PhD students",
            "Other (specify)"
        ],
        "type": [
            "Games",
            "Platform",
            "Simulations",
            "Teaching material"
        ],
        "id": "369d8912-d87f-4f88-86c2-954ce5c658eb"
    },
    {
        "title": "Oxford-Moscow Quantum Club",
        "summary": "Quantum physics classes for high school students",
        "description": "<p>\u2022 Weekly 2-hour tutorials \u2022 Laboratory practicums (circumstances permitting) \u2022 Virtual and/or real lab tours \u2022 Lectures and meetings with the world\u2019s leading quantum physicists The tutorials are currently for the UK and Russian students only. But we are happy to collaborate and organize similar activities in other countries, too.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Alexander Lvovsky",
                "second": "Alex.Lvovsky@physics.ox.ac.uk"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English",
            "Russian"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Quantum Metrology",
            "Quantum Physics",
            "Quantum Sensing",
            "Quantum Simulation",
            "Quantum Technology"
        ],
        "org": [
            "University of Oxford"
        ],
        "city": [
            "Oxford"
        ],
        "country": [
            "United Kingdom"
        ],
        "target": [
            "Primary school students",
            "Secondary school students"
        ],
        "type": [
            "Teaching material",
            "Videos"
        ],
        "id": "2bfa5bf2-000d-471c-864c-b84451ff6da4"
    },
    {
        "title": "Qiskit Textbook",
        "summary": "Free and very accessible textbook for learning Quantum Computing with Qiskit (open source framework for working with quantum computers at the level of circuits, pulses, and algorithms). ",
        "description": "<p>This textbook is a university quantum algorithms/computation course based on Qiskit to help learn:<br />\r\n1. The mathematics behind quantum algorithms.<br />\r\n2. Details about today's non-fault-tolerant quantum devices.<br />\r\n3. Writing code in Qiskit to implement quantum algorithms on IBM's cloud quantum systems.</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Fabio Scafirimuto",
                "second": "fas@zurich.ibm.com"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education",
            "Lifelong learning and (re)training",
            "Outreach"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Quantum Physics",
            "Quantum Simulation",
            "Quantum Technology",
            "Programming"
        ],
        "org": [
            " IBM Quantum"
        ],
        "city": [
            "Zurich"
        ],
        "country": [
            "Switzerland"
        ],
        "target": [
            "Entrepreneurs",
            "Managers",
            "Investors",
            "Professionals",
            "Technicians",
            "Primary school students",
            "Primary school teachers",
            "Secondary school students",
            "Secondary school teachers",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Book"
        ],
        "id": "faa3db2e-e6c6-43f2-b83f-a00a23a348b2"
    },
    {
        "title": "Coding with Qiskit",
        "summary": "This video series starts at learning how to install Qiskit ( open-source framework for working with quantum computers at the level of circuits, pulses, and algorithms) locally, understanding what gates to do quantum states, and exploring quantum algorithms and the latest research topics.",
        "description": "<p>This video series starts at learning how to install Qiskit ( open-source framework for working with quantum computers at the level of circuits, pulses, and algorithms) locally, understanding what gates to do quantum states, and exploring quantum algorithms and the latest research topics.</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Fabio Scafirimuto",
                "second": "fas@zurich.ibm.com"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education",
            "Lifelong learning and (re)training",
            "Outreach"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Technology"
        ],
        "org": [
            "IBM"
        ],
        "city": [
            "Zurich"
        ],
        "country": [
            "Switzerland"
        ],
        "target": [
            "Entrepreneurs",
            "Managers",
            "Investors",
            "Professionals",
            "Technicians",
            "Primary school students",
            "Primary school teachers",
            "Secondary school students",
            "Secondary school teachers",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Videos"
        ],
        "id": "6f125914-7027-4e4e-8f25-10c81f2e81c3"
    },
    {
        "title": "Quantum Chess",
        "summary": "Quantum Chess\u00ae is a variant of Chess, which is built on top of unitary dynamics and includes non-trivial quantum effects such as superposition, entanglement, and interference.",
        "description": "<p>Quantum phenomena have remained largely inaccessible to the general public. This can be attributed to the fact that we do not experience quantum mechanics on a tangible level in our daily lives. Games can provide an environment in which people can experience the behavior of the quantum world in a fun and mentally engaging way. Games can also offer an interesting test bed for near term quantum devices because they can be tailored to support varying amounts of quantum behavior through simple rule changes, which can be useful when dealing with limited resources. With the introduction of the \"split\" move, players can place their pieces in superposition on multiple squares at once. To learn more about the math behind the game, see arxiv:1906.05836. This publication explores a Cirq-based implementation of Quantum Chess. In the Concepts module, we introduce concepts such as error mitigation, post-selection, and qubit mapping, without requiring specific domain knowledge. In the Quantum Chess REST API module, you implement a fully functional server, that defines the specific REST endpoints required by the Quantum Chess Engine to offload its quantum state handling to an external resource. A similar server was used in this presentation to run Quantum Chess on Google's Rainbow chip during the Google Quantum AI Summer symposium. &nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Ricardo Olenewa",
                "second": "rolenewa@google.com"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education",
            "Lifelong learning and (re)training",
            "Outreach"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Physics"
        ],
        "org": [
            "Google, Quantum AI"
        ],
        "city": [
            "Munich"
        ],
        "country": [
            "Germany"
        ],
        "target": [
            "Entrepreneurs",
            "Managers",
            "Investors",
            "Professionals",
            "Technicians",
            "Primary school students",
            "Primary school teachers",
            "Secondary school students",
            "Secondary school teachers",
            "BSc students",
            "MSc students",
            "PhD students",
            "Other (specify)"
        ],
        "type": [
            "Games",
            "Teaching material",
            "Other"
        ],
        "id": "5ccce7d5-b107-488f-82e9-c180e01f06bc"
    },
    {
        "title": "Quantenkoffer physics science kit - Introduction",
        "summary": "The Quantenkoffer is a quantum physics science kit for a multitude of experiments from 100 years of quantum optics. The key feature is its flexibility with regard to the generation and detection of visible laser light, single photons, and even entangled pairs. Its optical elements, mechanical components, and digital circuits are integrated in order to cover a range of experiments and topics of quantum physics as wide as possible. This short video shows an introduction to the science kit.",
        "description": "<p>The Quantenkoffer and its modular design offer different approaches. You can choose to follow ideas and well-known experiments from 100 years of quantum physics, or you can use its intuitive software and design experiments from scratch. Here is a list of the prepared experiments you can performe. Single Photon Experiments without Interference: - Particle Nature of Photons - Quantum Cryptography/QKD: BB84 Protocol - Tomographic Single Photon State Reconstruction - Quantum Zeno Effect - Quantum Random Number Generation Single Photon Experiments with Interference - Wave Nature of Photons: Single Photon Michelson Interferometer - Quantum Eraser - Wave-Particle Dualism: Michelson + HBT - Double Michelson Interferometer - Visible (White) Light Interference (Observable by Eye) - Measurement of the Central Wavelength of Single Photons - Measurement of Coherence Length of Single Photons - Interaction-Free Measurement (Bomb Test) Photon Pair Experiments with Polarisation Entanglement - Violation of Bell\u2019s Inequality (CHSH) - \u201cNon-Classical\u201d Polarisation Correlations - Tomographic State Reconstruction of an Entangled Photon State - Quantum Cryptography/QKD: BBM Protocol - Quantum Cryptography: Ekert Protocol - Photon Pair Experiments without Polarisation Entanglement - Hong-Ou-Mandel 2-Photon Interference - Hong-Ou-Mandel Interference + Hanbury Brown &amp; Twiss Franson Interference These are the experiments we have come up with so far and found interesting enough to put them here. Do you have more ideas? Please let us know!</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Nico Klein",
                "second": "education@qutools.com"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education",
            "Outreach"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Physics"
        ],
        "org": [
            "qutools GmbH"
        ],
        "city": [
            "Munich"
        ],
        "country": [
            "Germany"
        ],
        "target": [
            "Primary school teachers",
            "Secondary school students",
            "Secondary school teachers",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Experiments",
            "Videos"
        ],
        "id": "7252adfc-c952-4f26-9989-d2f4ca6ebf77"
    },
    {
        "title": "Structures nucl\u00e9aires",
        "summary": "Through classical physics, we propose a new atomic model, consisting of a set of nuclear structures explaining quantum numbers, chemical links, and physical waves. This theory brings a new vision of quantum, optical, and semi-conduction phenomena.\u00a0It can help innovation in the field of decarbonized energies, optics, and chemistry.",
        "description": "<p>The book presents in an accessible language, the historical evolution of the atomic models. From these elements, the book proposes the construction of a new atomic model by classical physics approach and presents the nuclear structures obtained. The model explains the quantum numbers, chemical links, and physical wave phenomena. This book brings a new vision of atomic, optical, and semiconduction phenomena. It can help innovation in the field of energy, renewable energy, electronics, and chemistry. &nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Antoine Warnery",
                "second": "warneryantoine@free.fr"
            }
        ],
        "level": [
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "French"
        ],
        "topic": [
            "Quantum Physics",
            "Innovation & Entrepreneurship"
        ],
        "org": [
            "WARNERY"
        ],
        "city": [
            "VILLEMER"
        ],
        "country": [
            "France"
        ],
        "target": [
            "Professionals",
            "Technicians",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Book"
        ],
        "id": "3aa739ee-072c-45ef-bedf-d36a09e3266e"
    },
    {
        "title": "Quantenkoffer physics science kit - Michelson interferometer single photons",
        "summary": "The Quantenkoffer is a quantum physics science kit for a multitude of experiments from 100 years of quantum optics.",
        "description": "<p>The Quantenkoffer is a quantum physics science kit for a multitude of experiments from 100 years of quantum optics. The key feature is its flexibility with regard to the generation and detection of visible laser light, single photons, and even entangled pairs. Its optical elements, mechanical components, and digital circuits are integrated in order to cover a range of experiments and topics of quantum physics as wide as possible. This short video shows a Michelson interferometer on the science kit with single photons.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Nico Klein",
                "second": "education@qutools.com"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education",
            "Outreach"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Physics"
        ],
        "org": [
            "qutools GmbH"
        ],
        "city": [
            "Munich"
        ],
        "country": [
            "Germany"
        ],
        "target": [
            "Primary school teachers",
            "Secondary school students",
            "Secondary school teachers",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Experiments",
            "Videos"
        ],
        "id": "cc524c03-3d6d-49a3-a9c0-13329893640b"
    },
    {
        "title": "OpenFermion - library for compiling and analyzing quantum algorithms",
        "summary": "OpenFermion is a library for compiling and analyzing quantum algorithms to simulate fermionic systems, including quantum chemistry.",
        "description": "<p>Among other functionalities, this version features data structures and tools for obtaining and manipulating representations of fermionic and qubit Hamiltonians. The package provides everything from efficient data structures for representing fermionic operators to fermionic circuit primitives for execution on quantum devices. Plugins to OpenFermion provide users with an efficient, and low overhead means of translating electronic structure calculations into quantum circuit calculations. Guide&amp;Tutorials in OpenFermion:</p>\r\n\r\n<ul>\r\n\t<li><a href=\"https://quantumai.google/openfermion/tutorials/intro_to_openfermion?hl=en\">Introduction to OpenFermion</a></li>\r\n\t<li><a href=\"https://quantumai.google/openfermion/tutorials/jordan_wigner_and_bravyi_kitaev_transforms#the_bravyi-kitaev_transform\">The Jordan-Wigner and Bravyi-Kitaev Transforms</a></li>\r\n\t<li><a href=\"https://quantumai.google/openfermion/tutorials/binary_code_transforms\">Lowering qubit requirements using binary codes</a></li>\r\n\t<li><a href=\"https://quantumai.google/openfermion/tutorials/bosonic_operators\">Introduction to the bosonic operators</a></li>\r\n\t<li><a href=\"https://quantumai.google/openfermion/tutorials/circuits_1_basis_change\">Circuits 1: Compiling arbitrary single-particle basis rotations in linear depth</a></li>\r\n\t<li><a href=\"https://quantumai.google/openfermion/tutorials/circuits_2_diagonal_coulomb_trotter\">Circuits 2: Linear Trotter steps of diagonal Coulomb operators</a></li>\r\n\t<li><a href=\"https://quantumai.google/openfermion/tutorials/circuits_3_arbitrary_basis_trotter?hl=en\">Circuits 3: Low rank, arbitrary basis molecular simulations</a></li>\r\n</ul>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Ricardo Olenewa",
                "second": "rolenewa@google.com"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [],
        "org": [
            "Google, Quantum AI"
        ],
        "city": [
            "Munich"
        ],
        "country": [
            "Germany"
        ],
        "target": [
            "Entrepreneurs",
            "Professionals",
            "Technicians",
            "Secondary school students",
            "Secondary school teachers",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Teaching material",
            "Other"
        ],
        "id": "77677553-bf6a-48c0-9894-03904dfea802"
    },
    {
        "title": "TensorFlow Quantum - quantum machine learning library",
        "summary": "TensorFlow Quantum (TFQ) is a quantum machine learning library for rapid prototyping of hybrid quantum-classic.",
        "description": "<p>TensorFlow Quantum (TFQ) is a Python framework for quantum machine learning. As an application framework, TFQ allows quantum algorithm researchers and ML application researchers to leverage Google\u2019s quantum computing frameworks, all from within TensorFlow. Guide&amp;Tutorials in TensorFlow Quantum</p>\r\n\r\n<ul>\r\n\t<li><a href=\"https://www.tensorflow.org/quantum/tutorials/hello_many_worlds\">Hello, many worlds</a></li>\r\n\t<li><a href=\"https://www.tensorflow.org/quantum/tutorials/mnist\">MNIST classification</a></li>\r\n\t<li><a href=\"https://www.tensorflow.org/quantum/tutorials/quantum_data\">Quantum data</a></li>\r\n\t<li><a href=\"https://www.tensorflow.org/quantum/tutorials/gradients\">Calculate gradients</a></li>\r\n\t<li><a href=\"https://www.tensorflow.org/quantum/tutorials/barren_plateaus\">Barren plateaus</a></li>\r\n\t<li><a href=\"https://www.tensorflow.org/quantum/tutorials/qcnn\">Quantum Convolutional Neural Network</a></li>\r\n\t<li><a href=\"https://www.tensorflow.org/quantum/tutorials/research_tools\">Research tools</a></li>\r\n</ul>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Ricardo Olenewa",
                "second": "rolenewa@google.com"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Physics",
            "Quantum Simulation",
            "Quantum Technology",
            "Programming"
        ],
        "org": [
            "Google, Quantum AI"
        ],
        "city": [
            "Munich"
        ],
        "country": [
            "Germany"
        ],
        "target": [
            "Professionals",
            "Technicians",
            "Secondary school students",
            "Secondary school teachers",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Teaching material",
            "Other"
        ],
        "id": "a604a57c-4ec6-484a-86b2-447cf70a1476"
    },
    {
        "title": "Cirq - quantum algorithms and tutorials",
        "summary": "A hands-on tutorial about writing quantum algorithms in Cirq. Cirq is an open-source Python library that enables you to run quantum algorithms on quantum computers and simulators from Google and others.",
        "description": "<p>Cirq is a Python software library for writing, manipulating, and optimizing quantum circuits, and then running them on quantum computers and quantum simulators. Cirq provides useful abstractions for dealing with today\u2019s noisy intermediate-scale quantum computers, where details of the hardware are vital to achieving state-of-the-art results. <strong>Tutorials and examples</strong> Cirq comes with a collection of example implementations of beginner, intermediate, and advanced quantum algorithms that demonstrate the main features of the library.</p>\r\n\r\n<ul>\r\n\t<li><a href=\"https://quantumai.google/cirq/tutorials/educators/intro\">Introduction to Cirq</a></li>\r\n\t<li><a href=\"https://quantumai.google/cirq/tutorials/educators/textbook_algorithms\">Textbook algorithms in Cirq</a></li>\r\n\t<li><a href=\"https://quantumai.google/cirq/tutorials/educators/chemistry\">Quantum simulation of electronic structure</a></li>\r\n\t<li><a href=\"https://quantumai.google/cirq/tutorials/educators/qaoa_ising\">Quantum approximate optimization algorithm for the Ising model</a></li>\r\n\t<li><a href=\"https://quantumai.google/cirq/tutorials/educators/neutral_atom\">Neutral atom device class</a></li>\r\n\t<li><a href=\"https://quantumai.google/cirq/tutorials/educators/ion_device\">Ion Device Class</a></li>\r\n</ul>\r\n\r\n<p><strong>Research Experiments using Cirq</strong> In addition to software for building and testing circuits (Cirq), we have a library of research experiments using Cirq -- ReCirq! This repository contains code for our flagship experiments, enabling you to reproduce and extend cutting edge quantum computing research.</p>\r\n\r\n<ul>\r\n\t<li><a href=\"https://quantumai.google/cirq/experiments/qaoa\">QAOA</a></li>\r\n\t<li><a href=\"https://quantumai.google/cirq/experiments/quantum_chess\">Quantum Chess</a></li>\r\n\t<li><a href=\"https://quantumai.google/cirq/experiments/hfvqe?hl=en\">Hartree-Fock on a superconducting qubit quantum processor</a></li>\r\n\t<li><a href=\"https://quantumai.google/cirq/experiments/fermi_hubbard\">Simulation of spin and charge dynamics in the Fermi-Hubbard model</a></li>\r\n</ul>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Ricardo Olenewa",
                "second": "rolenewa@google.com"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Technology",
            "Business",
            "Innovation & Entrepreneurship",
            "Programming"
        ],
        "org": [
            "Google, Quantum AI"
        ],
        "city": [
            "Munich"
        ],
        "country": [
            "Germany"
        ],
        "target": [
            "Entrepreneurs",
            "Professionals",
            "Technicians",
            "Primary school students",
            "Primary school teachers",
            "Secondary school students",
            "Secondary school teachers",
            "BSc students",
            "MSc students",
            "PhD students",
            "Other (specify)"
        ],
        "type": [
            "Teaching material",
            "Other"
        ],
        "id": "f4c04163-a428-420b-9151-05e63ae1147c"
    },
    {
        "title": "Bronze-Qiskit",
        "summary": "Bronze is QWorld's introductory tutorial on quantum computing and quantum programming created in October 2018. Bronze-Qiskit is the version of Bronze using Qiskit as the quantum programming framework. It was released in February 2021 with the support of IBM Quantum.",
        "description": "<p>Bronze is a collection of Jupyter notebooks, and each notebook has many programming tasks to provide hands-on experiences. We see Bronze as a laboratory where you can learn the basics of quantum computing and quantum programming by doing. Bronze has already been used in more than 50 workshops under QWorld by March 2021. As a pedagogical strategy, we skip using complex numbers to keep the tutorial simpler. The only prerequisite is to know the basics of programming (variables and basic data types, loops, and conditionals). Any previous experience in python will be helpful. If you do not have any such experience, you can check our notebooks on python before starting the tutorial. Bronze also has notebooks on basic math to review your knowledge of the simple arithmetic operations on vectors and matrices.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Abuzer Yakaryilmaz",
                "second": "abuzer.yakaryilmaz@qworld.net"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education",
            "Lifelong learning and (re)training",
            "Outreach"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Programming"
        ],
        "org": [
            "QWorld Association"
        ],
        "city": [
            "Global"
        ],
        "country": [
            "Latvia"
        ],
        "target": [
            "Professionals",
            "Primary school students",
            "Primary school teachers",
            "Secondary school students",
            "Secondary school teachers",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Teaching material",
            "Videos"
        ],
        "id": "052d9390-daf2-4854-a9db-942bd8733695"
    },
    {
        "title": "Quantenkoffer physics science kit - Polarization Entanglement",
        "summary": "The Quantenkoffer is a quantum physics science kit for a multitude of experiments from 100 years of quantum optics. This short video shows the polarization entanglement of photon pairs.",
        "description": "<p>The Quantenkoffer is a quantum physics science kit for a multitude of experiments from 100 years of quantum optics. The key feature is its flexibility with regard to generation and detection of visible laser light, single photons and even entangled pairs. Its optical elements, mechanical components and digital circuits are integrated in order to cover a range of experiments and topics of quantum physics as wide as possible. This short video shows polarization entanglement of photon pairs.<br />\r\n-----------------------------------<br />\r\nOrganization name: qutools GmbH<br />\r\n-----------------------------------<br />\r\nOrganization country: Germany<br />\r\n-----------------------------------<br />\r\nOrganization city: Munich<br />\r\n-----------------------------------</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Nico Klein",
                "second": "education@qutools.com"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education",
            "Outreach"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Physics"
        ],
        "org": [
            "qutools GmbH"
        ],
        "city": [
            "Munich"
        ],
        "country": [
            "Germany"
        ],
        "target": [
            "Primary school teachers",
            "Secondary school students",
            "Secondary school teachers",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Experiments",
            "Videos"
        ],
        "id": "6951d8f3-08c5-461d-ab2d-8f6220b24cd5"
    },
    {
        "title": "Quantum Cryptography Educational Kit",
        "summary": "This presentation explains how the BB84 quantum crypto protocol works and demonstrates an educational setup that allows students to play through all of the BB84 steps (set a polarization state, generate a key, encrypt, send, decrypt, and, finally, how an eavesdropper is detected).",
        "description": "<p>The EDU-QCRY1(/M) Quantum Cryptography Analogy Demonstration Kit contains components to model a data transmission setup using the BB84 encryption protocol. This encryption method allows a sender and receiver to generate an encryption key that only they know and eavesdroppers to be detected. In this analogy experiment, the polarization of transmitted light carries bits of information that are manipulated using half-wave plates and polarizing beamsplitters. The educational lab kit includes the lasers, half-wave plates, polarizing beamsplitters, and detectors required to model the sender (Alice), the receiver (Bob), and the eavesdropper (Eve).</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Jens K\u00fcchenmeister",
                "second": "jkuechenmeister@thorlabs.com"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education",
            "Outreach"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Physics",
            "Teaching"
        ],
        "org": [
            "Thorlabs GmbH"
        ],
        "city": [
            "Munich"
        ],
        "country": [
            "Germany"
        ],
        "target": [
            "Primary school students",
            "Primary school teachers",
            "Secondary school students",
            "Secondary school teachers",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Experiments",
            "Videos"
        ],
        "id": "a7f41764-642c-4bdc-b8b4-12ae15b9eaf2"
    },
    {
        "title": "Quantum Cryptography Educational Kit Teaching Material",
        "summary": "This manual describes the different steps of the BB84 protocol. Numerous graphics are included to help in teaching this exciting topic.",
        "description": "<p>This manual describes how polarization states are prepared, how the key is generated between Alice and Bob, and how Eve's presence is always detected. Numerous graphics are included to help in teaching this exciting topic.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Jens K\u00fcchenmeister",
                "second": "jkuechenmeister@thorlabs.com"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Physics"
        ],
        "org": [
            "Thorlabs GmbH"
        ],
        "city": [
            "Munich"
        ],
        "country": [
            "Germany"
        ],
        "target": [
            "Primary school students",
            "Primary school teachers",
            "Secondary school students",
            "Secondary school teachers",
            "BSc students",
            "MSc students",
            "PhD students",
            "Other (specify)"
        ],
        "type": [
            "Teaching material"
        ],
        "id": "301a15b5-6b41-4f05-b877-753dd9b3b8ec"
    },
    {
        "title": "PhotonLab 3D posters",
        "summary": "We offer posters in a 3d-world so that school students can prepare themselves for a visit at the student's lab \"PhotonLab\". We give an overview of selected experiments that can be performed by the students themselves during their visit.",
        "description": "<p>At the students lab \"PhotonLab\" we present several (analogy) experiments in Quantum Physics as quantum cryptography, bomb tester, Quantum eraser and Quantum Random Number Generation. These can be performed by the students themselves. Before the visit, the school students should choose one experiment and prepare for it. To make this more motivating for the students we placed posters in a 3d-world where they can walk around and get a better overview.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [],
        "topic": [],
        "org": [
            "Max-Planck-Institute of Quantum Optics"
        ],
        "city": [
            "Garching"
        ],
        "country": [
            "Germany"
        ],
        "target": [
            "Primary school students",
            "Primary school teachers",
            "Secondary school students",
            "Secondary school teachers"
        ],
        "type": [
            "Posters"
        ],
        "id": "1655a68f-e2e5-4bbb-add5-8ef4d065a24d"
    },
    {
        "title": "Playing with a Quantum Computer: teaching approach",
        "summary": "We show a direct and straightforward way to use quantum computers in an introductory course on quantum physics. We use an algorithm that solves a simple and easily understandable problem while providing a quantum advantage. The algorithm we propose is a simple game (Quantum Penny Flip) in which the use of quantum physics offers a winning advantage.",
        "description": "<p>The high public attention given to quantum computing shows that it is perceived as an interesting topic. We want to utilize this motivating effect for the teaching and learning of quantum physics. Specifically, we want to take advantage of the access to real quantum computers, which various providers make available free of charge. We show a direct and straightforward way to use quantum computers in an introductory course on quantum physics. We use an algorithm that solves a simple and easily understandable problem while providing a quantum advantage. The algorithm we propose is a simple game in which the use of quantum physics offers a winning advantage. The game is called Quantum Penny Flip and was proposed by David A. Meyer back in 1999. It can be easily reformulated to be described by quantum gates. We can therefore use it to teach the programming of a quantum computer. We demonstrate its implementation in IBM's Quantum Composer. Additional contact information: Franziska Greinert f.greinert@tu-bs.de</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Rainer M\u00fcller",
                "second": "rainer.mueller@tu-bs.de"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Physics"
        ],
        "org": [
            "Braunschweig Technical University"
        ],
        "city": [
            "Braunschweig"
        ],
        "country": [
            "Germany"
        ],
        "target": [
            "Primary school students",
            "Primary school teachers",
            "Secondary school students",
            "Secondary school teachers",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Games",
            "Publication",
            "Teaching material"
        ],
        "id": "cac3e3a6-bc96-4cf9-a026-d4cda5e9b3f0"
    },
    {
        "title": "Quantum digital-experiment kit (Photoeffect)",
        "summary": "This set of videos covers one of the typical experiments in high school regarding quantum physics, the photoeffect. With this approach we offer the user a different way, closer to research, to understand the experiments around the concept of the photoeffect.",
        "description": "<p>The quantum digital-experiment kit is a concept developed to offer a different approach to learn about the main experiments in quantum physics. Usually text books and digital material offer a historic perspective of the experiments where the results of those are presented without giving the learner the opportunity to create his or her own hypothesis. With this series of videos we show in many steps different aspects of a particular experiment and through interactive questions and animations, we encourage the learner to question and imagine possible answers to physics situations.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Alda Arias",
                "second": "aldaariass@gmail.com"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "German"
        ],
        "topic": [
            "Quantum Physics"
        ],
        "org": [
            "Heidelberg School of education"
        ],
        "city": [
            "Heidelberg"
        ],
        "country": [
            "Germany"
        ],
        "target": [
            "Secondary school students",
            "Secondary school teachers"
        ],
        "type": [
            "Experiments",
            "Videos"
        ],
        "id": "59e2a8de-f085-44dc-9107-ddd10f3612d1"
    },
    {
        "title": "Warsaw Quantum Computing Group meetups",
        "summary": "Warsaw Quantum Computing Group (WQCG) is a series of meetups for quantum computing enthusiasts in Warsaw. Its goal is to facilitate the education and collaboration of people interested in quantum computing. Recordings of the lectures are available on our YouTube channel.",
        "description": "<p>WQCG meetings are organized several times per year (approximately once per month), usually on Mondays at 6 pm CET. Each meeting consists of a lecture given by a quantum computing specialist (it usually takes about 60 minutes) followed by a Q&amp;A session. Some of the lectures are followed by an afterparty during which the participants can interact and exchange their ideas. We record most of the lectures and make them available on our YouTube channel: https://www.youtube.com/channel/UCoQAyPU5KQEpMOMDUN0j3IQ/videos.<br />\r\n&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Pawe\u0142 Gora",
                "second": "warsaw.quantum@gmail.com"
            }
        ],
        "level": [
            "Outreach"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Teaching"
        ],
        "org": [
            "Quantum AI Foundation"
        ],
        "city": [
            "Warsaw"
        ],
        "country": [
            "Poland"
        ],
        "target": [],
        "type": [
            "Teaching material",
            "Videos"
        ],
        "id": "74934d9f-6a9b-4f4c-8083-1dea6ecd5b8a"
    },
    {
        "title": "Teaching Science in Today\u2019s Society: The Case of Particle Physics for Primary Schools",
        "summary": "This paper contributes to the discussion on the need to strengthen the connection between the outreach activities of universities and research institutes and the activities of educational institutions. It reports on an ongoing project aimed to teach Particle Physics in primary schools.",
        "description": "<p>The rapid changes in science and technology witnessed in recent decades have significantly contributed to the arousal of the awareness by decision-makers and the public as a whole of the need to strengthen the connection between outreach activities of universities and research institutes and the activities of educational institutions, with a central role played by schools. While the relevance of the problem is nowadays unquestioned, no unique and fully satisfactory solution has been identified. In the present paper, we would like to contribute to the discussion on the subject by reporting on an ongoing project aimed to teach Particle Physics in primary schools. We will start from the past and currently planned activities in this project in order to establish a broader framework to describe the conditions for the fruitful interplay between researchers and teachers. We will also emphasize some aspects related to the dissemination of outreach materials by research institutions, in order to promote the access and distribution of scientific information in a way suited to the different ages of the target students. This paper is an extended version from the proceeding paper: Cristina Lazzeroni. Particle Physics for Primary Schools\u2014Enthusing Children to Modern Science. In Proceedings of the 1st Electronic Conference on Universe: online, 22\u201328 February 2021. Quantum Field Theories, High Energy Physics, Compact Objects, General Relativity and Gravitation, Black Holes, Dark Matter and Dark Energy, Deep Space Probes https://ecu2021.sciforum.net Special Issue \"Selected Papers from the 1st International Electronic Conference on Universe (ECU 2021)\" https://www.mdpi.com/journal/universe/special_issues/ecu2021 https://www.mdpi.com/2218-1997/7/6/169</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Cristina Lazzeroni",
                "second": "c.lazzeroni@bham.ac.uk"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Physics",
            "Quantum Technology",
            "Teaching"
        ],
        "org": [
            "University of Birmingham"
        ],
        "city": [
            "Birmingham"
        ],
        "country": [
            "United Kingdom"
        ],
        "target": [
            "Primary school students",
            "Primary school teachers"
        ],
        "type": [
            "Presentations",
            "Publication",
            "Teaching material"
        ],
        "id": "733c3572-5bf1-416b-9886-0a13b3b1a665"
    },
    {
        "title": "Teaching quantum mechanics at the secondary level",
        "summary": "PhD thesis into teaching QM at the secondary, consisting of a review study, an investigation of experts opinions on teaching QM at the secondary level, research into students' difficulties while learning about the infinite 1D potential well and tunneling, and an investigation of the influence of increased understanding of potential energy in classical contexts on the understanding of the 1D potential well and tunneling.",
        "description": "<p>Abstract: Quantum mechanics (QM) plays an important role in current technological developments and scientific research. Therefore, QM has become part of the secondary schools curriculum in several countries. However, there has been little research into secondary school students\u2019 understanding of quantum mechanics. In this thesis we present the results of an investigation into how QM can be successfully introduced at the secondary school level. We first conducted a literature review to investigate the current state of research on secondary school students\u2019 understanding of QM. Results showed that students have difficulty relating QM to physical reality and that there is a need to investigate students\u2019 difficulties concerning wave functions and potential wells. Additionally, this study showed there is a need for the development of assessment tools for secondary education Secondly, a Delphi study was conducted in order to explore what topics of QM Dutch experts consider important to teach at secondary schools and why. The results showed that there was a moderate to strong consensus on the topics that are considered to be important, i.e. duality, wave functions, and atoms. Interviews showed that the experts\u2019 opinions were based mainly on the idea that students should have a certain understanding of important scientific concepts. Topics that were considered too complex or abstract were viewed as less essential. In the third study, we researched Dutch students\u2019 misunderstandings after they learned quantum mechanics. Quantitative analysis of a concept test showed that Dutch secondary school students experience the same difficulties that were reported for undergraduate students. A qualitative analysis of open-ended questions and interviews showed that Dutch students have difficulty connecting knowledge of the 1D infinite potential well and tunneling to their prior knowledge. Finally, we investigated the influence of prior knowledge of potential energy on students\u2019 understanding of QM in a quasi-experimental study. Results showed that the experimental group not only had a better understanding of potential energy but also of QM even before they were being taught QM. The analysis also showed that there was a significant correlation between the understanding of potential energy diagrams and the understanding of quantum mechanics.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Kim Krijtenburg-Lewerissa",
                "second": "k.krijtenburg-lewerissa@uu.nl"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Outreach"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Physics",
            "Teaching"
        ],
        "org": [
            "University of Twente"
        ],
        "city": [
            "Enschede"
        ],
        "country": [
            "The Netherlands"
        ],
        "target": [
            "Secondary school teachers"
        ],
        "type": [
            "Publication"
        ],
        "id": "b1806e6f-70af-4dbc-a6eb-4f2265067047"
    },
    {
        "title": "Acting as a quantum: what can I do that a single photon can't?",
        "summary": "1-hour hands-on, role-play activity for the general public. Let's act as if we were photons! We are going to cross an interferometer where the paths split and then cross again. In this role play, we will see if there are really differences between how we and photons can do it. Probably you wanna ask who are these photons? Play and discover!",
        "description": "<p>Participants will first play a learning game using the online platform Kahoot! Afterward, they will go through the setup - pass through the symbolic doors and get reflected from the symbolic mirrors. They will play two main scenes: how a non-quantum object would pass the interferometer, and how a quantum object would pass it. In the second scene about the quantum object participants will act as a probability amplitude of the quantum object in groups of four people using a simple tool made from transparent paper. They will observe what happens and discuss it with each other. We will brainstorm altogether how one could potentially use this quantum phenomenon causing that photons (as well atoms in fact) always exit the interferometer from the same side, which is called quantum interference. The key quantum concept discussed here is a quantum superposition. This game reproduces at human scale a Mach-Zehnder-Interferometer - a setup used in a real physical experiment about the single-photon interference described in this article https://iopscience.iop.org/article/10.1209/0295-5075/1/4/004 . The symbolic setup is rather simple to build: you need two symbolic doors (at 45-degree angle relative to the pathways) that one can enter that will represent two beamsplitters, and two symbolic walls representing the mirrors. The first door will give two options: go through straight or go through with a 90-degree turn, thus two possible paths will appear. Using the walls these paths will be directed such that they will cross while entering the second door from two different directions. Participants will first choose freely whether to cross straight or to turn 90 degrees at each door and we will count how many will end up on each of the two exits of the interferometer. This will represent the non-quantum case as if the rules of quantum physics do not apply. To show what happens when a quantum object goes through the same setup four participants will have to use a special tool I made representing a probability amplitude of a quantum object and discover how paradoxically the photon always exits from the same side of the interferometer. The tool consists of four transparent papers with the same drawing of a photon attached to the transparent reference sheet. The drawing should be rotated clockwise every time the person turns on the interferometer. The group of 4 people always split equally as each door, half going straight and half making a turn. At the exit, the drawings should be superposed and it will result in a black picture in one exit (no photon) and a drawing of a photon in the other exit (yes photon), if there was no disturbance on the way ;) This hands-on activity was proposed four times to the general public at a mini-maker fair in Trieste in 2018. 10-15 people took part in each game. Please don't hesitate to contact Oxana Mishina for more details.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Oxana Mishina",
                "second": "omishina@gmail.com"
            }
        ],
        "level": [
            "Outreach"
        ],
        "lang": [
            "English",
            "Italian"
        ],
        "topic": [],
        "org": [
            "National Institute of Optics (CNR-INO)"
        ],
        "city": [
            "Trieste"
        ],
        "country": [
            "Italy"
        ],
        "target": [],
        "type": [
            "Games",
            "Experiments",
            "Other"
        ],
        "id": "0b02521e-a48d-4436-8759-ecc79cc5f538"
    },
    {
        "title": "LearnQM",
        "summary": "LearnQM is a website that hosts digital games and interactive visualizations for learning quantum and semiconductor physics. It currently hosts three digital artifacts: Particle in a Box, Psi and Delta, and Semiconductor Visualizations. The website was developed by an interdisciplinary team of researchers at Georgia Institute of Technology.",
        "description": "<p>Quantum Mechanics (QM) is the foundation for science and engineering disciplines as diverse as semiconductor physics, chemistry, and material science. However, educators face major challenges in teaching QM given the abstract, non-experiential, and counter-intuitive nature of its concepts. Further, introductory quantum mechanics courses and texts predominantly focus on the mathematical formulations of the subject and lay less emphasis on its conceptual understanding. As a result students often struggle to develop robust conceptual mental models of QM concepts. We are exploring supporting material such as interactive visualizations and games for teaching and learning quantum mechanics. Digital artifacts such as these have the potential to facilitate the experiential and conceptual learning of QM. They can immerse their audience in fantasy worlds unlike those experienced in a reality where players can observe, experiment with, and get \"used to\" new rules and different phenomena. Further, the inherently repetitive nature of games is conducive to learning complex concepts such as probability. Check out our digital artifacts at learnqm.gatech.edu!<br />\r\n&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Aditya Anupam",
                "second": "aanupam3@gatech.edu"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education",
            "Outreach"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Physics",
            "Quantum Technology"
        ],
        "org": [
            "Georgia Institute of Technology"
        ],
        "city": [],
        "country": [
            "United States"
        ],
        "target": [
            "Primary school students",
            "Primary school teachers",
            "Secondary school students",
            "Secondary school teachers",
            "BSc students",
            "MSc students",
            "PhD students",
            "Other (specify)"
        ],
        "type": [
            "Games"
        ],
        "id": "94b85e84-0008-409e-8e89-ce09a74ab893"
    },
    {
        "title": "Learning quantum concepts with quantum cryptography",
        "summary": "A teaching unit was developed with the goal to contribute to general education in quantum physics with the fascinating example of quantum cryptography.  This teaching unit does not require prerequisites and is suitable for high school students. It uses simulations, worksheets and own activities of students. Also school teachers can use it as an introduction into this field.",
        "description": "<p>The goal of the teaching unit is to bring together the aspects of mathematics, quantum physics and their application in quantum cryptography. The interlinking should contribute to an understanding of the quantum concepts superposition, measuring process and uncertainty in a deep and natural way. Polarization is used as a suitable model system. This is useful for understanding the q-bit as smallest unit in quantum information. Students learn that any given quantum state can be represented with respect to different bases of the vector space. The measuring process is explained and applied for generating a perfect random sequence. They learn that uncertainty is important for securing the protocol (BB84 protocol).<br />\r\n-----------------------------------<br />\r\nOrganization name: TU Dresden<br />\r\n-----------------------------------<br />\r\nOrganization country: Germany<br />\r\n-----------------------------------<br />\r\nOrganization city:<br />\r\n-----------------------------------</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Gesche Pospiech",
                "second": "gesche.pospiech@tu-dresden.de"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "German"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Information",
            "Quantum Physics",
            "Quantum Technology"
        ],
        "org": [
            "TU Dresden"
        ],
        "city": [],
        "country": [
            "Germany"
        ],
        "target": [
            "Primary school students",
            "Primary school teachers",
            "Secondary school students",
            "Secondary school teachers"
        ],
        "type": [
            "Simulations",
            "Teaching material"
        ],
        "id": "05a6c107-d28c-4f45-b153-a6800e1916f2"
    },
    {
        "title": "Entangle me!",
        "summary": "We present a game where students take the role of quantum particles and scientists. They experience the rules of quantum mechanics first hand, and discover entanglement and decoherence in a playful way.",
        "description": "<p>We introduce a game to illustrate the principles of quantum mechanics using a qubit (or spin-first) approach, where students can experience and discover its puzzling features first-hand. Students take the role of particles and scientists. Scientists unravel underlying rules and properties by collecting and analysing data that is generated by observing particles that act according to given rules. We show how this allows one to illustrate quantum states, their stochastic behavior under measurements as well as quantum entanglement. In addition, we use this approach to illustrate and discuss decoherence, and a modern application of quantum features, namely quantum cryptography. We have tested the game in class and reported on the results we obtained.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Wolfgang D\u00fcr",
                "second": "wolfgang.duer@uibk.ac.at"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Outreach"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Physics"
        ],
        "org": [
            "University of Innsbruck"
        ],
        "city": [
            "Innsbruck"
        ],
        "country": [
            "Austria"
        ],
        "target": [
            "Primary school students",
            "Primary school teachers",
            "Secondary school students",
            "Secondary school teachers"
        ],
        "type": [
            "Games",
            "Publication"
        ],
        "id": "5b4fc63a-a076-4f36-91a7-2232a219bb4a"
    },
    {
        "title": "Quantum cartoons",
        "summary": "Humorous interpretations of quantum physics.",
        "description": "<p>Cartoons and animations (in Danish) developed as part of a project investigating alternative ways to stimulate interest about quantum physics in Danish highschool classes. The material is meant as an icebreaker or a funny little intermezzo during a lecture. The hypothesis behind is that laughter and creation of a joyful teaching environment leads to increased learning and knowledge retention.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Ulrich Busk Hoff",
                "second": "ulrich.hoff@fysik.dtu.dk"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "Danish"
        ],
        "topic": [
            "Quantum Physics"
        ],
        "org": [
            "Technical University of Denmark"
        ],
        "city": [
            "Copenhagen"
        ],
        "country": [
            "Denmark"
        ],
        "target": [
            "Primary school students",
            "Primary school teachers",
            "Secondary school students",
            "Secondary school teachers"
        ],
        "type": [
            "Illustrations"
        ],
        "id": "55ccca51-cb35-4004-b51a-53c4a67f2e8a"
    },
    {
        "title": "Interactive Quantum Physics",
        "summary": "In our 360\u00b0 picture of the PhotonLab, you will find several interactive books, explaining our (analogy) quantum experiments to school students. We guide you with nice animations, videos, and quizzes. Learn more about our quantum random number generator, quantum eraser, quantum cryptography, bomb tester and interferometer.",
        "description": "<p>We designed several interactive books in h5p for use with the concept of the flipped classroom. We used very motivating components such as animations, quizzes, and videos. Some of the interactive books give a basic introduction to selected quantum physics experiments such as quantum cryptography, quantum random number generation, bomb tester, and quantum eraser. The books start with a motivating part, then they introduce the basic concepts of quantum physics that are needed for the selected experiment and continue with the experiment itself. They finish with a research question that ideally has to be answered in the lab. We also offer silent videos, which are videos that explain the experiment - but the sound is removed. The task for the students is to add their own oral descriptions to the experiment. This can be reviewed by their teacher.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Silke St\u00e4hler-Sch\u00f6pf",
                "second": "staehler-schoepf@mpq.mpg.de"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "German"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Information",
            "Quantum Metrology",
            "Quantum Physics"
        ],
        "org": [
            "Max-Planck-Institut f\u00fcr Quantenoptik"
        ],
        "city": [
            "Garching bei M\u00fcnchen"
        ],
        "country": [
            "Germany"
        ],
        "target": [
            "Primary school students",
            "Primary school teachers",
            "Secondary school students",
            "Secondary school teachers"
        ],
        "type": [
            "Book",
            "Experiments",
            "Illustrations",
            "Posters",
            "Presentations",
            "Videos",
            "Other"
        ],
        "id": "8a0875e7-a29d-47da-b069-37e32824bc43"
    },
    {
        "title": "Quantum Jumps",
        "summary": "Quantum Jumps is a professional development program for high school physics and maths in-service teachers. Using an informational approach related to the exploration of quantum technologies, we aim to help teachers support their students in the transition from classical to the quantum world.",
        "description": "<p>Quantum Jumps wants to offer teachers resources that can be used for designing teaching activities. We want to offer some of the \"ingredients\" that we think might be useful to teachers in creating materials to be used within regular school activities. The resources have been built up for the design of teaching activities that meet the objectives (\u201cspecific scientific competences\u201d) set out in the Physics Study Plan for Italian scientific high schools [DPR 89 15/03/2010] and the Reference Framework for the Second Physics Test [DM 769 26/11/2018]. These objectives (expressed as learning outcomes) are as follows: (a) To be able to show, by referring to specific experiments, the limits of the classical paradigm of explanation and interpretation of phenomena and to be able to argue the need for a quantum vision b) To know how to recognise the role of quantum physics in real situations and in technological applications. Using a mathematical formalism linked to the content of the mathematics curriculum, it is possible to rigorously analyse experiments relating to electronic spin states and the polarisation of single photons. This activity makes it possible to introduce the concept of qubits, which provides an interpretative key to understanding the behaviour of quantum objects and to derive the key to understanding the principles underlying quantum technologies. In this context, quantum technologies have been used as a context to explore the tenets of quantum theory.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "Italian"
        ],
        "topic": [
            "Quantum Physics",
            "Quantum Technology",
            "Teaching"
        ],
        "org": [
            "Department of Science and High Technology, University of Insubria"
        ],
        "city": [
            "Como"
        ],
        "country": [
            "Italy"
        ],
        "target": [
            "Secondary school students",
            "Secondary school teachers"
        ],
        "type": [
            "Platform",
            "Presentations",
            "Teaching material"
        ],
        "id": "efa2129b-0e4b-4f7f-95c4-0efbf0bde51c"
    },
    {
        "title": "Quantum technologies - Course for teachers - Materials",
        "summary": "",
        "description": "<p>Materials for the professional training course on quantum technologies for &nbsp;high school physics teachers offered in 2020/21 and 2021/22 by the Department of Physics at the University of &nbsp;Pavia.</p>\r\n\r\n<p>The purpose of the course is to enhance physics teachers\u2019 knowledge and awareness of topics related to quantum computation and quantum information, and of their relevance for technological advancement. Besides their objective importance, also stressed by several authors and projects, the choice of topics not traditionally covered in the final year physics curricula also arises from the concrete possibility of developing a multidisciplinary path, able to represent under a unified perspective several subjects treated in secondary school physics and mathematics.<br />\r\nThe materials for the course were developed in the context of the Italian PLS (Plan for Science Degrees) and in collaboration with the education section of the Quantum Flagship.<br />\r\nThe materials are meant to complement an educational path lasting about 30 hours and are structured according to the following steps:</p>\r\n\r\n<ol>\r\n\t<li>introduction to physics problem of classical computation;</li>\r\n\t<li>building the quantum logic language and the origin of quantum algorithms;</li>\r\n\t<li>introduction to entanglement and development of quantum protocols.</li>\r\n</ol>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Massimiliano Malgieri",
                "second": "massimiliano.malgieri@unipv.it"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "Italian"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Information",
            "Teaching"
        ],
        "org": [
            "University of Pavia"
        ],
        "city": [
            "Pavia"
        ],
        "country": [
            "Italy"
        ],
        "target": [
            "Secondary school teachers"
        ],
        "type": [
            "Presentations"
        ],
        "id": "8d297f09-9be2-4897-bc2b-8538873db971"
    },
    {
        "title": "bits and qbits",
        "summary": "Professor Jan Philip Solovej explaines how quantum mechanics can be used in a game using GHZ states. This video is completed with teaching material introducing the mathematics.",
        "description": "<p>Professor Jan Philip Solovej explaines how quantum mechanics can be used in a game using GHZ states. This video is completed with teaching material introducing the mathematics.</p>\r\n\r\n<p>The material is part of a larger project where professional mathematicians presents a topic with teaching materials and a video.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Mads Peter",
                "second": "mps@rysensteen.dk"
            }
        ],
        "level": [
            "Outreach"
        ],
        "lang": [
            "Danish"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Physics",
            "Quantum Technology"
        ],
        "org": [
            "HEM"
        ],
        "city": [
            "Copenhagen"
        ],
        "country": [
            "Denmark"
        ],
        "target": [],
        "type": [
            "Teaching material",
            "Videos"
        ],
        "id": "08b7b906-1da6-4bf1-baaa-c742b039c96b"
    },
    {
        "title": "European Quantum week 2020: slides and recordings",
        "summary": "A sample presentation on the Second Quantum revolution realized by QTEdu CSA in occasion of the European Quantum Week in 2020",
        "description": "<p><span><span><span><span><span><span>After the cancellation of many scientific meetings and events during the course of 2020, QFlag organized a hybrid digital event called <strong>European Quantum Week (EQW)</strong> to present the latest achievements of the Quantum Flagship and news from the European Commission to the community.&nbsp;</span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span>The EQW took place virtually from November 2</span></span></span></span></span></span><span><span><span><span><span><span><sup>nd</sup></span></span></span></span></span></span><span><span><span><span><span><span> to November 6</span></span></span></span></span></span><span><span><span><span><span><span><sup>th</sup></span></span></span></span></span></span><span><span><span><span><span><span> (</span></span></span></span></span></span><a href=\"https://eqw.qt.eu/\"><span><span><span><span><span><u><span><span>https://eqw.qt.eu/</span></span></u></span></span></span></span></span></a><span><span><span><span><span><span>). </span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span>QTEdu team took care to share with the EQW community a Second Quantum revolution introductory sample presentation. It was designed as starting point for speakers and educators involved in local events. The presentation is now available here.</span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span>In addition, recordings of the online live sessions are available on the </span></span></span></span></span></span><a href=\"https://www.youtube.com/watch?v=-gUc-xrq0qg&amp;list=PL52eYZ21uXgaAqLQALXxtoQY-caFDBasK\"><span><span><span><span><span><u><span><span>Quantum Flagship YouTube channel</span></span></u></span></span></span></span></span></a>.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Oxana Mishina",
                "second": "info.qtedu@qtedu.eu"
            }
        ],
        "level": [
            "Outreach"
        ],
        "lang": [
            "English",
            "Spanish",
            "Italian",
            "Danish",
            "French",
            "Finnish",
            "Turkish",
            "Slovene",
            "Hebrew",
            "Croatian",
            "Romanian",
            "Hungarian",
            "Maltese",
            "Lithuanian",
            "Swedish"
        ],
        "topic": [
            "Quantum Physics",
            "Quantum Technology",
            "Innovation & Entrepreneurship",
            "Teaching"
        ],
        "org": [
            "QTEdu CSA, QFlag"
        ],
        "city": [],
        "country": [],
        "target": [
            "Secondary school students",
            "Secondary school teachers"
        ],
        "type": [
            "Presentations",
            "Teaching material",
            "Videos"
        ],
        "id": "7ed52ba4-4e89-468e-af08-ee8608f4729b"
    },
    {
        "title": "Quantum Game Caf\u00e9",
        "summary": "Learn about quantum by playing games while having a drink in a cosy atmospher of a lovely caf\u00e8? Yes, this is possible in a Quantum game Caf\u00e8! Physics scientists and students would welcome the enthusiasts to learn and introduce table and computer games all inspires by principleas of quantum physics.",
        "description": "<p><em>The Quantum Game Caf\u00e8 inspired by a project realized for the first time by&nbsp;<a href=\"https://www.scienceathome.org/community/blog/quantum-game-cafe/\">\u00c5rhus&nbsp;Univerity&nbsp;in Denmark</a>&nbsp;and we reproduced it in Trieste for the forst time in 2019, in occasion of proESOF events when Trieste was the european the city of science. Next event was in April&nbsp; 2022 in occasion of the <a href=\"https://www.quantumweeks.it/trieste/#marzo31\">Italian quantum Weeks 2022 @ Trieste</a>&nbsp;as sinergetic action within the <a href=\"https://qtedu.eu/project/quantum-technologies-education-everyone\">pilot&nbsp; project QuTE4E</a>. The location is typically a nice caf\u00e8 in the city and it lasts 4-5 evenings.&nbsp;</em></p>\r\n\r\n<p><em>Students and scientists who keep on sharing their knowledge with the public were involved in preparation of the event. It is a special occasion because all is made while playing different tables and computer games inspired by the principles of quantum physics (for example -&nbsp;<a href=\"https://www.scienceathome.org/games/quantum-moves-2/\">Quantum moves 2</a>) and having a drink in a relaxing ambiance. <a href=\"https://twitter.com/shaeema_zaman\">Shaeema Zanam</a>&nbsp;was our guest from Denmark to guide the enthusiasts throught the quantum moves 2.</em></p>\r\n\r\n<p>&nbsp;</p>\r\n\r\n<p><em>Following games were present:</em></p>\r\n\r\n<ul>\r\n\t<li><a href=\"http://quantumrace.blogspot.com/\">Quantum Race</a></li>\r\n\t<li><em><a href=\"https://www.scienceathome.org/games/quantum-moves-2/\">Quantum moves 2</a></em></li>\r\n\t<li><a href=\"https://www.kickstarter.com/projects/1950856204/dead-cat-a-quantum-physics-card-game\"><em>Dead cat</em></a></li>\r\n\t<li>...</li>\r\n\t<li><em>see the <a href=\"https://docs.google.com/spreadsheets/d/1lb1N2Nx4ffLJqkxPRX352D0HoSVZbpRSEFFhLyvy6vo/edit?usp=sharing\">full list</a></em></li>\r\n</ul>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Oxana Mishina",
                "second": "omishina@gmail.com"
            }
        ],
        "level": [
            "Outreach"
        ],
        "lang": [
            "English",
            "Italian"
        ],
        "topic": [
            "Quantum Physics",
            "Quantum Technology"
        ],
        "org": [
            "CNR-INO"
        ],
        "city": [
            "Trieste"
        ],
        "country": [
            "Italy"
        ],
        "target": [],
        "type": [
            "Games",
            "Videos"
        ],
        "id": "b1a89f0b-e92f-4cf3-9573-b3dd5485bf12"
    },
    {
        "title": "quantum@School: Racconti di Tecnologia Quantistica",
        "summary": "National conference for the high school students within Italian Quantum Weeks 2022. ",
        "description": "<p>Five passionate scientists guide you in the world of quantum technologies alongside their personal career paths.</p>\r\n\r\n<p>Speakers:<br />\r\n. Maja Colautti - CNR-INO, Firenze - <a href=\"http://www.quantumnanophotonics-lab.it/\">LAB website</a><br />\r\n. Ilaria Gianani - Universit\u00e0 degli Studi di Roma Tre, Roma - <a href=\"https://twitter.com/neqogroup\">LAB twitter</a><br />\r\n. Francesco Vedovato, Universita' degli Studi di Padova, Padova - <a href=\"https://quantumfuture.dei.unipd.it/\">LAB website</a><br />\r\n. Filippo Cardano - Universit\u00e0 degli Studi di Napoli Federico II, Napoli -&nbsp;<a href=\"https://www.docenti.unina.it/#!/professor/46494c4950504f43415244414e4f43524446505038384330364638333952/riferimenti\">Personal page</a><br />\r\n. Iris Paparelle- CNR-INO, Trieste - <a href=\"https://www.ino.cnr.it/?p=16121&amp;lang=it\">LAB page</a></p>\r\n\r\n<p>Moderator:<br />\r\nOxana Mishina- CNR-INO, Trieste - <a href=\"https://qtedu.eu/\">Project page</a></p>\r\n\r\n<p>Discover other events of the <a href=\"https://www.quantumweeks.it\">Italian Quantum Weeks 2022</a></p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Oxana Mishina",
                "second": "info@quantumweeks.it"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Outreach"
        ],
        "lang": [
            "Italian"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Quantum Metrology",
            "Quantum Physics",
            "Quantum Simulation",
            "Quantum Technology"
        ],
        "org": [
            "Italian Quantum Weeks"
        ],
        "city": [],
        "country": [
            "Italy"
        ],
        "target": [
            "Primary school students",
            "Primary school teachers",
            "Secondary school students",
            "Secondary school teachers"
        ],
        "type": [
            "Videos"
        ],
        "id": "cd4c45a7-d06c-4d59-ab58-a2c22e7e1009"
    },
    {
        "title": "Competence Framework for Quantum Technologies",
        "summary": "The European Competence Framework for Quantum Technologies aims to map the landscape of possible competences and skills in Quantum Technologies. It has been compiled by the QTEdu CSA in order to facilitate the planning and design of education and training projects in Quantum Technologies.",
        "description": "<p>In a bottom-up approach we conducted a three-round Delphi study with many participants from the QT community between summer 2020 and spring 2021. The results were refined by conducting expert interviews for each subfield. Details can be found the the methodology report <a href=\"https://www.doi.org/10.2759/130432\">doi.org/10.2759/130432.</a></p>\r\n\r\n<p>An application are the<span><span><span><span><span><span> <a href=\"https://qtedu.eu/qualification-profiles-quantum-technologies\">qualification profiles</a>. They provide examples of the competences an individual has acquired through education or further training in preparation for employment in industry. They are not meant to represent specific job profiles in a particular industry position \u2013 any such description would have to be much more specific. Instead, they describe the competences available through education which can best prepare an individual for a job in industry.</span></span></span></span></span></span></p>\r\n\r\n<p>Quantum Technologies are rapidly evolving. New technologies will be developed, others will become less important. The Competence Framework will have to be adapted accordingly. Thus, the Competence Framework is a living document which will be updated in regular intervals. Suggestions for additions and corrections are welcome at any time.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Rainer M\u00fcller",
                "second": "f.greinert@tu-braunschweig.de"
            }
        ],
        "level": [
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Quantum Metrology",
            "Quantum Physics",
            "Quantum Sensing",
            "Quantum Simulation",
            "Quantum Technology",
            "Business",
            "Engineering",
            "Innovation & Entrepreneurship",
            "Programming",
            "Soft Skills"
        ],
        "org": [
            "TU Braunschweig"
        ],
        "city": [
            "Braunschweig"
        ],
        "country": [
            "Germany"
        ],
        "target": [
            "Entrepreneurs",
            "Managers",
            "Investors",
            "Professionals",
            "Technicians",
            "Other (specify)",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Publication",
            "Report",
            "Other"
        ],
        "id": "65a1a6b7-c038-4ffc-93fa-4584820a79e0"
    },
    {
        "title": "QuExplained (German) - Quantum computing for secondary schools",
        "summary": "In project QuExplained materials for teaching and self-learning about quantum computing were developed for older pupils in secondary schools.\u00a0Special care was taken to ensure that the material appeals to learners of all genders by avoiding male STEM-stereotypes.\u00a0",
        "description": "<p>Im Projekt QuExplained wurden Materialien zum Lehren und Lernen von Quatencomputertechnologie in der Oberstufe entwickelt. Die Materialien sind gendersensibel gestaltet.&nbsp;</p>\r\n\r\n<p>Das Projekt wurde gef\u00f6rdert durch das Bundesministerium f\u00fcr Bildung und Forschung, F\u00f6rderkennzeichen 13N15413.&nbsp;</p>\r\n\r\n<p>This project was funded by the German Minstry of Education and Research (F\u00f6rderkennzeichen 13N15413).&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Katharina Simbeck",
                "second": "simbeck@htw-berlin.de"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "German"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Simulation",
            "Quantum Technology"
        ],
        "org": [
            "HTW Berlin"
        ],
        "city": [
            "Berlin"
        ],
        "country": [
            "Germany"
        ],
        "target": [
            "Secondary school students",
            "Secondary school teachers"
        ],
        "type": [
            "Teaching material",
            "Videos"
        ],
        "id": "80631124-4a39-45b9-a64c-c5ec251e31da"
    },
    {
        "title": "Quantum computing educational instrument with 2 qubits based on Diamond N-V center",
        "summary": "CIQTEK is originated from University of Science&Technology of China. We commercialized the world first quantum computing educational instrument<Diamond I> with 2 Qubits based on diamond nitrogen-vacancy color center .",
        "description": "<p>&nbsp;</p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span><span>&lt;Diamond I&gt; Featured functions &amp; aims:</span></span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span><span>1.<strong>Continuous wave experiment;</strong>&nbsp;</span></span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span><span>2.<strong>Rabi oscillation experiment;</strong></span></span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span><span>3.<strong>Spin Echo experiment;&nbsp;&nbsp;</strong></span></span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span><span>4.<strong>T2 &amp; T*2 experiment;&nbsp;</strong></span></span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span><span>5.<strong>D.J. algorithm experiment;</strong>&nbsp;&nbsp;</span></span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span><span>This instrument aims at developing students` strong experimental ability to handle, build ,adjust the instrument by themselves to understand quantum,rather than a simply theoretical demonstration software.</span></span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span><span>It is easy to operate &lt;only needs a laptop&gt; , as small as a suitcase, &nbsp;besides, we could provide operation video,on-line training and course teaching plans .</span></span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span><span>After 3 years usage feedback from American,Australian&amp;Chinese universities, we believe &lt;Diamond I&gt; could bring more benefit to students.</span></span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span><span>Welcome to visit the demonstration on Youtube:</span></span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span><span><a href=\"https://www.youtube.com/watch?v=npULnhmUmuY  \">https://www.youtube.com/watch?v=npULnhmUmuY </a></span></span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><img alt=\"\" src=\"///C:/Users/Administrator/AppData/Roaming/Foxmail7/Temp-19552-20220308095556/Attach/InsertPic_7D80(1(03-08-11-38-43).jpg\" /><img alt=\"\" src=\"///C:/Users/Administrator/AppData/Roaming/Foxmail7/Temp-19552-20220308095556/Attach/InsertPic_7D80(1(03-08-11-38-43).jpg\" /></p>\r\n\r\n<p>&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [],
        "level": [
            "Primary and Secondary School",
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Information",
            "Quantum Physics",
            "Quantum Technology"
        ],
        "org": [
            "China Instru & Quantumtech (CIQTEK) Co.,Ltd."
        ],
        "city": [
            "Hefei"
        ],
        "country": [
            "China"
        ],
        "target": [
            "Secondary school students",
            "Secondary school teachers",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Experiments",
            "Platform",
            "Teaching material"
        ],
        "id": "045efe68-6ff8-49a6-9ab9-a02d41ea3d3f"
    },
    {
        "title": "Quantum Quest",
        "summary": "Quantum Quest is a 5-week (~8 hours per week) online course that explains the mathematical foundations of quantum computing. It's aimed at students aged 16-20 who can handle the most difficult math at well-ranking high schools - the program is very challenging.\u00a0",
        "description": "<p>Once every 1-2 years, we offer this as an active course with dedicated teachers, group work and video meetings.&nbsp;</p>\r\n\r\n<p>In between, the program is open for self-study. All English-language course materials are freely available on quantum-quest.nl.&nbsp;</p>\r\n\r\n<p>&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Koen Groenland",
                "second": "k.l.groenland@uva.nl"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Programming"
        ],
        "org": [
            "QuSoft"
        ],
        "city": [
            "Amsterdam"
        ],
        "country": [
            "The Netherlands"
        ],
        "target": [
            "Secondary school students",
            "Secondary school teachers"
        ],
        "type": [
            "Book",
            "Platform",
            "Teaching material",
            "Teaching notes",
            "Videos"
        ],
        "id": "7e5d9e38-a64e-4bf7-90e0-286b8ed72c35"
    },
    {
        "title": "Italian Quantum weeks 2022- Video ITA",
        "summary": "Attivit\u00e0 di ricerca nell'ambito delle tecnologie quantistiche all'interno dei laboratori di ricerca italiani.",
        "description": "<p>Video realizzato in occasione delle <a href=\"https://www.quantumweeks.it/\">Italian Quantum Weeks 2022 </a>come elemento dell'esposizione \"Dire l'indicibile\".</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [],
        "level": [
            "Primary and Secondary School",
            "Outreach"
        ],
        "lang": [
            "Italian"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Quantum Metrology",
            "Quantum Physics",
            "Quantum Sensing",
            "Quantum Simulation",
            "Quantum Technology"
        ],
        "org": [
            "Italian Quantum Weeks"
        ],
        "city": [],
        "country": [
            "Italy"
        ],
        "target": [
            "Secondary school students",
            "Secondary school teachers"
        ],
        "type": [
            "Videos"
        ],
        "id": "b575b65c-8316-4594-b4f8-0f29583b7f61"
    },
    {
        "title": "Italian Quantum Weeks 2022 - Video ENG",
        "summary": "Overview of the quantum technology research in Italian laboratories.\u00a0",
        "description": "<p>Video produced on the occasion of the 2022 Italian Quantum Weeks as final part of the Exhibition \"Dire l'indicibile\".</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [],
        "level": [
            "Primary and Secondary School",
            "Outreach"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Quantum Metrology",
            "Quantum Physics",
            "Quantum Sensing",
            "Quantum Simulation",
            "Quantum Technology"
        ],
        "org": [
            "Italian Quantum Weeks"
        ],
        "city": [],
        "country": [
            "Italy"
        ],
        "target": [
            "Secondary school students",
            "Secondary school teachers"
        ],
        "type": [
            "Videos"
        ],
        "id": "7a05a5fb-e8fb-4da3-b7bb-4bb504cc44aa"
    },
    {
        "title": "Quantum-Penny-Flip Game",
        "summary": "A small web applet that can be used for an action-oriented and playful introduction to quantum information",
        "description": "<p>The Quantum Penny Flip game is a small web applet that can be used for an action-oriented and playful introduction to quantum information. Following the game, parallels can be drawn to the concept of superposition.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Stefan Seegerer",
                "second": "stefan.seegerer@meetiqm.com"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "English",
            "German"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Information"
        ],
        "org": [
            "Albert-Ludwigs-Universit\u00e4t Freiburg"
        ],
        "city": [
            "Freiburg im Breisgau"
        ],
        "country": [
            "Germany"
        ],
        "target": [
            "Secondary school students",
            "Secondary school teachers"
        ],
        "type": [
            "Games",
            "Teaching material",
            "Teaching notes"
        ],
        "id": "253ae027-dc90-4359-ad38-11f14995a515"
    },
    {
        "title": "The Role of Mathematics in Teaching Quantum Physics at High School",
        "summary": "Pospiech, G. et al. (2021). In: Jarosievitz, B., S\u00fck\u00f6sd, C. (eds) Teaching-Learning Contemporary Physics. Challenges in Physics Education. Springer, Cham. https://doi.org/10.1007/978-3-030-78720-2_4",
        "description": "<p>As quantum physics (QP) requires substantial mathematical knowledge, a thorough elementarization by reduction of complexity or with help of visualizations is needed without neglecting the goal of deeper understanding. First, we present how the visualization of the Dirac formalism could contribute to a deeper understanding of the central concepts of QP. Then, we present two teaching/learning proposals (TLP) for high school students based on the Dirac notation. Both approaches show how suitable strategies can improve student understanding of topics rooted in math and indicate significant success of the students in understanding, interpreting and implementation of the basic concepts of QP. The first approach presented here uses the concept of \u201cwavity\u201d or \u201cwave-particle-duality\u201d in the context of Dirac notation. The second approach emphasizes the measurement process and, on this basis, moves on to discuss the quantum state. It is asked whether and how it is possible to use the formal structure of these concepts to support students in interpreting them. In an inquiry-based teaching\u2013learning sequence on high school level, educational strategies for consolidating the grasp of quantum concepts through math were developed and implemented in teaching experiments conducted in the framework of design-based research. Results of data analysis in both cases show that the adopted strategies are largely successful.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Avraham Merzel",
                "second": "avraham.merzel@mail.huji.ac.il"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Physics",
            "Teaching"
        ],
        "org": [
            "The Hebrew Universitity of Jerusalem Israel"
        ],
        "city": [
            "Jerusalem"
        ],
        "country": [
            "Israel"
        ],
        "target": [
            "Secondary school students",
            "Secondary school teachers"
        ],
        "type": [
            "Book"
        ],
        "id": "f5fbf418-e34c-40c8-861f-1f28df185ed0"
    },
    {
        "title": "Qiskit Global Summer School 2021: Quantum Machine Learning ",
        "summary": "Materials of the course which contains around eight hours of content, and is aimed at self-learners who are comfortable with undergraduate-level mathematics and quantum computing fundamentals. ",
        "description": "<p>This course contains around eight hours of content, and is aimed at self-learners who are comfortable with undergraduate-level mathematics and quantum computing fundamentals. This course will take you through key concepts in quantum machine learning, such as parameterized quantum circuits, training these circuits, and applying them to basic problems. By the end of the course, you'll understand the state of the field, and you'll be familiar with recent developments in both supervised and unsupervised learning such as quantum kernels and general adversarial networks. This course finishes with a project that you can use to showcase what you've learnt.</p>\r\n\r\n<p>This course was created by IBM Quantum with the help of Qiskit Advocates through the Qiskit Advocate Mentoring Program.</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Fabio Scafirimuto",
                "second": "fas@zurich.ibm.com"
            }
        ],
        "level": [
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Business",
            "Engineering",
            "Programming"
        ],
        "org": [
            "IBM Quantum"
        ],
        "city": [
            "Zurich"
        ],
        "country": [
            "Switzerland"
        ],
        "target": [
            "Entrepreneurs",
            "Managers",
            "Investors",
            "Professionals",
            "Technicians",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Book",
            "Videos"
        ],
        "id": "32aa2d2f-a8fa-479a-ba2c-ff462c32c1af"
    },
    {
        "title": "Qiskit Developer Certification ",
        "summary": "An IBM Qiskit Developer is an individual who demonstrates fundamental knowledge of quantum computing concepts and is able to express them using the Qiskit open source software development kit (SDK). They have experience using the Qiskit SDK from the Python programming language to create and execute quantum computing programs on IBM Quantum computers and simulators.",
        "description": "<p><span><span>An IBM Qiskit Developer is an individual who demonstrates fundamental knowledge of quantum computing concepts and is able to express them using the Qiskit open source software development kit (SDK). They have experience using the Qiskit SDK from the Python programming language to create and execute quantum computing programs on IBM Quantum computers and simulators.</span></span></p>\r\n\r\n<p><span><span><strong>Key areas of competency:</strong></span></span></p>\r\n\r\n<ul>\r\n\t<li><span><span>Defining, executing, and visualizing results of quantum circuits using the Qiskit SDK</span></span></li>\r\n\t<li><span><span>Understanding single-qubit gates and their rotations on the Bloch sphere.</span></span></li>\r\n\t<li><span><span>Understanding various multi-qubit gates and their effects in quantum circuits.</span></span></li>\r\n\t<li><span><span>Leveraging fundamental Qiskit SDK features including commonly-used classes and functions located in qiskit.circuit, qiskit.execute, qiskit.providers, qiskit.qasm, qiskit.quantum_info, qiskit.tools, and qiskit.visualization packages</span><span>.</span></span></li>\r\n</ul>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Fabio Scafirimuto",
                "second": "fas@zurich.ibm.com"
            }
        ],
        "level": [
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Programming"
        ],
        "org": [
            "IBM Quantum"
        ],
        "city": [
            "Zurich"
        ],
        "country": [
            "Switzerland"
        ],
        "target": [
            "Entrepreneurs",
            "Managers",
            "Investors",
            "Professionals",
            "Technicians",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Other"
        ],
        "id": "59ea23da-85b0-4d3d-9803-e35ce54248fe"
    },
    {
        "title": "Public talk: 30 years that shocked quantum physics",
        "summary": "A series of public talks were held in a historical cafe Caff\u00e8 San of Trieste city in Italy to discover the fascinating sides of quantum objects and their importance for technology.",
        "description": "<p>30 min public talk and 30 min discussion with the public</p>\r\n\r\n<p>Thursday 31 March 2022 \u2013 18.00</p>\r\n\r\n<p>Speaker: Fabio Benatti (Univetsity of Triest - UniTS)</p>\r\n\r\n<p>Description:&nbsp;The second quantum revolution: how the bizzar epistemological curiosity becomes the resource of the technological transformation.</p>\r\n\r\n<p>It is a part of the series of evenings of public speaking called \"Aperitivi Quantistici\" within the <a href=\"//www.quantumweeks.it\">Italian Quantum Weeks 2022</a>.</p>\r\n\r\n<p>List of all public talks:</p>\r\n\r\n<ul>\r\n\t<li>\r\n\t<p><a href=\"https://youtu.be/LbcWmcHAuIc\">30 years that shocked quantum physics</a></p>\r\n\t</li>\r\n\t<li>\r\n\t<p><a href=\"https://youtu.be/K5Q1Ht4JRYs\">Quantum computers and complex calculations&nbsp;</a></p>\r\n\t</li>\r\n\t<li>\r\n\t<p><a href=\"https://youtu.be/E75i4bfregg\">Quantum computers and society</a></p>\r\n\t</li>\r\n\t<li>\r\n\t<p><a href=\"https://youtu.be/gbtOmyTYF2s\">Coldest atoms and quantum technologiea in Trieste</a></p>\r\n\t</li>\r\n\t<li>\r\n\t<p><a href=\"https://youtu.be/Cb19camnaj0\">Artificial inteligence &amp; Quantum Technologies</a></p>\r\n\t</li>\r\n</ul>\r\n\r\n<p>Full programma of Trieste can be found at&nbsp;&nbsp;<a dir=\"auto\" href=\"https://www.youtube.com/redirect?event=video_description&amp;redir_token=QUFFLUhqbGhtMU9NSHBRa1BPaVFzQTJhTWFfa01Ud1JNUXxBQ3Jtc0tuWTVyM0xxaHloYWhUeThMZXR0b1Q0T0ZMWE9Bb0lkWGJqWEthd2dQZXlPNk1iNEpkcW9pOTVLekYxZ2VVRFZSME1EYnpxU1FfMERhMUZaRDg5dkhNYjloUDQ2N2hTYXJBMHNjb2E2OGJsNm5hdVBKVQ&amp;q=https%3A%2F%2Fwww.quantumweeks.it%2Ftrieste%2F&amp;v=LbcWmcHAuIc\">https://www.quantumweeks.it/trieste/</a></p>\r\n\r\n<p>&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Oxana Mishina",
                "second": "italianquantumweeks.trieste@gmail.com"
            }
        ],
        "level": [
            "Outreach"
        ],
        "lang": [
            "Italian"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Quantum Metrology",
            "Quantum Physics",
            "Quantum Sensing",
            "Quantum Simulation",
            "Quantum Technology"
        ],
        "org": [
            "Italian National Institute of Optics - CNR"
        ],
        "city": [
            "Trieste"
        ],
        "country": [
            "Italy"
        ],
        "target": [],
        "type": [
            "Videos"
        ],
        "id": "67b38fae-45ca-4e7f-a017-e49ab616e919"
    },
    {
        "title": "Hydrogen Atom Orbitals",
        "summary": "",
        "description": "<p>It is interactive programs and extensive worksheets with theory and about 30 questions and problems that lead students to understand stationary states and probability density (i.e. orbitals) of hydrogen atoms; <span lang=\"en\"><span><span>special emphasis is placed on building the image of spatial layout and the role of all three spherical coordinates.</span></span></span></p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Zde\u0148ka Koupilov\u00e1",
                "second": "zdenka.koupilova@mff.cuni.cz"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English",
            "Czech"
        ],
        "topic": [
            "Quantum Physics"
        ],
        "org": [
            "Charles University, Faculty of Mathematics and Physics"
        ],
        "city": [
            "Prague"
        ],
        "country": [
            "Czech Republic"
        ],
        "target": [
            "BSc students",
            "MSc students"
        ],
        "type": [
            "Illustrations",
            "Platform",
            "Publication",
            "Simulations",
            "Teaching material"
        ],
        "id": "a302aae8-860b-46ba-8454-8dcc95520f40"
    },
    {
        "title": "Italian Quantum Weeks - website",
        "summary": "Website of the outreach project Italian Quantum Weeks",
        "description": "<p>Quantum Mechanics, the set of laws that govern the world of atoms and elementary particles, has disrupted the way we conceive of reality with its fascinating oddities. Quantum Technologies based on the use of quantum mechanics in everyday life applications are bringing a new technological revolution that we must learn to understand and manage. In this context and on the occasion of the World Quantum Day (April 14), the Italian Quantum Weeks project aims to raise awareness of the quantum world and the opportunities that the quantum revolution is about to bring. Italian Quantum Weeks involves researchers, technicians, popularizers, communicators, and teachers belonging to more than 40 Italian research institutions, university sites, and scientific societies, all committed to the field of quantum mechanics and the dissemination of its knowledge.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [],
        "level": [
            "Outreach"
        ],
        "lang": [
            "Italian"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Quantum Physics",
            "Quantum Technology",
            "Teaching"
        ],
        "org": [
            "National Research Council (CNR)"
        ],
        "city": [],
        "country": [
            "Italy"
        ],
        "target": [],
        "type": [
            "Illustrations",
            "Teaching material",
            "Videos"
        ],
        "id": "22153634-fa5a-4b36-a576-c77483130fd1"
    },
    {
        "title": "Quantum mechanics at high school level using double well",
        "summary": "A course for high school using active engagement based on ISLE and the context of the double well to explore the topics of indeterminism, probability superposition, uncertainty principle, measurement and time evolution.",
        "description": "The course uses a set of activities that have been developed using the ISLE (Investigative Science Learning Environment) framework. The first few activities are observational experiments to arrive at the basic rules of quantum mechanics: indeterminism of single results and the statistical description of possible outcomes of a measurement. The next few activities discuss superposition, showing through observational and testing experiments that a superposition state cannot be adequately described as either-or. The next few activities explore the effect of measurement and the uncertainty principle. The minimum course length to have all activities done by the students is six 45-minutes sessions. ",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Sergej Faleti\u010d",
                "second": "sergej.faletic@fmf.uni-lj.si"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Physics"
        ],
        "org": [
            "University of Ljubljana, Faculty of mathematics and physics"
        ],
        "city": [
            "Ljubljana"
        ],
        "country": [
            "Slovenia"
        ],
        "target": [
            "Secondary school students",
            "Secondary school teachers",
            "Other (specify)"
        ],
        "type": [
            "Publication",
            "Teaching material"
        ],
        "id": "b0e5825a-37bd-428a-9492-18be434b3597"
    },
    {
        "title": "Double well simulation",
        "summary": "This is a simplified simulation of a double well. It allows for measurement of position and energy at different times. It displays the results in a log and as histograms.",
        "description": "This simulation has been created to allow students to explore the behaviour of an electron in an idealized double well using their smart phones. It is written in HTML5.\r\nIt has been tested in class and reported about in https://doi.org/10.1088/1361-6404/ab90db.\r\nThe simulation uses a histogramic graphical representation of measurement results from which probability can be easily derived. It allows for all basic experiments and also for testing experiments showing that a superposition is not a statistical mixture, that trajectories are not unique and that measurement affects the system.",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Sergej Faleti\u010d",
                "second": "sergej.faletic@fmf.uni-lj.si"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Physics",
            "Soft Skills"
        ],
        "org": [
            "Univesrity of Ljubljana, Faculty of mathematics and physics"
        ],
        "city": [
            "Ljubljana"
        ],
        "country": [
            "Slovenia"
        ],
        "target": [
            "Secondary school students",
            "Secondary school teachers",
            "Other (specify)"
        ],
        "type": [
            "Simulations"
        ],
        "id": "c07be3a1-4934-42f5-83ea-90e6cb96fdf6"
    },
    {
        "title": "Potential of games and simulations in quantum science and education-PhD Thesis",
        "summary": "In this PhD thesis, Shaeema Zaman Ahmed describes the use and impact of games and simulations in quantum physics education, outreach training, and quantum control research, which she explored during her PhD at Aarhus University, Denmark. ",
        "description": "<p><strong>Have you ever wondered about the potential of games and simulations in quantum physics education, outreach and research?</strong></p>\r\n\r\n<p><span><span><span><span><span><span>During her PhD studies, Shaeema Zaman Ahmed researched the use and impact of games and simulations in quantum physics education, outreach training, and quantum control research. One might wonder \u201cwhy games and simulations?\u201d. </span></span></span></span></span></span>There are indeed a couple of good reasons. Firstly, research shows that there is potential in crowdsourcing solutions to scientific problems through games [1]. Secondly, studies also show that games and simulations can enhance learning, as seen in many scientific disciplines. During her PhD, Shaeema took forward this arena of tools and applied it in quantum physics to explore: (a) how simulations can improve student learning of quantum mechanics [2,3], (b) perspectives on crowdsourcing solutions for controlling atoms through a game [4], and (c) the impact of the use of simulations in quantum physics outreach training [5].</p>\r\n\r\n<p><span><span><span><span><span><span>The new research findings contribute to the understanding of how games and simulations can be powerful in quantum physics education and quantum control research.&nbsp;</span></span></span></span></span></span></p>\r\n\r\n<p>The PhD was carried out at the Department of Physics and Astronomy, AarhusUniversity, Denmark under<br />\r\nthe Marie Sk\u0142odowska-Curie-Innovative Training Networks-2017 fellowship(MSCA-ITN-2017)<br />\r\nfunded by the European Union\u2019s Horizon 2020 Research Innovation Programme grant agreement<br />\r\nNo. 765267.</p>\r\n\r\n<p><strong>References:</strong></p>\r\n\r\n<p>[1] Jeanne&nbsp;Garbarino,&nbsp;Christopher E.&nbsp;Mason. \u201c<a href=\"https://journals.asm.org/doi/10.1128/jmbe.v17i1.1052\">The Power of Engaging Citizen Scientists for Scientific Progress</a>\u201d. In: Journal of Microbiology &amp; Biology Education (2016), Vol. 17, No. 1</p>\r\n\r\n<p>[2] Shaeema Zaman Ahmed et al. \u201c<a href=\"https://aapt.scitation.org/doi/10.1119/10.0003396\">Quantum composer: A programmable quantum visualization and simulation tool for education and research</a>\u201d. In: American Journal of Physics 89.3 (2021), pp. 307\u2013316.&nbsp;</p>\r\n\r\n<p>[3] Shaeema Zaman Ahmed et al. \u201c<a href=\"https://arxiv.org/abs/2104.13260v1\">Student engagement and learning with Quantum Composer</a>\u201d. In: arXiv:2104.13260v1&nbsp;(2021)</p>\r\n\r\n<p>[4] Jesper Hasseriis Mohr Jensen et al. \u201c<a href=\"https://journals.aps.org/prresearch/abstract/10.1103/PhysRevResearch.3.013057\">Crowdsourcing human common sense for quantum control</a>\u201d. In: Phys. Rev. Research 3 (1 2021), p. 013057.&nbsp;</p>\r\n\r\n<p>[5] Shaeema Zaman Ahmed et al. \u201c<a href=\"https://arxiv.org/abs/2103.03109\">A training programme for early-stage researchers that focuses on developing personal science outreach portfolios</a>\u201d. In: arXiv:2103.03109 (2021).</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Shaeema Zaman Ahmed",
                "second": "info@sciencemeltingpot.com"
            }
        ],
        "level": [
            "Higher education",
            "Lifelong learning and (re)training",
            "Outreach"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Physics",
            "Quantum Technology",
            "Soft Skills",
            "Teaching",
            "Other (specify)"
        ],
        "org": [
            "Aarhus University"
        ],
        "city": [
            "Aarhus"
        ],
        "country": [
            "Denmark"
        ],
        "target": [
            "Entrepreneurs",
            "Investors",
            "Professionals",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Report"
        ],
        "id": "dfa2665c-7a9c-404f-89e9-f7bab4d0dcbe"
    },
    {
        "title": "Toward Teacher Training for Teaching Quantum Physics in High School",
        "summary": "This chapter presents insights from a workshop for teachers' training for teaching quantum physics in secondary schools.",
        "description": "<p>Toward Teacher Training for Teaching Quantum Physics in High School</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Avraham Merzel",
                "second": "avraham.merzel@mail.huji.ac.il"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Physics",
            "Teaching"
        ],
        "org": [
            "The Hebrew Universitity of Jerusalem Israel"
        ],
        "city": [
            "Jerusalem"
        ],
        "country": [
            "Israel"
        ],
        "target": [
            "Secondary school students",
            "Secondary school teachers"
        ],
        "type": [
            "Book",
            "Publication"
        ],
        "id": "ef9dd07c-a964-42e4-a1a8-3fb317fbd95a"
    },
    {
        "title": "How can we use atoms (and photons) as quantum sensors?",
        "summary": "",
        "description": "<p>When atoms absorb photons with specific energy, they can make transitions to different quantum states. Atomic spins at the same time behave like tiny magnets, making an atom the smallest multi-tool possible. macQsimal\u2019s scientists are using vapor cells filled with trillions of atoms. By combining microelectromechanical systems (MEMS) technology with laser beams they develop atomic quantum sensors. Researchers aim to use quantum-enhanced sensors to measure magnetic fields, time, rotation, electromagnetic radiation, and gas concentration with unprecedented sensitivity.</p>\r\n\r\n<p><span lang=\"EN-US\">The employment of MEMS technology in combination with laser beams to create quantum sensors for multiple purposes. The animated short film is designed to serve as an educational and explanatory video.</span></p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Joanna Plesniak",
                "second": "jplesniak@accelopment.com"
            }
        ],
        "level": [
            "Higher education",
            "Outreach"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Metrology",
            "Quantum Physics",
            "Quantum Sensing",
            "Teaching"
        ],
        "org": [
            "macQsimal consortium"
        ],
        "city": [
            "Neuchatel"
        ],
        "country": [
            "Switzerland"
        ],
        "target": [
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Videos"
        ],
        "id": "0cf49705-670d-45eb-add1-14efbfdbf6b9"
    },
    {
        "title": "Phenomena and Principles: Presenting Quantum Physics in a High School Curriculum",
        "summary": "",
        "description": "<p>&nbsp;The goal of teaching quantum physics (QP) in high school is a problematic and highly turbulent area of divergent views, curricula studies, and claims.&nbsp;The innovative curricular approach of discipline-culture (DC) suggests a way of overcoming its significant difficulties. It suggests presenting QP as a fundamental theory structured in terms of the <span>nucleus</span>, <span>body</span>, and <span>periphery</span>. Applying this perspective in our study, we interviewed nine experts with respect to their view of how the <span>nucleus</span> of QP should be presented to high-school students. With the different viewpoints of the core essentials in hand, we compiled the <span>nucleus</span> of the QP. We also examined this subject using nine introductory university textbooks that might suit high school students and considered their coherence and suitability with regard to the specified <span>nucleus</span>. We found some confusion regarding the status of theoretical items: some fundamental principles, as perceived in the eyes of the experts, are presented as phenomena. Not only does this mismatch represent a special barrier for both the teachers and students to understand QP, it promotes an inadequate image of QP as well as a distorted view of the nature of science. Finally, we offer a framework for a DC-based QP curriculum free of the noted deficiencies.</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Efraim Weissman",
                "second": "efy.wei@gmail.com"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Physics",
            "Teaching"
        ],
        "org": [
            "The Hebrew Universitity of Jerusalem Israel"
        ],
        "city": [
            "Jerusalem"
        ],
        "country": [
            "Israel"
        ],
        "target": [
            "Secondary school students",
            "Secondary school teachers"
        ],
        "type": [
            "Publication",
            "Other"
        ],
        "id": "50d41126-3838-46b4-9946-10b5c95cd8ad"
    },
    {
        "title": "Quantum Enigmas video series",
        "summary": "You are invited to discover the extraordinary world of quantum programming through a unique animated series: The Quantum enigmas.\u00a0",
        "description": "<p>We\u2019ve made an introduction to the key concepts of quantum computing and a series of fun enigmas to solve. Even if there is no quantum advantage at the moment, from one enigma to the next, you will develop a deeper understanding of quantum by testing your logic against various scenarios.</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Ghislain Lefebvre",
                "second": "ghislain.lefebvre2@usherbrooke.ca"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education",
            "Lifelong learning and (re)training",
            "Outreach"
        ],
        "lang": [
            "English",
            "French"
        ],
        "topic": [
            "Quantum Computing"
        ],
        "org": [
            "Institut quantique"
        ],
        "city": [
            "Sherbrooke"
        ],
        "country": [
            "Canada"
        ],
        "target": [
            "Entrepreneurs",
            "Secondary school students",
            "Secondary school teachers",
            "BSc students"
        ],
        "type": [
            "Videos"
        ],
        "id": "d903297d-96ee-47b0-808e-de05825e9128"
    },
    {
        "title": "WAINTEACH - kit for practical courses in\u00a0quantum physics",
        "summary": "",
        "description": "<p>WAINTEACH&nbsp;is a kit for practical courses in&nbsp;quantum physics, for&nbsp;Masters 1 and 2,&nbsp;and&nbsp;BTEC Higher National Diploma&nbsp;students to contribute to their training in&nbsp;quantum information.</p>\r\n\r\n<p>With this kit, they will approach the concepts of quantum bit manipulation by studying&nbsp;<a href=\"https://wainvam-e.com/nv-center-diamonds-and-their-production/\">the&nbsp;NV&nbsp;<em>(Nitrogen Vacancy)&nbsp;</em>diamond&nbsp;centres</a>.</p>\r\n\r\n<p>The simple experimental implementation (no vacuum, no cryogenics) allows great flexibility, for example on optical alignments. This&nbsp;practical approach&nbsp;will complete the theoretical knowledge given in the course.</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Luc Le Romancer",
                "second": "luc.leromancer@wainvam-e.com"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Metrology",
            "Quantum Physics",
            "Quantum Sensing",
            "Quantum Technology",
            "Engineering",
            "Teaching"
        ],
        "org": [
            "WAINVAM-E"
        ],
        "city": [
            "PLOEMEUR"
        ],
        "country": [
            "France"
        ],
        "target": [
            "BSc students",
            "MSc students"
        ],
        "type": [
            "Experiments",
            "Teaching material"
        ],
        "id": "4ca65f3f-7b03-4ff9-8e34-b18034f4ea8f"
    },
    {
        "title": "Qureka! Box ",
        "summary": "",
        "description": "<h4>Teaching and Learning Quantum Computing Made Simple And Fun</h4>\r\n\r\n<p>The Qureka! Box is designed to introduce to high school and undergraduate students, as well as the general public, the fascinating world of quantum computing.</p>\r\n\r\n<p>The box features interactive game-based hands-on teaching and learning tools in quantum computing promoting maximum engagement and interest while ensuring that nobody is left behind. The box provides a complete set of tools that minimizes the need for abstract imagination.</p>\r\n\r\n<p>Qureka! Box untangles quantum computing concepts through interactive game-based tools, generating \u201ceureka\u201d moments that enhance motivation and recall. Physical models like the Qubit and 3D Bloch sphere allow students to touch, interact and build, enabling a firm grasp of fundamental concepts such as spin, uncertainty, superposition, and state. The box immerses students in quantum phenomena through games, allowing visualization of states, gates, and circuits.</p>\r\n\r\n<p>Games comparing classical computing and quantum computing highlight the benefits of quantum computing. The use of cards and a real quantum computer lab enables students to visualize and simulate quantum circuits, building real skills for quantum computing. In a fun and engaging way, Qureka! Box ensures students gain a good understanding of quantum computing.</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "contacts": [],
        "level": [
            "Primary and Secondary School",
            "Higher education",
            "Outreach"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Information",
            "Quantum Physics",
            "Quantum Technology",
            "Programming",
            "Soft Skills",
            "Teaching"
        ],
        "org": [
            "QURECA SPAIN "
        ],
        "city": [],
        "country": [
            "Spain"
        ],
        "target": [
            "Secondary school students",
            "Secondary school teachers",
            "BSc students"
        ],
        "type": [
            "Games",
            "Illustrations",
            "Presentations",
            "Teaching material",
            "Teaching notes",
            "Videos"
        ],
        "id": "4f9a6bb4-e880-4365-9bd9-b6032d7629cc"
    },
    {
        "title": "QuantumVR",
        "summary": "QuantumVR is a virtual reality game that teaches you to solve small quantum algorithms by placing simple quantum gates. VR and 2D version available. ",
        "description": "<p>Learn to solve quantum algorithms in a playful way with QuantumVR. The game is based on escape elements in virtual reality (VR, optional). By placing simple quantum gates you solve small quantum algorithms to free animals. Immerse yourself in the virtual game world and advance from level to level. Whether you are a beginner or an advanced player, there is a suitable mode for everyone.<br />\r\n&nbsp;</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Franziska Greinert",
                "second": "f.greinert@tu-braunschweig.de"
            }
        ],
        "level": [
            "Outreach"
        ],
        "lang": [
            "English",
            "German"
        ],
        "topic": [
            "Quantum Computing"
        ],
        "org": [
            "TU Braunschweig"
        ],
        "city": [],
        "country": [
            "Germany"
        ],
        "target": [],
        "type": [
            "Games",
            "Teaching material"
        ],
        "id": "627ff4e7-d699-42e5-8161-b31d83eadbce"
    },
    {
        "title": "Textbook on quantum information science",
        "summary": "A textbook on quantum information science for graduate students in physics, mathematics, and computer science that aims to help many students understand the technical details of this field.",
        "description": "<p>Good morning,</p>\r\n\r\n<p>My name is Riccardo Manenti,I am a senior quantum engineer at Rigetti Computing, a quantum computing company based in California.</p>\r\n\r\n<p>Over the past nine years, I have written a textbook on quantum information science with Mario Motta, a research scientist at IBM. The book will soon be published by the Oxford University Press and can be ordered online.</p>\r\n\r\n<p><a href=\"https://www.amazon.co.uk/Quantum-Information-Science-Riccardo-Manenti/dp/0198787480/ref=sr_1_1?keywords=manenti+motta&amp;qid=1686550769&amp;sprefix=manenti%2Caps%2C366&amp;sr=8-1\">ORDER ONLINE</a></p>\r\n\r\n<p>The target audience is graduate students in physics, mathematics, and computer science. I believe this book will help many students understand the technical details of this field.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Riccardo Manenti",
                "second": "riccardo.manenti@gmail.com"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Information",
            "Quantum Physics",
            "Quantum Simulation",
            "Quantum Technology",
            "Engineering"
        ],
        "org": [
            "Rigetti"
        ],
        "city": [
            "Berkeley"
        ],
        "country": [
            "United States"
        ],
        "target": [
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Book"
        ],
        "id": "c2012de9-52b9-463e-bf7e-da1084ea0cde"
    },
    {
        "title": "Quantum Optics Educational Kit Manual",
        "summary": "",
        "description": "<p><strong>Quantum Optics Educational Kit Details</strong></p>\r\n\r\n<ul>\r\n\t<li>Build a Heralded Single-Photon Source (Spontaneous Parametric Down-Conversion)</li>\r\n\t<li>Learn Coincidence Counting Techniques to Distinguish Classical from Non-Classical Light Sources</li>\r\n\t<li>Analyze the Polarization State of Single Photons</li>\r\n\t<li>Show How a Single Photon Interferes with Itself (Superposition of Quantum States)</li>\r\n\t<li>Demonstrate Particle/Wave Duality of Light in the Context of the Quantum Eraser Experiment</li>\r\n</ul>\r\n\r\n<p>Our Quantum Optics Educational Kit includes all the components needed for students to investigate the quantum properties of light first-hand in an open and accessible environment. From the type-I BBO crystal used to generate photon pairs to the state-of-the-art single-photon detectors, all elements employ free-space optics to clearly show where and when the measurement occurs. Detailed step-by-step alignment instructions using an additional visible laser that mimics the single-photon emission cone ensure short setup times for each experiment. One particularly important aspect of the kit is to educate people about what constitutes a non-classical light source.</p>\r\n\r\n<p>An extension to optical quantum computing (Deutsch algorithm) is shown in the \"Additional Experiments\" section of the manual.</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Jens K\u00fcchenmeister",
                "second": "jkuechenmeister@thorlabs.com"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Physics",
            "Quantum Technology",
            "Teaching"
        ],
        "org": [
            "Thorlabs GmbH"
        ],
        "city": [
            "Bergkirchen"
        ],
        "country": [
            "Germany"
        ],
        "target": [
            "Secondary school students",
            "Secondary school teachers",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Experiments",
            "Teaching material"
        ],
        "id": "36710342-e58e-4317-a69f-56e564ae614a"
    },
    {
        "title": "Quantum Information Science (Textbook)",
        "summary": "",
        "description": "<p>This book provides an introduction to quantum information science, the science at the basis of the new quantum revolution of this century. It teaches the reader to build and program a quantum computer and leverage its potential.<br />\r\n<br />\r\nAimed at quantum physicists and computer scientists, the book covers several topics, including quantum algorithms, quantum chemistry, and quantum engineering of superconducting qubits.<br />\r\n<br />\r\nWritten by two professionals in the experimental and theoretical fields of quantum information science and containing over 200 figures and 100 exercises with solutions and summaries at the end of each chapter, this book is set to become a new standard in the field.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Riccardo Manenti",
                "second": "riccardo.manenti@gmail.com"
            }
        ],
        "level": [
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Information",
            "Quantum Physics",
            "Quantum Simulation",
            "Quantum Technology",
            "Engineering"
        ],
        "org": [
            "Oxford University Press"
        ],
        "city": [
            "Oxford"
        ],
        "country": [
            "United Kingdom"
        ],
        "target": [
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Book"
        ],
        "id": "90cc6c2b-60cb-468a-bd1f-aa83a05d8513"
    },
    {
        "title": "Quantum Technology Training for Popicymakers - recordings ",
        "summary": "The Quantum Flagship is offering a series of training sessions on Quantum Technology (QT), addressing policymakers at EU and national levels. The training has been designed in collaboration with EC policymakers accounting for their interests and needs.",
        "description": "<p><strong>The Quantum Flagship</strong>&nbsp;is offering a series of training sessions on Quantum Technology (QT), addressing policymakers at EU and national levels. The training has been designed in collaboration with EC policymakers accounting for their interests and needs and will allow participants to:</p>\r\n\r\n<ul>\r\n\t<li>gain the necessary knowledge to make informed decisions during the performance of their duties,</li>\r\n\t<li>cooperate with peers from other countries,</li>\r\n\t<li>and sustain a conversation on QT topics with experts.</li>\r\n</ul>\r\n\r\n<p>The monthly series will consist of six dedicated online sessions, each 40 minutes long with a 20-minute presentation from experts and a 20-minute Q&amp;A session. The sessions will be recorded and be made available on this page.</p>\r\n\r\n<p>The topics cover:</p>\r\n\r\n<ul>\r\n\t<li>European QT Ecosystem and Roadmap (June&nbsp;2023)</li>\r\n\t<li>Efforts and investments in QT beyond the EU (July 2023)</li>\r\n\t<li>Use Cases: Quantum Sensing &amp; Metrology (September 2023)</li>\r\n\t<li>Use cases: Quantum Communication (October 2023)</li>\r\n\t<li>Use Cases: Quantum Computing (November 2023)</li>\r\n\t<li>QT state-of-the-art and future use cases (December 2023)</li>\r\n</ul>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Costanza Toninelli",
                "second": "costanza.toninelli@ino.cnr.it"
            }
        ],
        "level": [
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Quantum Metrology",
            "Quantum Physics",
            "Quantum Sensing",
            "Quantum Simulation",
            "Quantum Technology",
            "Business"
        ],
        "org": [
            "QUCATS",
            "Italian Nationals Institute of Optics CNR-INO"
        ],
        "city": [
            "Trieste, Florence"
        ],
        "country": [
            "Italy"
        ],
        "target": [
            "Entrepreneurs",
            "Managers",
            "Investors",
            "Professionals",
            "Other (specify)"
        ],
        "type": [
            "Videos"
        ],
        "id": "2b5eaf56-1a28-480c-a852-77d28ddd2ac9"
    },
    {
        "title": "PointerPodcast",
        "summary": "",
        "description": "<p>The PointerPodcast is a podcast about innovation and technology. PointerPodcast interviews highly qualified guests on various topics such as Quantum Computing, Blockchain, Artificial Intelligence, etc. The PointerPodcast is available on Spotify, Apple Podcast, and Google Podcast. Through the podcast, we hope to generate an impact and inspire people through the stories of our guests.</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Alessandro Berti",
                "second": "alessandro.berti1994@gmail.com"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Innovation & Entrepreneurship",
            "Soft Skills",
            "Other (specify)"
        ],
        "org": [
            "PointerPodcast"
        ],
        "city": [
            "Pisa"
        ],
        "country": [
            "Italy"
        ],
        "target": [
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Other"
        ],
        "id": "a0e50263-428c-4a69-8db6-0139f1edc96b"
    },
    {
        "title": "book: Quantum Technologies for Engineers",
        "summary": "",
        "description": "<p>How does a quantum computer work and how can photons be used to transmit messages securely? Intended for engineering and computer science students, this introduction to quantum technologies presents the fundamentals of quantum computing, quantum communication, and quantum sensing without requiring extensive previous knowledge of physics.</p>\r\n\r\n<ul>\r\n\t<li>Quantum technology - one of the key technologies for our future.</li>\r\n\t<li>Concise introduction in today's research.</li>\r\n\t<li>Examples with solutions and in-depth calculations.</li>\r\n</ul>\r\n\r\n<p><a href=\"https://doi.org/10.1515/9783110717457\">https://doi.org/10.1515/9783110717457</a></p>\r\n\r\n<p>German version also available: <a href=\"https://doi.org/10.1515/9783110717211\">https://doi.org/10.1515/9783110717211</a></p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Rainer M\u00fcller",
                "second": "f.greinert@tu-braunschweig.de"
            }
        ],
        "level": [
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Quantum Metrology",
            "Quantum Physics",
            "Quantum Sensing",
            "Quantum Simulation",
            "Quantum Technology"
        ],
        "org": [
            "TU Braunschweig"
        ],
        "city": [],
        "country": [
            "Germany"
        ],
        "target": [
            "Technicians",
            "BSc students",
            "MSc students"
        ],
        "type": [
            "Book"
        ],
        "id": "1363423b-55f8-42c1-884c-d7cffe7dc280"
    },
    {
        "title": "QuantAttack",
        "summary": "",
        "description": "<p><strong>QuantAttack</strong> is a puzzle game that uses the mechanism of quantum gates in a quantum computer. The rules of quantum gate transformation are used to erase the puzzle such that a sequence of two NOT gates (two Pauli X) will return to identity. Even if you don't know how quantum gates and matrices work, even elementary school students can play this game because they can erase blocks of the same color and shape by stacking them vertically. While playing the puzzle game, you can learn the mechanism of quantum gates behind it.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Keisuke Fujii",
                "second": "fujii.keisuke.es@osaka-u.ac.jp"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education",
            "Lifelong learning and (re)training",
            "Outreach"
        ],
        "lang": [
            "English",
            "Japanese"
        ],
        "topic": [
            "Quantum Computing"
        ],
        "org": [
            "Osaka University"
        ],
        "city": [
            "Osaka"
        ],
        "country": [
            "Japan"
        ],
        "target": [
            "Professionals",
            "Technicians",
            "Primary school students",
            "Primary school teachers",
            "Secondary school students",
            "Secondary school teachers",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Games"
        ],
        "id": "8dd1e5cb-bc78-4a80-95bf-5dabe645d893"
    },
    {
        "title": "Article: Minimizing Deployment Cost of Hybrid Application",
        "summary": "",
        "description": "<p>Within Quantum Software Engineering, the development of hybrid classical-quantum applications is an active research topic. Concretely, there is a focus on the usage of microservices architectures to offer quantum functionalities through classical service gateways. However, while there are methodologies and tools to automatically determine the best deployment for classical applications, this is not the case for hybrid applications, which are especially complicated to deploy due to their specific quantum-requirements. In this paper, we propose Cost Minimizer, a tool to determine the most cost-effective classical and quantum machines to deploy hybrid microservice-based applications. We believe Cost Minimizer will be a step towards achieving a better interaction between classical and quantum computing systems.</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "\u00c1lvaro Manuel Aparicio-Morales",
                "second": "amapamor@unex.es"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Other (specify)"
        ],
        "org": [
            "University of Extremadura"
        ],
        "city": [
            "C\u00e1ceres"
        ],
        "country": [
            "Spain"
        ],
        "target": [
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Publication"
        ],
        "id": "3ac80438-6e97-4cc2-a5c7-05ad9277cab0"
    },
    {
        "title": "QTIndu - Module 1: Why is Quantum so special? Basic rules of quantum physics",
        "summary": "",
        "description": "<p>This module is part of the QTIndu project. It is a qualitative journey through the basic rules of quantum physics, an introduction to the special and counterintuitive world of quantum. The learner will be guided through interesting phenomena, experimental setups and their (planned) application in the real world. The module targets Quantum Novices from all sectors and stakeholders within the industry!</p>\r\n\r\n<p>&nbsp;</p>\r\n\r\n<p>The QTIndu project has received funding from the European Union\u2019s Digital Europe Programme and aims to...</p>\r\n\r\n<ul>\r\n\t<li>...develop a pan-European short-term training program in Quantum Technology.</li>\r\n\t<li>...offer training courses specifically tailored to the requirements of companies and SMEs from different business sectors.</li>\r\n\t<li>...provide guidelines for scaling up the work done in QTIndu to a comprehensive pan-European scale.</li>\r\n</ul>\r\n\r\n<p>You want to learn more about QTIndu? Have a look <a href=\"https://qtindu.eu/\">here</a>.</p>\r\n\r\n<p>You want to know more about other courses and/or modules? Have a look <a href=\"https://qtindu.eu/courses/\">here</a>.</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "contacts": [
            {
                "first": "Ismet N. Dogan (Content Creator)",
                "second": "ismdogan@tu-bs.de"
            }
        ],
        "level": [
            "Lifelong learning and (re)training",
            "Outreach"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Physics",
            "Quantum Technology"
        ],
        "org": [
            "Technische Universit\u00e4t Braunschweig"
        ],
        "city": [
            "Braunschweig"
        ],
        "country": [
            "Germany"
        ],
        "target": [
            "Entrepreneurs",
            "Managers",
            "Investors",
            "Professionals",
            "Technicians",
            "Other (specify)",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [
            "Teaching material",
            "Videos"
        ],
        "id": "ca18fff6-78ec-4ca4-af70-b2d12c8bafa8"
    },
    {
        "title": "Quantum Programming Courses",
        "summary": "The courses have been designed for IT people that wanted to be up-to-date and have general state-of-the-art technologies.",
        "description": "<p>The time has come to take charge of producing quantum software by applying the knowledge and lessons learned from the field of software engineering.<span>&nbsp;</span>This involves applying or adapting existing software engineering processes, methods, techniques, practices, and principles to quantum software development.<span>&nbsp;</span>Our Quantum programming training will help you launch into this disruptive technology.</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Jos\u00e9 Luis Hevia ",
                "second": "jluis.hevia@a-e.es"
            }
        ],
        "level": [
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [],
        "topic": [
            "Quantum Technology",
            "Programming"
        ],
        "org": [
            "Alhambra-Eidos"
        ],
        "city": [],
        "country": [
            "Spain"
        ],
        "target": [
            "Professionals",
            "Technicians",
            "PhD students"
        ],
        "type": [],
        "id": "6d832ef8-3240-457b-9fda-098954393897"
    },
    {
        "title": "ID Quantique winter school on quantum communications",
        "summary": "Annual one-week research school, taking place in Les Diablerets, Switzerland, every year for one calendar week around January 20-25th. Covers QKD, quantum communications, random number generators, very basic intro into quantum computing, industrial applications. Lectures are given by most prominent persons in the research field and industry. Includes 4 hands-on labs. ",
        "description": "<p>Covers QKD, quantum communications, random number generators, very basic intro into quantum computing, industrial applications. Lectures are given by most prominent persons in the research field and industry. Includes 4 hands-on labs.<br />\r\n&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": "Vadim Makarov ",
                "second": "makarov@vad1.com"
            }
        ],
        "level": [
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [],
        "topic": [
            "Quantum Communication",
            "Quantum Information",
            "Quantum Physics"
        ],
        "org": [
            "ID Quantique (IDQ)"
        ],
        "city": [],
        "country": [
            "Switzerland"
        ],
        "target": [
            "Professionals",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [],
        "id": "c23dc98d-92df-4a8b-b751-2d20971f4fb9"
    },
    {
        "title": "Quantum Communications for ALL (QCALL)",
        "summary": "Quantum Communications for ALL (QCALL) is a European Innovative Training Network that endeavors to take the next necessary steps to bring the developing quantum technologies closer to the doorsteps of end-users. QCALL will empower a nucleus of 15 doctoral researchers in this area to provide secure communications in the European continent and, in the long run, to its connections worldwide.",
        "description": "<p>Quantum Communications for ALL (QCALL) is a European Innovative Training Network that endeavors to take the next necessary steps to bring the developing quantum technologies closer to the doorsteps of end-users. QCALL will empower a nucleus of 15 doctoral researchers in this area to provide secure communications in the European continent and, in the long run, to its connections worldwide The countries involved in this project are the UK, France, Germany, Italy, Switzerland, and Spain. &nbsp;<br />\r\n-----------------------------------<br />\r\nOrganization name: European Innovative Training Network<br />\r\n-----------------------------------<br />\r\nProgram target: PhD course,Other,Training modules<br />\r\n-----------------------------------<br />\r\nProgram country: France,Germany,Italy,Spain,Switzerland,United Kingdom<br />\r\n-----------------------------------</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Mohsen Razavi",
                "second": "m.razavi@leeds.ac.uk"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Physics",
            "Quantum Sensing"
        ],
        "org": [
            "European Innovative Training Network"
        ],
        "city": [],
        "country": [],
        "target": [
            "PhD students"
        ],
        "type": [],
        "id": "d46c6180-8e24-4a2a-bb36-d0ac3b7448ff"
    },
    {
        "title": "Quantum Rules!",
        "summary": "The lab QuantumRules! consists of about fifteen quantum-related experiments. ",
        "description": "<p>In an day's visit exam-grade high-school classes perform the experiments in the morning. In the afternoon they present the results among themselves with the constraint that all the results fifteen experiments must presented in only four presentations. This way the students learn how to combine and relate subjects in physics. Currently an extra layer is being developed in the form of a telephone app. This app has the form of a game in which the students have to solve societal aspects of quantum. &nbsp;<br />\r\n-----------------------------------<br />\r\nOrganization name: Physics Department - Leiden University<br />\r\n-----------------------------------<br />\r\nProgram target: Training for school students<br />\r\n-----------------------------------<br />\r\nProgram country: Netherlands<br />\r\n-----------------------------------</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Henk Buisman",
                "second": "buisman@physics.leidenuniv.nl"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "Dutch"
        ],
        "topic": [
            "Quantum Physics"
        ],
        "org": [
            "Physics Department - Leiden University"
        ],
        "city": [],
        "country": [
            "The Netherlands"
        ],
        "target": [
            "Secondary school students",
            "Secondary school teachers"
        ],
        "type": [],
        "id": "6b2c6116-6e8e-4d93-b5e7-15b87ae27449"
    },
    {
        "title": "Quantum Quest - Web classes",
        "summary": "Web class for high school students, organized by QuSoft and the University of Amsterdam.",
        "description": "<p>During 2018, 2020 and 2021, students from all over the globe learned about the mathematics behind Quantum Computers. The next Dutch edition will take place in&nbsp;<strong>November 2023</strong>.</p>\r\n\r\n<p><strong>The course will open for registration in September 2023</strong>. In the meantime, all the course materials are freely available. Please feel warmly invited to browse these pages to already get an impression of the Quantum Quest, or perhaps even complete the course by self-study!</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Maris Ozols ",
                "second": "marozols@gmail.com"
            },
            {
                "first": "Michael Walter",
                "second": "m.walter@uva.nl"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "Dutch",
            "English"
        ],
        "topic": [
            "Quantum Computing"
        ],
        "org": [
            "University of Amsterdam"
        ],
        "city": [],
        "country": [
            "The Netherlands"
        ],
        "target": [
            "Secondary school students"
        ],
        "type": [],
        "id": "f90dab38-e825-40af-b1fd-bb70ee88f6cb"
    },
    {
        "title": "Master IDIFO 2021-22",
        "summary": "The Master IDIFO is a university master dedicated to the in-service training of secondary school teachers on topics including, among others of the modern physics, the quantum mechanics.",
        "description": "<p>The Master IDIFO (Innovation of Education in Physics&nbsp; ed Orientation) is one of the activities promoted by the Physics Education Research Unit of the University of Udine as part of the Scientific Degrees Plan (PLS) of the Italian Ministry of Education.</p>\r\n\r\n<p>Now in its tenth edition, the Master&nbsp;involves the collaboration of professors from four Italian universities and has among its educational objectives the innovation in scientific teaching/learning with particular regard to the themes of modern physics, the teaching&nbsp;based on information and communication technologies (ICT), the physics in context and the laboratory</p>\r\n\r\n<p>The manifesto of the Master is linked <a href=\"https://www.uniud.it/it/didattica/formazione-post-laurea/master/alta-formazione/area-scientifico-tecnologica/idifo-master/ulteriori-approfondimenti/manifesto-idifo2021-prot-agg.pdf\">here</a>&nbsp;and its program&nbsp; <a href=\"https://www.uniud.it/it/didattica/formazione-post-laurea/master/alta-formazione/area-scientifico-tecnologica/idifo-master/ulteriori-approfondimenti/corsi-idifo-21_22.pdf\">here</a>.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Marisa Michelini",
                "second": "marisa.michelini@uniud.it"
            },
            {
                "first": "Lorenzo Santi",
                "second": "lorenzo.santi@uniud.it"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education"
        ],
        "lang": [],
        "topic": [
            "Quantum Physics",
            "Teaching"
        ],
        "org": [
            "University of Udine"
        ],
        "city": [
            "Udine"
        ],
        "country": [
            "Italy"
        ],
        "target": [
            "Secondary school teachers",
            "MSc students"
        ],
        "type": [],
        "id": "597a4354-afb4-44d4-9ef8-58c7a8712bb2"
    },
    {
        "title": "PLS (Scientific Degree Plan) -Teachers action",
        "summary": "About 28 hours per years of teachers formation about topics concerning quantum Physics based on Physics education research.",
        "description": "<p><br />\r\n-</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Marco Giliberti",
                "second": "marco.giliberti@unimi.it"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [],
        "topic": [
            "Quantum Physics",
            "Teaching"
        ],
        "org": [
            "University of Milan"
        ],
        "city": [
            "Milano"
        ],
        "country": [
            "Italy"
        ],
        "target": [
            "Secondary school teachers"
        ],
        "type": [],
        "id": "b0f8af6c-92dc-4b95-a384-40b04a99765e"
    },
    {
        "title": "International MasterClasses in Quantum Optics",
        "summary": "Extension of the master classes program started as an outreach/training project of the cluster of excellence \"QUANTUM FRONTIERS\" .",
        "description": "<p>Extension of the master classes program started as an outreach/training project of the cluster of excellence \"QUANTUM FRONTIERS\" .</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Gunnar Friege",
                "second": "friege@idmp.uni-hannover.de"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [],
        "topic": [
            "Quantum Metrology",
            "Quantum Sensing"
        ],
        "org": [
            "Leibniz Universitaet Hannover",
            "Technische Universit\u00e4t Braunschweig"
        ],
        "city": [],
        "country": [
            "Germany",
            "Germany"
        ],
        "target": [
            "Secondary school students"
        ],
        "type": [],
        "id": "67e35bb9-1eb1-41b2-8e7c-8fb966cad9cc"
    },
    {
        "title": "foeXlab - Quantum optics experiments",
        "summary": "Informal learning situations where students (school) are guided through optical experiments from statistical optics to quantum optics. Conceptual Change from Classical to Quantum is via Inquiry Learning. ",
        "description": "<p>Informal learning situations where students (school) are guided through optical experiments from statistical optics to quantum optics. Conceptual Change from Classical to Quantum is via Inquiry Learning.&nbsp;</p>\r\n\r\n<p><strong>Additional contact information:</strong> R\u00fcdiger Scholz <a href=\"mailto:r.scholz@iqo.uni-hannover.de\">r.scholz@iqo.uni-hannover.de</a></p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "R\u00fcdiger Scholz",
                "second": "wessnigk@idmp.uni-hannover.de"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Outreach"
        ],
        "lang": [],
        "topic": [
            "Quantum Physics"
        ],
        "org": [
            "Leibniz Universitaet Hannover"
        ],
        "city": [
            "Hannover"
        ],
        "country": [
            "Germany"
        ],
        "target": [
            "Secondary school students"
        ],
        "type": [],
        "id": "b26b8098-b917-4ad3-bb2d-d3bd69c21892"
    },
    {
        "title": "milq - Quantum Physics in High School",
        "summary": "The course focuses on conceptual questions with a minimum of formulas, based on a modern, pragmatic interpretation of quantum mechanics. ",
        "description": "<p>The aim is a conceptually clear formulation of quantum physics. Qualitative \u201creasoning tools\u201d form a \u201cbeginners\u2019 axiomatic system\u201d for quantum mechanics. They help students to predict quantum mechanical effects qualitatively and help to avoid learning difficulties. Currently, this course is given to the teacher students to prepare them for teaching quantum physics at school. It is also used by in-service teachers for teaching secondary school pupils. The online resource is available in German and in English.</p>\r\n\r\n<p>Article about the teaching approach and its validation can be found on https://arxiv.org/abs/2012.15162<br />\r\n<br />\r\n<strong>Additional contact information:</strong> Oxana Mishina <a href=\"mailto:omishina@gmail.com\">omishina@gmail.com</a></p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Rainer M\u00fcller",
                "second": "rainer.mueller@tu-bs.de"
            },
            {
                "first": "Oxana Mishina",
                "second": "omishina@gmail.com"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education"
        ],
        "lang": [
            "English",
            "German"
        ],
        "topic": [
            "Quantum Physics",
            "Teaching"
        ],
        "org": [
            "Braunschweig Technical University"
        ],
        "city": [],
        "country": [
            "Germany"
        ],
        "target": [
            "Primary school teachers",
            "Secondary school teachers",
            "MSc students"
        ],
        "type": [],
        "id": "bebd785e-674c-43a9-84de-084f3dfe1f10"
    },
    {
        "title": "Quantum computing for students",
        "summary": "Training a new generation of software developers for the \u201cQuantum Computers\u201c and the future \"Quantum Internet\". In this course, we are going to introduce this exciting topic using only high school algebra and trigonometry (no complex numbers).",
        "description": "<p>Our&nbsp;<a href=\"https://www.dotquantum.io/academy/\">courses</a>&nbsp;are designed to bring all&nbsp;<em>classical</em>&nbsp;developers closer to the programming world of \u201c<strong>Quantum Computers</strong>\u201c, by providing the basic tools necessary to understand the new paradigm of&nbsp;<em>quantum software development</em>.</p>\r\n\r\n<p>The training and guidance of young people in this emerging field of study are one of the most important motivating factors for us, and for this reason, we have also designed courses for young students (age 15 and older).</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": "Pierpaolo Marturano",
                "second": "pierpaolo.marturano@dotquantum.io"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Programming"
        ],
        "org": [
            "dotQuantum s.r.l.s."
        ],
        "city": [],
        "country": [
            "Italy"
        ],
        "target": [
            "Secondary school students"
        ],
        "type": [],
        "id": "d2a8945c-8263-4fbb-810a-3cac7e5a93de"
    },
    {
        "title": "Quantum Technology at RWTH Aachen University",
        "summary": "The program includes an area of specialization in the physics MSc program (in the future it will be offered in the electrical engineering MSc program). ",
        "description": "<p><span lang=\"EN-US\">The two-year Master's specialization, Quantum Technology (QT), at RWTH Aachen University is a collaboration between its Department of Physics and the Faculty of Electrical Engineering and Information Technology offering theoretical and experimental courses, and a dedicated lab course where theory is put into practice. The students will be also offered cutting-edge research projects and an industrial tie-up for internships. For international students, there\u2019s also an option for the Master's college for the bridging courses, where missing pre-knowledge is imparted.</span><span lang=\"EN-US\">&nbsp;</span><span lang=\"EN-US\">Note that the language of study is English.</span></p>\r\n\r\n<p><span lang=\"EN-US\">The Master's specialization is also one of the strategic measures of the Cluster of Excellence Matter and Light for Quantum Computing (ML4Q) in the field of education and research, and it greatly profits from the close collaborations with experts from J\u00fclich Research Center, Cologne, and Bonn Universities. In the framework of ML4Q, the RWTH Aachen University also awards full two-year QT Master scholarships to two outstanding students. More details can be found at&nbsp;<a href=\"http://www.rwth-aachen.de/mscqt\">www.rwth-aachen.de/mscqt</a>.&nbsp;</span></p>\r\n\r\n<p><span lang=\"EN-US\">Apart from the QT Master specialization, the Department of Physics at RWTH Aachen University is also involved in the industrial education on QT-related courses and the outreach program with local schools on QT-related projects.</span></p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": true,
        "category": "Program",
        "contacts": [
            {
                "first": "Hendrik Bluhm",
                "second": "bluhm@physik.rwth-aachen.de"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Physics"
        ],
        "org": [
            "RWTH Aachen University"
        ],
        "city": [],
        "country": [
            "Germany"
        ],
        "target": [
            "Professionals",
            "Secondary school students",
            "Secondary school teachers"
        ],
        "type": [],
        "id": "c09f5534-a5a6-4530-a4f1-048783babeb5"
    },
    {
        "title": "QuSoft education",
        "summary": "Educational activities both on bachelor and master level in the general area of Quantum Information.",
        "description": "<p>Through the University of Amsterdam, a variety of courses in the general area of Quantum Information are available. They range from introductory to advanced. By including some of these courses in their BSc or MSc study program, students can get ready for research projects (BSc or MSc theses) or PhD studies in the field. Quantum information science is interdisciplinary between Physics, Mathematics, and Computer Science and the optimal choice of courses depends on what has been learned in preceding course work. This page provides a brief guide.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Program",
        "contacts": [
            {
                "first": "Christian Schaffner",
                "second": "c.schaffner@uva.nl"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Quantum Physics"
        ],
        "org": [
            "University of Amsterdam"
        ],
        "city": [],
        "country": [
            "The Netherlands"
        ],
        "target": [
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [],
        "id": "2bf08faf-8d5c-47cf-bbd6-a9ee948163f1"
    },
    {
        "title": "Quantum Technology",
        "summary": "It is a Bachelor's Programme in Science and Technology - Quantum Technology, at Aalto University. ",
        "description": "<p>The compulsory courses introduce students to quantum science and technology, fundamental physics ranging from thermodynamics to electromagnetism, as well as the necessary analytical and numerical tools from mathematics. The elective courses cover advanced topics, such as quantum information processing, computation, communication, and materials science intended for future quantum technologies.</p>\r\n\r\n<ul>\r\n\t<li>The core of the Quantum Technology major includes the following topics:</li>\r\n\t<li>Quantum devices for advanced technologies</li>\r\n\t<li>Quantum information processing, communication, and algorithms</li>\r\n\t<li>Quantum sensing and simulation</li>\r\n\t<li>Nano-scale fabrication of quantum circuits and processors</li>\r\n\t<li>Low-temperature physics and materials science for quantum engineering</li>\r\n\t<li>Theoretical description and understanding of quantum systems</li>\r\n</ul>\r\n\r\n<p>The bachelor's degree (180 ECTS) is composed of basic studies of the program (65 ECTS mathematics, programming, industrial engineering and management, obligatory languages, Aalto studies, orientation), the major in quantum technology (65 ECTS including BSc thesis and seminar), the minor (20-25 ECTS) and elective studies (25-30 ECTS).</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Program",
        "contacts": [
            {
                "first": "Minna G\u00fcnes",
                "second": "minna.gunes@aalto.fi"
            },
            {
                "first": "Mikko M\u00f6tt\u00f6nen",
                "second": "mikko.mottonen@aalto.fi"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Technology"
        ],
        "org": [
            "Aalto University"
        ],
        "city": [],
        "country": [
            "Finland"
        ],
        "target": [
            "BSc students"
        ],
        "type": [],
        "id": "4a967a51-ad3e-4eab-a142-e37cd733405a"
    },
    {
        "title": "Course on Quantum computing",
        "summary": "The module introduces to the concept of quantum computing and the most important quantum algorithms.",
        "description": "<p>The Course on Quantum Computing is a part of Computer Science Master program. Students know the computational model of quantum computing as well as the most important quantum algorithms. They are able to understand new developments in quantum computing, and to specialize to selected topics in quantum computing. &nbsp;<br />\r\n&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": "Bettina Just",
                "second": "bettina.just@mni.thm.de"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [],
        "topic": [
            "Quantum Computing",
            "Programming"
        ],
        "org": [
            "Technische Hochschule Mittelhessen"
        ],
        "city": [],
        "country": [
            "Germany"
        ],
        "target": [
            "BSc students"
        ],
        "type": [],
        "id": "f4e1cd3d-c34d-4333-ba73-14cc8fb25de5"
    },
    {
        "title": "Teacher Trainer Course for Upper Secondary Physics Teacher",
        "summary": "Lecture about the subject of Quantum World - a topic in the secondary school curriculum. ",
        "description": "<p>Every other year we organize a five-session high school teacher training (upper secondary education). The courses have a didactical aspect and inform about new developments in the field. Next course due: autumn 2022.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Henk Buisman",
                "second": "buisman@physics.leidenuniv.nl"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "Dutch"
        ],
        "topic": [
            "Quantum Physics"
        ],
        "org": [
            "Leiden University"
        ],
        "city": [],
        "country": [
            "The Netherlands"
        ],
        "target": [
            "Secondary school teachers"
        ],
        "type": [],
        "id": "e137979a-aed0-4bfc-8ffe-e8a0ca5e9b8b"
    },
    {
        "title": "Quantum Algorithms - Applied Quantum computing as a part of Masters course in Computer Science",
        "summary": "These are master courses highlighting algorithmic aspects of quantum computing, and emphasizing the relevance of quantum computing for practical computing problems.",
        "description": "<p><a href=\"https://studiegids.universiteitleiden.nl/en/courses/98804/quantum-algorithms\">Details about the course 2020-2021</a>.<br />\r\n&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": "Vedran Dunjko",
                "second": "v.dunjko@liacs.leidenuniv.nl"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [],
        "topic": [
            "Quantum Computing"
        ],
        "org": [
            "Leiden University"
        ],
        "city": [],
        "country": [
            "The Netherlands"
        ],
        "target": [
            "BSc students",
            "MSc students"
        ],
        "type": [],
        "id": "ddb6076a-2133-4060-8a63-ce1973bf1149"
    },
    {
        "title": "Material Sciences and nano-objects-nanomat",
        "summary": "SMNO-Nanomat is a research-type M2 program (M2: Master 2nd year), offering a complete high-level training on the structural and electronic properties of condensed matter and nanostructures.",
        "description": "<p>The objective is not only to acquire the theoretical bases allowing a thorough understanding of the materials properties, but also to be trained in advanced experimental and numerical investigation methods, in relation with current scientific topics that can answer to societal challenges (renewable energies, ecology, health, heritage). These themes concern optics, electronics, spintronics, superconductivity, correlated systems, physical chemistry of solids and high-density liquids, exploration of planetary interiors, interaction with the environment, etc. They cover several types of materials and their applications, such as nanostructured materials, 2D materials, thin layers, materials for energy, materials under extreme conditions, glasses, minerals and cultural heritage materials, with a systematic focus on the microscopic phenomena at the origin of their macroscopic properties. The teaching semester in English consists of a series of courses, practical work and digital and bibliographic projects, designed in a coherent and coordinated way, allowing to acquire a solid base of knowledge to realize in the best conditions, starting from February, a full-time research internship in public or private sector research units.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": "Max Marangolo",
                "second": "marangolo@insp.jussieu.fr"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Physics",
            "Quantum Technology"
        ],
        "org": [
            "Sorbonne Universit\u00e9",
            "CNRS"
        ],
        "city": [],
        "country": [
            "France",
            "France"
        ],
        "target": [
            "MSc students"
        ],
        "type": [],
        "id": "9ae3408c-bd5a-4e40-8b56-ea990f34e71c"
    },
    {
        "title": "From Classical Sensors to Quantum Sensors - Practical Physics Courses for Students and Teachers",
        "summary": "A specialized undergraduate lab for students (physics, physics education) and physics teachers.",
        "description": "<p>A specialized undergraduate lab for students (physics, physics education) and physics teachers.</p>\r\n\r\n<p><strong>Additional contact information:</strong> Susanne Wessnigk <a href=\"mailto:wessnigk@idmp.uni-hannover.de\">wessnigk@idmp.uni-hannover.de</a> R\u00fcdiger Scholz <a href=\"mailto:r.scholz@iqo.uni-hannover.de\">r.scholz@iqo.uni-hannover.de</a></p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Susanne Wessnigk ",
                "second": "wessnigk@idmp.uni-hannover.de"
            }
        ],
        "level": [
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [],
        "topic": [
            "Quantum Physics"
        ],
        "org": [
            "Leibniz Universitaet Hannover"
        ],
        "city": [
            "Hannover"
        ],
        "country": [
            "Germany"
        ],
        "target": [
            "Secondary school teachers",
            "BSc students"
        ],
        "type": [],
        "id": "812b5d65-61b2-4217-8b5f-88907275d9ad"
    },
    {
        "title": "Teacher Professional Courses - From Statistical Optics to Quantum Optics",
        "summary": "Development, performance, and evaluation of university training courses and educational concepts; in-service teachers training.",
        "description": "<p>Development, performance, and evaluation of university training courses and educational concepts; in-service teachers training.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Susanne Wessnigk",
                "second": "wessnigk@idmp.uni-hannover.de"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [],
        "topic": [
            "Quantum Physics"
        ],
        "org": [
            "Leibniz Universitaet Hannover"
        ],
        "city": [],
        "country": [
            "Germany"
        ],
        "target": [
            "Professionals",
            "Secondary school teachers",
            "Other (specify)"
        ],
        "type": [],
        "id": "a0d2a3c2-0020-4dba-81f4-c252feca3530"
    },
    {
        "title": "Quantum Technology Enterprise Centre - Incubator for Innovators",
        "summary": "Quantum Technology Enterprise Centre (QTEC) is a world-leading training program and incubator for quantum-based technology innovators.",
        "description": "<p>The QTEC program is a full-time one-year cohort-based pathway with taught courses that cover entrepreneurship, business, and innovation with aspects of systems and design engineering. &nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Program",
        "contacts": [
            {
                "first": "David D May",
                "second": "david.may@bristol.ac.uk"
            }
        ],
        "level": [
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [],
        "topic": [
            "Quantum Technology",
            "Innovation & Entrepreneurship"
        ],
        "org": [
            "University of Bristol"
        ],
        "city": [],
        "country": [
            "United Kingdom"
        ],
        "target": [
            "Entrepreneurs",
            "Professionals",
            "Technicians",
            "PhD students"
        ],
        "type": [],
        "id": "07e3134b-0145-4174-a298-c54554d64310"
    },
    {
        "title": "Quantum Mechanics for teacher students",
        "summary": "This is an experimental one-semester course offered to the teacher-students at the physics education department, that accounts for their different initial preparation in mathematics and physics and for the professional needs.",
        "description": "<p>In Germany, Theoretical Quantum Physics is an obligatory course for the physics teacher-students, and they typically attend it together with the physics students. This is an experimental one-semester course offered to the teacher-students at the physical education department, which accounts for their different initial preparation in mathematics and physics and for their professional needs.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": "Oliver Bodensiek",
                "second": "o.bodensiek@tu-bs.de"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education"
        ],
        "lang": [
            "German"
        ],
        "topic": [
            "Quantum Physics",
            "Teaching"
        ],
        "org": [
            "Braunschweig Technical University"
        ],
        "city": [],
        "country": [
            "Germany"
        ],
        "target": [
            "Secondary school teachers",
            "MSc students"
        ],
        "type": [],
        "id": "526431bc-8946-4708-9af9-d5153c00b3c8"
    },
    {
        "title": "MSc Quantum Engineering",
        "summary": "The Master of Science in Quantum Engineering offers an education program at the forefront of quantum physics, electrical engineering, and information technology. ",
        "description": "<p>The first two semesters are devoted to classroom course work. The main focus during the second semester is on the industry internship which can be substituted by a quantum engineering laboratory project. During the third semester, students finish remaining coursework, while a semester project is a first independent research project. The fourth semester is fully reserved for the final Master's Thesis. &nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": "George Tudosie",
                "second": "tudosieg@phys.ethz.ch"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [],
        "topic": [
            "Quantum Technology",
            "Engineering"
        ],
        "org": [
            "ETH (Eidgen\u00f6ssische Technische Hochschule)"
        ],
        "city": [],
        "country": [
            "Switzerland"
        ],
        "target": [
            "MSc students"
        ],
        "type": [],
        "id": "380c0217-2460-4c35-96ee-ec8b35d2cba7"
    },
    {
        "title": "Online course on quantum computing",
        "summary": "Lectures at Goethe University, winter 2020/21",
        "description": "<p>This is an introductory online course on quantum computing at Goethe University in the winter semester 2020/21. T<br />\r\nopics covered include:<br />\r\nPep Talk: Why Quantum Computing is \u201eHot\u201c Quantum Theory in a Nutshell Gates and Circuits Universality Measurement-Based Computation Deutsch-Jozsa Algorithm Ground States and Classical Optimization Simulation High-Precision Measurement Classical Information Quantum Information Cryptography Superdense Coding and Teleportation.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": "Jochen Rau",
                "second": "jochen.rau@q-info.org"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Physics",
            "Quantum Technology",
            "Teaching"
        ],
        "org": [
            "Goethe University"
        ],
        "city": [],
        "country": [
            "Germany"
        ],
        "target": [
            "BSc students",
            "MSc students"
        ],
        "type": [],
        "id": "371bad96-01e5-4f24-a91f-5ea383865fd8"
    },
    {
        "title": "Quantum-enhanced Sensing via Quantum Control (QuSCo)",
        "summary": "QuSCo strives to develop a best practice for PhD training in emerging quantum technologies using the example of quantum-enhanced sensing via quantum control, by providing cross-sectional and interdisciplinary training to its fellows.",
        "description": "<p>QuSCo exposes its students, at the same time, to fundamental questions of quantum mechanics and practical issues of specific applications. Albeit challenging, this reflects our view of the best possible training that the field of quantum technologies can offer. Training in scientific skills is based on the demonstrated tradition of excellence in research of QuSCo\u2019s PIs. It is complemented by training in communication and commercialization. The latter builds on strong industry participation whereas the former on existing expertise on visualization and gamification, combining it with more traditional means of outreach to realize target audience-specific public engagement strategies.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": "Christiane Koch",
                "second": "christiane.koch@fu-berlin.de"
            }
        ],
        "level": [
            "Higher education",
            "Outreach"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Physics",
            "Quantum Sensing",
            "Quantum Technology",
            "Engineering"
        ],
        "org": [
            "Freie Universit\u00e4t Berlin"
        ],
        "city": [],
        "country": [
            "Germany"
        ],
        "target": [
            "PhD students"
        ],
        "type": [],
        "id": "16e17124-3427-4c0f-9d54-8f3da7952102"
    },
    {
        "title": "Physics of Quantum Technologies",
        "summary": "Master program on the physics of quantum technologies",
        "description": "<p>Tailored Master curriculum on the Physics of Quantum Technologies within the Master program in Physical Sciences, with a wide spectrum of courses covering all aspects of Quantum Technologies (from Quantium Computation and Information to Foundations of Quantum Physics, Quantum Thermodynamics, Quantum Communications, Quantum Simulations and Applications in Photonics Systems, Integrated Optics and Quantum Nanostructures) &nbsp;<br />\r\n&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Program",
        "contacts": [],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English",
            "Italian"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Metrology",
            "Quantum Physics",
            "Quantum Sensing",
            "Quantum Simulation",
            "Quantum Technology"
        ],
        "org": [
            "University of Pavia"
        ],
        "city": [
            "Pavia"
        ],
        "country": [
            "Italy"
        ],
        "target": [
            "BSc students",
            "MSc students"
        ],
        "type": [],
        "id": "c0ec5b28-13d6-4cbd-9a0d-69572f77cece"
    },
    {
        "title": "Didactic Innovation in Physics and Guidance (IDIFO)",
        "summary": "IDIFO is a biannual master program for physics teachers created by the University of Udine in cooperation with 20 Italian University. It is running and developing starting from 2006.",
        "description": "<p>In IDIFO master program&nbsp; 60cts were offered to Italian teachers by means of a web platform every two years from 2006 to 2020. The different Universities cooperating offered 3-4 modules of 2cts on teaching/learning Quantum Physics. Four different proposals were compared in many ways during the Master activities. Materials produced for the master program on teaching/learning proposals for Quantum Physics in secondary school are <a href=\"http://www.fisica.uniud.it/URDF/laurea/materiali/index.htm\">available online</a>.</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": "Marisa Michelini",
                "second": "marisa.michelini@uniud.it"
            }
        ],
        "level": [
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "Italian"
        ],
        "topic": [
            "Quantum Physics",
            "Teaching"
        ],
        "org": [
            "University of Udine"
        ],
        "city": [],
        "country": [
            "Italy"
        ],
        "target": [
            "Secondary school teachers"
        ],
        "type": [],
        "id": "da51f2f5-1922-432a-a96f-0f434f4675b1"
    },
    {
        "title": "Minor Applied Quantum Computing",
        "summary": "Students learn to program a Quantum Computer, about the hardware available, how to detect problems which gain by the use of Quantum Computing and to develop solutions for real world problems.",
        "description": "<p>In recent years an enormous progress in the field of Quantum Computing has taken place. Although a commercial available Quantum Computer is not expected within five years companies want to be ready in case it will be. Furthermore, the possibility to decrypt by a Quantum Computer foreshadows the need to be Quantum Secure. The minor Applied Quantum Computing offers several courses on Quantum Computing and real world projects initiated by companies. The program entails courses and projects adding up to 30 ects. <a href=\"https://minoren.mijnhva.nl/2020-2021/applied-quantum-computing\">Website for intranet (login required)</a> &nbsp; &nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Program",
        "contacts": [
            {
                "first": "Marten Teitsma",
                "second": "m.teitsma@hva.nl"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing"
        ],
        "org": [
            "Amsterdam University of Applied Sciences"
        ],
        "city": [],
        "country": [
            "The Netherlands"
        ],
        "target": [
            "BSc students"
        ],
        "type": [],
        "id": "badd2f69-2dab-482c-98e9-18c8f7fdfb91"
    },
    {
        "title": "Online course \"Quantum for everyone\"",
        "summary": "The online course to learn a practical approach to quantum technologies for you and your business.",
        "description": "<p>Quantum technologies are not only for physicists. \u201cQuantum for Everyone\u201d, a new online course designed by QURECA\u2018s experts for non-specialists, will help you understand quantum technologies and spot opportunities to apply quantum technologies to problems in your own organization. If you are a non-technical business professional, \u201cQuantum for Everyone\u201d will help you understand how to build a sustainable quantum strategy. If you are a quantum software developer or a quantum engineer, this is the course to ask your manager, VP or CEO to take if you want them to understand what you can \u2013 and cannot ! \u2013 do.<br />\r\n&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": "Araceli Venegas-Gomez",
                "second": "araceli.venegas-gomez@qureca.com"
            }
        ],
        "level": [
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Technology",
            "Business",
            "Programming",
            "Soft Skills"
        ],
        "org": [
            "Qureca"
        ],
        "city": [],
        "country": [
            "United Kingdom"
        ],
        "target": [
            "Entrepreneurs",
            "Managers",
            "Professionals"
        ],
        "type": [],
        "id": "4b99ce3e-9a1a-4b69-aa07-9cb30ed60231"
    },
    {
        "title": "Introduction to Quantum Technologies",
        "summary": "This introduction course about different quantum technologies in maid for PhD students of scientific area, not only in physics.",
        "description": "<p>The Second Quantum Revolution is unfolding now, exploiting the enormous advancements in our ability to detect and manipulate single quantum objects and triggering the development of the different Quantum Technologies. New perspectives and opportunities are opening for researchers in any scientific discipline.&nbsp; The course Introduction to Quantum Technologies, issued by the PhD program in Physics and Astrophysics, in collaboration with the European Project QTEdu, is intended to give an introduction to the different quantum technologies to PhD students attending any scientific PhD program, not only in physics. The course will be held in English at distance in April-May 2021 once a week. <strong>To attend the course</strong>, please contact the coordinator Prof. Giuliano Benenti:&nbsp; giuliano.benenti@uninsubria.it Supporting material to the lectures will be made available in advance,&nbsp;but preliminary self-study is not mandatory. Program 1-2) Introduction to the formalism G. Benenti (Uninsubria)/M. Bondani (CNR-IFN) 6 hours 3) Quantum Computing F. Chiarello (CNR-IFN) 3 hours 4) Quantum Communication G. Vallone (Unipd) 3 hours 5) Quantum Simulations S. Montangero (Unipd) 3 hours 6) Quantum Metrology I. Degiovanni/M. Genovese (INRIM) 3 hours 7) Quantum Algorithms D. Tamascelli (Unimi) 3 hours 8) Quantum Machine Learning F. Tacchino (IBM) 3 hours &nbsp;<br />\r\n&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": "Giuliano Benenti",
                "second": "giuliano.benenti@uninsubria.it"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Metrology",
            "Quantum Simulation",
            "Quantum Technology"
        ],
        "org": [
            "Universit\u00e0 degli Studi dell'Insubria"
        ],
        "city": [],
        "country": [
            "Italy"
        ],
        "target": [
            "PhD students"
        ],
        "type": [],
        "id": "9048aca4-8cc8-4818-beff-611696eb468a"
    },
    {
        "title": "Master of Computer Science - Quantum Information (IQ)",
        "summary": "Sorbonne University opens the first master program dedicated to Quantum Information in Paris! This program is supported by the Quantum Information Center Sorbonne (QICS), the Computer Science Master Department, in collaboration with the School of Physics. Experts from LIP6, LKB and INRIA will teach recent research results in quantum algorithms, quantum cryptography, photonic quantum computing and quantum information theory.",
        "description": "<p>Sorbonne University opens the first master program dedicated to Quantum Information in Paris! This program is supported by the Quantum Information Center Sorbonne (QICS), the Computer Science Master Department, in collaboration with the School of Physics. Experts from LIP6, LKB and INRIA will teach recent research results in quantum algorithmics, quantum cryptography, photonic quantum computing, and quantum information theory. This program will open in 2021 and will be mainly given in English for an international student audience. It will provide a master's degree in Computing Science with a specialization in Quantum Computing for graduate students in computer science with a strong interest in physics.<br />\r\n&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Program",
        "contacts": [
            {
                "first": "Fr\u00e9d\u00e9ric Grosshans",
                "second": "qics@sorbonne-universite.fr"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English",
            "French"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Programming"
        ],
        "org": [
            "Sorbonne Universit\u00e9"
        ],
        "city": [],
        "country": [
            "France"
        ],
        "target": [
            "MSc students"
        ],
        "type": [],
        "id": "03080325-16c0-498b-b984-308c3a5704e7"
    },
    {
        "title": "Workshop General Awareness Quantum Computing",
        "summary": "A 3.5-hour workshop for business professionals to develop a clear view of the possibilities and threats of Quantum Technology. No math, but a clear focus on the impact on business operations.",
        "description": "<p>The workshop General Awareness Quantum Computing introduces you to the general principles of quantum computing and how such a computer can be used.<br />\r\nThe workshop aimed at an audience that could use Quantum Technology at their organization; we expect no prior knowledge of quantum physics, but basic experience with everyday computers and business operations. When done, you will have a general understanding of the possibilities and threats, and what to expect of quantum computers in the future.</p>\r\n\r\n<p>Duration: 3.5-hours Can be booked individually on the last Friday of each month, from 13:00 \u2013 16:30, or for a private group of 15-25 people (date and time will be discussed).<br />\r\nThe workshop is given online using Cisco Webex or MS Teams. English language is used. Registration for the workshop can be done via the <a href=\"https://www.quantum.amsterdam/workshop-general-awareness-quantum-computing/\">online form</a>.<br />\r\nAfter registration, we will confirm your booking and contact you about payment information.</p>\r\n\r\n<p>Price: \u20ac 100, plus (optional) \u20ac 25 for a final test + certification. Prices are excluding 21% VAT (in Dutch: BTW).<br />\r\n&nbsp;</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Koen Groenland",
                "second": "education@quantum.amsterdam"
            }
        ],
        "level": [
            "Lifelong learning and (re)training",
            "Outreach"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Information",
            "Quantum Technology",
            "Business",
            "Soft Skills"
        ],
        "org": [
            "Quantum.Amsterdam"
        ],
        "city": [],
        "country": [
            "The Netherlands"
        ],
        "target": [
            "Entrepreneurs",
            "Managers",
            "Investors",
            "Professionals",
            "Technicians"
        ],
        "type": [],
        "id": "37b7be0c-4fe3-400d-ad08-e3c0706c39c4"
    },
    {
        "title": "MCQST Summer Student Program - ONLINE",
        "summary": "The MCQST Summer Bachelor Program provides undergraduate students worldwide the opportunity to gain an insight into research in Quantum Science and Technology (QST) at the Munich Center for Quantum Science and Technology and its participating institutes.",
        "description": "<p>After an introductory week featuring a retreat in the Bavarian Alps, you will work on a project of our research groups. An early-career researcher (PhD student or Postdoc) will serve as your mentor and personal contact, introducing you to your project and supervising it. You will be fully integrated into the research group, allowing you to experience the processes and challenges of cutting-edge research in QST. In addition, cultural and social activities give you a taste of life in Munich. By the end of the program, you will have gained first-hand expert knowledge in quantum science and technology and a familiarity with the Munich research environment.<br>MCQST focuses on specific research directions: quantum information theory, quantum simulations, quantum computing, quantum communication, quantum metrology and sensing, quantum matter, and interdisciplinary explorative directions.<br>Eligibility: Bachelor students enrolled in an undergraduate degree in physics, mathematics, computer science, electrical engineering, material science, or chemistry.<br>Application phase starts in fall each year. Find out more information and how to apply here: mcqst.de/summer.<br />\r\n-----------------------------------<br />\r\nOrganization name:<br />\r\n-----------------------------------<br />\r\nProgram target: Other,Training modules<br />\r\n-----------------------------------<br />\r\nProgram country: Germany<br />\r\n-----------------------------------</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Barbara Tautz",
                "second": "info@mcqst.de"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Quantum Metrology",
            "Quantum Physics",
            "Quantum Sensing",
            "Quantum Simulation",
            "Quantum Technology",
            "Soft Skills"
        ],
        "org": [
            "Munich Center for Quantum Science and Technology"
        ],
        "city": [],
        "country": [
            "Germany"
        ],
        "target": [
            "BSc students"
        ],
        "type": [],
        "id": "c13c1199-3f50-4f97-9b9a-6b75d9dd13fb"
    },
    {
        "title": "Introduction to Quantum Computing and Quantum Hardware",
        "summary": "This course is an introduction to the world of quantum computing, with an exploration of some of the key quantum algorithms and their implementations using quantum circuits, as well as the quantum hardware that is designed to run these algorithms. The course was first offered during the Qiskit Global Summer School in July 2020 as a two-week intensive summer school.",
        "description": "<p>This course is an introduction to the world of quantum computing, with an exploration of some of the key quantum algorithms and their implementations using quantum circuits, as well as the quantum hardware that is designed to run these algorithms. The course was first offered during the Qiskit Global Summer School in July 2020 as a two-week intensive summer school. There are 27 lectures in this course, which cover the material in 9 lecture notes and 9 associated labs.<br />\r\nThe textbook for the course is available online: Learn Quantum Computation using Qiskit.<br />\r\nPrerequisites: In order to make the best out of these lectures, we strongly recommend reviewing linear algebra and brushing up on Python. &nbsp;<br />\r\n<br />\r\n<br />\r\n&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Fabio Scafirimuto",
                "second": "fas@zurich.ibm.com"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Programming"
        ],
        "org": [
            "IBM"
        ],
        "city": [],
        "country": [
            "United States"
        ],
        "target": [
            "BSc students",
            "MSc students"
        ],
        "type": [],
        "id": "116b8e3c-ffb8-4b50-b4c4-6dd0262f0bca"
    },
    {
        "title": "Quantum Devices Master program",
        "summary": "Quantum Devices is a second-year master's program giving a high-level theoretical and experimental training on different kind of quantum phenomena with particular attention to quantum devices and nanotechnologies.",
        "description": "<p>'Quantum Devices\u2019 is a training for the students having validated the first year of a master\u2019s degree; the objective of this master\u2019s degree is to provide a very high level of theoretical and experimental training on several types of quantum phenomena with particular emphasis on the many devices that result from them. This largely transversal field touches on several disciplines, from physics to chemistry, from materials science to biology. In this field, fundamental and applied researches enrich each other: theoretical advancements are accompanied by progress in material science (creation of new materials, control of their elaboration) and by the realization of new and unique experimental techniques. These advancements, awarded with several Nobel prizes, have had important consequences in fundamental physics; today we are able to observe and manipulate single atoms or conceive complex quantum devices at the nanometer scale: semiconductor sources and detectors, molecular transistor, superconducting circuits for quantum information, hard disks based on giant magnetoresistance, transistor made from two-dimensional materials\u2026. The program is offered by the Universit\u00e9 de Paris in partnership with the Ecole Polytechnique and in a double degree agreement with the Ecole d\u2019Ing\u00e9nieur Denis Diderot (EIDD). It is also part of the international double degree master program \u2018Nanotechnologies and Quantum Devices\u2019 in partnership with the Politecnico of Turin (Italy). Students receive a state of the art training in nanofabrication and nanocharacterization, thanks to access to the cleanroom of the Universit\u00e9 de Paris and the dedicated nanoscience teaching platform equipped with top-level facilities. The training relies on the participation of high-level scientists from Ile de France laboratories working in the domain of quantum devices. Thanks to this well-established network, students find many opportunities after graduation both in academics as well as in the industrial sector. After the master\u2019s degree, most of the students begin a PhD thesis in a research laboratory (public or private). Thanks to this versatile training, both theoretical and applied, students, will be able to quickly integrate both a public research organization (after a PhD thesis) or an industrial Research and Development group.&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Program",
        "contacts": [
            {
                "first": "Maria Luisa Della Rocca",
                "second": "maria-luisa.della-rocca@u-paris.fr"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Quantum Physics",
            "Quantum Simulation",
            "Quantum Technology"
        ],
        "org": [
            "Universit\u00e9 de Paris"
        ],
        "city": [],
        "country": [
            "France"
        ],
        "target": [
            "MSc students"
        ],
        "type": [],
        "id": "e1d3e194-1bcb-40fa-bf31-183086874dae"
    },
    {
        "title": "Quantum Technologies - PhD",
        "summary": "Doctoral program Quantum Technologies is open in Czech and English language from the academic year 2020/2021.",
        "description": "<p>Doctoral program Quantum Technologies is a multidisciplinary program that targets the education of top experts engaged in the research and scientific-technical practice in the fields of quantum technologies, especially quantum physics, information and communications, quantum optics, lasers, solids, nanomaterials, nanostructures, and advanced characterization and modeling methods. A unique feature of the doctoral program is the emphasis on synergies between the highly specialized fields of quantum science. Study in the program is closely linked with scientific-research activities of the research groups at the Faculty of Nuclear Sciences and Physical Engineering, Czech Technical University in Prague, and the collaborating institutions (particularly institutes of Academy of Sciences of Czech Republic). Doctoral program Quantum Technologies provide scientific education to talented students who have a solid educational foundation in the master's programs focusing on theoretical and applied physics, applied mathematics and computer science, physical electronics, physics and engineering of solids and materials characterization, and further extends and depends this foundation \u2013 on an interdisciplinary basis \u2013 onto more advanced and / or specific disciplines. Graduate students of the program will be equipped with a deep theoretical knowledge of physics, mathematics and computer science, as well as specialized skills in the areas of quantum physics, quantum information theory, physics of solids and surfaces, optics and photonics, lasers, mathematical modeling, and preparation and characterization of nanostructures. &nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Program",
        "contacts": [
            {
                "first": "Martin \u0160tefa\u0148\u00e1k",
                "second": "martin.stefanak@fjfi.cvut.cz"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English",
            "Czech"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Quantum Physics",
            "Quantum Sensing",
            "Quantum Simulation",
            "Quantum Technology"
        ],
        "org": [
            "Czech Technical University in Prague, Faculty of Nuclear Sciences and Physical Engineering"
        ],
        "city": [],
        "country": [
            "Czech Republic"
        ],
        "target": [
            "PhD students"
        ],
        "type": [],
        "id": "65cf3f61-e091-4bd7-be7e-487f23f24f10"
    },
    {
        "title": "Quantum Technologies - bachelor's",
        "summary": "Bachelor's program on Quantum Technologies is open for study in the Czech language from the academic year 2020/2021 at the Faculty of Nuclear Sciences and Physical Engineering, Czech Technical University in Prague. We plan to open the study program in English in the forthcoming years.",
        "description": "<p>The degree course is of interdisciplinary character, covering classical and modern sections of mathematics, physics, and informatics. It prepares students for jobs in physics, natural sciences, and engineering and for use of modern computational methods. The degree course structure is based on core courses on mathematics, i.e. calculus; linear algebra; linear equations; differential equations; probability theory and statistics; equations of mathematical physics, and functions of complex variables. Physics courses cover an introduction to mechanics, electricity and magnetism, thermodynamics, waves and optics, and theoretical and statistical physics. However, the core of the degree program is quantum physics. Apart from theory, students get practical hands-on training in physics labs, solid-state physics labs, laser labs, and linear optics labs. Graduate\u00b4s Profile Knowledge: Graduates are versed in the core disciplines of mathematics, physics, and informatics, and even more specialized in quantum physics, and physics of solids and lasers, both theoretically and practically. Skills: They are skilled in using various calculation methods and procedures of mathematics and physics to tackle - both theoretically and practically \u2013 engineering research and scientific issues of quantum theory, theory of solids, and physics and technology of lasers. They are skilled in modern computational methods and laboratory equipment. &nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Program",
        "contacts": [
            {
                "first": "Martin \u0160tefa\u0148\u00e1k",
                "second": "martin.stefanak@fjfi.cvut.cz"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "Czech"
        ],
        "topic": [
            "Quantum Physics",
            "Quantum Technology"
        ],
        "org": [
            "Czech Technical University in Prague, Faculty of Nuclear Sciences and Physical Engineering"
        ],
        "city": [],
        "country": [
            "Czech Republic"
        ],
        "target": [
            "BSc students"
        ],
        "type": [],
        "id": "34b22747-6662-4b07-802d-9af455cd4d23"
    },
    {
        "title": "Quantum Technologies - master's",
        "summary": "The multidisciplinary Continuation Master Course Quantum Technologies is open from the academic year 2020/2021 at the Faculty of Nuclear Sciences and Physical Engineering, Czech Technical University in Prague. Its aim is to educate experts in quantum information and communication, quantum optics, physics and technologies of lasers, solid-state physics, and nanomaterials.",
        "description": "<p>Graduate\u00b4s Profile Knowledge: Graduates will acquire a great knowledge of modern parts of physics, particularly of quantum theory, solid-state physics, and laser physics, and, with a view to their specialization, also of quantum optics, quantum information, lasers, or physics of nanomaterials. Skills: Graduates are skilled in using methods and tools of modern parts of mathematics and physics to solve theoretical and real engineering research and scientific problems of quantum theory, quantum optics, quantum theory of information, theory of solids, and physics laser technology. They are able to use modern technology and laboratory instrumentation, follow new trends in their respective field and promptly orient themselves in interdisciplinary issues, analyze problems and synthesize results.&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Program",
        "contacts": [
            {
                "first": "Martin \u0160tefa\u0148\u00e1k",
                "second": "martin.stefanak@fjfi.cvut.cz"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Quantum Physics",
            "Quantum Simulation",
            "Quantum Technology"
        ],
        "org": [
            "Czech Technical University in Prague, Faculty of Nuclear Sciences and Physical Engineering"
        ],
        "city": [],
        "country": [
            "Czech Republic"
        ],
        "target": [
            "MSc students"
        ],
        "type": [],
        "id": "46c8bf39-7e88-4095-9f65-386604515dd4"
    },
    {
        "title": "Quantum Science and Nanomaterials International Graduate School",
        "summary": "The QMat \u201cinitiative of excellence\u201d is an international integrated MSc and PhD program of the University of Strasbourg, which prepares the next generation of scientists and engineers to shape the future in quantum science and nanotechnology.",
        "description": "<p>The continuing miniaturization and integration of information technologies requires a better understanding and control of the quantum nature of matter that becomes dominant at the (sub) nm scale. By exploiting quantum effects, such as coherence and entanglement, we can create new and innovative devices and materials that will shape the future of technology and positively impact society as a whole. The QMat \u201cinitiative of excellence\u201d (qmat.unistra.fr) is an international integrated MSc and PhD program of the University of Strasbourg, which prepares the next generation of scientists and engineers to shape the future in quantum science and nanotechnology. We provide a challenging and engaging curriculum spanning fundamental and applied aspects and put students at the forefront of international research at the interfaces between physics, material science, chemistry and engineering. The QMat program brings together four cross-disciplinary research institutes and five specializations at the M2 (second year master) level combined with extended research projects. The program is taught in the English language. As a QMat student you will learn from world leading experts in fundamental and applied quantum science and nanotechnology and profit from enhanced networking opportunities including international and industrial internships. We are announcing up to 15 \u201cQ-Master\" scholarships at both the M1 (first year) and M2 (second year) Master levels for outstanding candidates with a BSc degree (or equivalent). Applications open in January/February (international students) and April/May each year (local and EU students). &nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": true,
        "category": "Program",
        "contacts": [
            {
                "first": "Alena Gradt (Project Manager)",
                "second": "qmat@unistra.fr"
            }
        ],
        "level": [
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Physics",
            "Quantum Technology"
        ],
        "org": [
            "University of Strasbourg"
        ],
        "city": [],
        "country": [
            "France"
        ],
        "target": [
            "Professionals",
            "Technicians",
            "MSc students",
            "PhD students"
        ],
        "type": [],
        "id": "675e314d-eb30-429c-8b77-67e46865e6f9"
    },
    {
        "title": "QPlayLearn - Quantum e-learning programmes for companies",
        "summary": "Qplaylearn\u2019s Customized Online Programmes are tailor-made corporate learning solutions that provide a perfect blend of top academic research, cutting-edge digital technology, and best-in-class pedagogical design. \r\nUsing innovative learning techniques, we design solutions for all levels of your organization \u2013 from the board and C-suite right through multiple leadership levels, so that new behaviours and mindsets cascade throughout the organization to enable continued transformation. We partner with your organization to create a learning solution directly tied to your organization\u2019s strategic objectives.These highly customized solutions allow organizations to reach a large number of employees across the world in an efficient, impactful and cost-effective way. The resulting learning is not only engaging and thought provoking, but also practical, convenient and \u2013 above all \u2013 immediately applicable.",
        "description": "<p>Algorithmiq is a startup developing quantum algorithms to tackle complex problems in life sciences. We also develop and offer e-learning courses on quantum technologies for companies. &nbsp;<br />\r\n&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Sabrina Maniscalco",
                "second": "sabrina@algorithmiq.fi"
            }
        ],
        "level": [
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Technology",
            "Business",
            "Teaching"
        ],
        "org": [
            "Algorithmiq Ltd"
        ],
        "city": [],
        "country": [
            "Finland"
        ],
        "target": [
            "Entrepreneurs",
            "Managers",
            "Investors",
            "Professionals",
            "Technicians"
        ],
        "type": [],
        "id": "69791e4a-817c-47c9-8d78-a72b8e9a057a"
    },
    {
        "title": "Master in Quantum Science and Technology @ Barcelona",
        "summary": "The Master in Quantum Science and Technologies is aimed at graduates in Physics, Physical Engineering or equivalent degrees who want to continue specialization studies in Quantum Science and Technologies. The master provides access to 60+ cutting-edge theoretical and experimental research groups across 3 universities and 4 research centres, working on quantum sensing, communication, computing and simulation, fields aligned with major pillars of the European Quantum Flagship. The program is taught by 30+ expert professors, and covers the core concepts of quantum science & technology, as well as practical tools and techniques. Engagement with industry is prominent, with high-tech companies actively participating in teaching, offering internships, seminars and a careers symposium. The program provides access to PhD programs at the participating institutes, and will advance the future careers of students interested in working in academia or industry in this exciting and fast-moving field.",
        "description": "<p>The master provides advanced knowledge to develop cutting-edge research both theoretical and experimental in quantum simulation, quantum computing, quantum sensors, quantum communications, as well as in purely formal theoretical aspects. Various universities, research centers and companies actively participate in teaching the master's degree. The master's degree in Quantum Science and Technology is the result of the coordinated effort of the University of Barcelona, the Autonomous University of Barcelona, the Polytechnic University of Catalonia, the Institute of Photonic Sciences, the Barcelona Supercomputing Center, the Institute of High Energy Physics and the Catalan Institute of Nanoscience and Nanotechnology. It arises in parallel to the establishment of the emerging community in Quantum Technologies, QuantumCat. SYLLABUS Students entering the Master are required to take the Quantum Core courses covering advanced quantum mechanics, condensed matter theory, and quantum information theory. After that, students may build their own path through the master, selecting elective courses from one or more of the following tracks: Quantum Theory: designed for students with a background in theory and mathematics, with advanced courses on theoretical topics related to quantum information, communications and sensing. Quantum Software: designed for students with a computational background, with courses on cutting-edge numerical and computational techniques Quantum Hardware: designed for students with an experimental focus, these courses have a practical focus on experimental techniques and cutting-edge quantum technologies. Quantum Optics: these are theoretical and experimental courses offered in conjunction with the Master in Photonics, for students interested in quantum optics, atom-light interaction, and their applications. Strong links with industry are embedded into the program. All students are required to take a course on Entrepreneurship &amp; Innovation, and the program offers opportunities to undertake an Internship with a local company or research group. Topical Seminars from researchers and companies, and an Annual Career Symposium, will enhance the link to industry and expose students to a wide range of career paths and potential employers. PHD STUDIES Students who complete the master program and wish to continue their studies towards a research career may apply to several PhD programs: PhD in Physics, UB PhD in Physics, UAB PhD in Computational and Applied Physics, UPC PhD in Photonics, ICFO FELLOWSHIPS Several fellowships are available for students joining the master program: ICCUB Maria de Maeztu Fellowship covering full registration fees ICN2 Internship providing a living allowance for a student undertaking their Masters Thesis with an ICN2 research group ICFO Student Research Fellowship providing a living allowance for a student undertaking their Masters Thesis with an ICFO research group SPIE@ICFO Maria Yzuel Fellowship Award providing a living allowance for a student undertaking their Masters Thesis with an ICFO research group COMPANIES Students enrolled in the master will have the opportunity to have \ufb01rst hand contact with local and international companies working on Quantum Technologies through a variety of activities, including Internships, Topical Seminars, and an Annual Career Symposium. &nbsp;<br />\r\n&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Program",
        "contacts": [
            {
                "first": "Bruno Julia Diaz",
                "second": "brunojulia@ub.edu"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Quantum Metrology",
            "Quantum Physics",
            "Quantum Simulation",
            "Quantum Technology",
            "Soft Skills"
        ],
        "org": [
            "University of Barcelona"
        ],
        "city": [],
        "country": [
            "Spain"
        ],
        "target": [
            "MSc students",
            "PhD students"
        ],
        "type": [],
        "id": "a3e3539c-57fe-46f2-8fb0-9bbbd7226fbe"
    },
    {
        "title": "Materials Physics and Quantum Technology major \u2013 Master's Programme in Engineering Physics",
        "summary": "Studies focus on either experimental physics or theoretical physics and modeling with emphasis on technology applications or basic research. Specializing in nanomaterials, solid-state applications of quantum technology, or purely theoretical physics related to the most pressing questions in modern solid-state physics and quantum technology.The program delivers profound understanding of physics and mathematics as well as skills that are highly applicable.  Language of instruction: English",
        "description": "<p>The Materials Physics and Quantum Technology major is offered as a long major, and as a compact major. The compact major forms the core content for the long major. The pertaining courses cover important topics for engineering physics, and methods from computational, theoretical, and experimental physics. The compact major includes also some choices for more detailed focusing on a certain subject. The rest of the studies in the long major have a flexible structure, and provide the student with the possibility of focusing in physics, nanoscience, or designing a more cross-disciplinary content for the long major.</p>\r\n\r\n<p>Further details on the major: <a href=\"https://into.aalto.fi/display/enengphys/Materials+Physics+and+Quantum+Technology+major\">https://into.aalto.fi/display/enengphys/Materials+Physics+and+Quantum+Technology+major</a></p>\r\n\r\n<p>Additional contact for further information:<br />\r\nProf. Mika Sillanp\u00e4\u00e4: <a href=\"https://www.aalto.fi/en/people/mika-sillanpaa\">https://www.aalto.fi/en/people/mika-sillanpaa</a>&nbsp; &nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": "Minna G\u00fcnes",
                "second": "minna.gunes@aalto.fi"
            },
            {
                "first": "Mika Sillanp\u00e4\u00e4",
                "second": "mika.sillanpaa@aalto.fi"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Quantum Metrology",
            "Quantum Physics",
            "Quantum Sensing",
            "Quantum Simulation",
            "Quantum Technology",
            "Engineering",
            "Soft Skills"
        ],
        "org": [
            "Aalto University"
        ],
        "city": [],
        "country": [
            "Finland"
        ],
        "target": [
            "MSc students"
        ],
        "type": [],
        "id": "10a00720-265f-49f7-9806-147a28d8eb42"
    },
    {
        "title": "Quantum Computing Specialization, master in Data Science and Scientific Computing",
        "summary": "A curriculum in Quantum computing and information in the Master Program in Scientific and Data-Intensive Computing (SDIC).",
        "description": "<p>It trains students in classic modeling, programming, statistics, and machine learning in the first year and digs into quantum computing and information in the second year. In collaboration with the physics department of the University of Trieste (UniTS) and with the International Center for Theoretical Physics  (ICTP). More details about the study plan are <a href='https://sdic.units.it/index.php/curriculum-quantum-computing/'>here</a>.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Program",
        "contacts": [
            {
                "first": "Luca Manzoni",
                "second": "lmanzoni@units.it"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Information"
        ],
        "org": [
            "University of Trieste"
        ],
        "city": [],
        "country": [
            "Italy"
        ],
        "target": [
            "MSc students"
        ],
        "type": [],
        "id": "ce3fe7bc-473d-4b2a-aec7-8ae69bb4763a"
    },
    {
        "title": "Master in Quantum Science & Technology",
        "summary": "Quantum Science & Technology is a broad, interdisciplinary field of contemporary science spanning a wide range of scientific areas with a high potential for the development of future information, sensing and computing technologies. Major research thrusts are, for example, Quantum Computing, Quantum Sensing, Quantum Simulation, Quantum Materials and Quantum Cryptography to name but a few. The research field is firmly grounded on the basic understanding of the principles of quantum mechanics, but also relies on developments in neighboring research areas such as mathematics, information technology, electrical engineering and chemistry. It is for this reason that the two Munich Universities \u2013 Technical University of Munich and Ludwig-Maximilians-University Munich \u2013 have joined their forces to establish the interdisciplinary Master\u2019s study program \u201cQuantum Science & Technology\u201c (QST). Students particularly benefit from the research environment provided by the Excellence cluster Munich Center for Quantum Science and Technology (MCQST).",
        "description": "<p>Students learn to directly translate current results from research and development in Natural Sciences (e. g. Physics, Chemistry) and Mathematics and Engineering (e. g. informatics, electrical engineering) into applications which exploit quantum phenomena \u2013 especially superposition and entanglement, such as: Quantum sensors Quantum algorithms Quantum computers Specialization Areas Experimental Quantum Science &amp; Technology Theoretical Quantum Science &amp; Technology<br />\r\n<br />\r\nProgram target: Master's programme<br />\r\n-----------------------------------<br />\r\nProgram country: Germany<br />\r\n-----------------------------------</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Program",
        "contacts": [
            {
                "first": "Anca Ionescu",
                "second": "info@mcqst.de"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Quantum Metrology",
            "Quantum Physics",
            "Quantum Sensing",
            "Quantum Simulation",
            "Quantum Technology",
            "Engineering",
            "Soft Skills"
        ],
        "org": [
            "TU Munich",
            "LMU Munich"
        ],
        "city": [],
        "country": [
            "Germany",
            "Germany"
        ],
        "target": [
            "MSc students"
        ],
        "type": [],
        "id": "f2acce5e-992f-4512-a1d3-a87f4c7c8ed3"
    },
    {
        "title": "Master in Quantum Computing @ Madrid",
        "summary": "This blended-learning Master in Quantum Computing is aimed at graduates in Computer Science, Computer Engineering, Electrical and Electronic Engineering or equivalent degrees who want to learn about Quantum algorithms, programming models and languages for quantum computing, tools and simulators, Quantum error correction and applications and use cases. The master has an important practical workload that allows students to become familiar with the computing environments available today.",
        "description": "<p>This blended-learning Master in Quantum Computing is aimed at graduates in Computer Science, Computer Engineering, Electrical and Electronic Engineering or equivalent degrees who want to learn about Quantum algorithms, programming models and languages for quantum computing, tools and simulators, Quantum error correction and applications and use cases. The master has an important practical workload that allows students to become familiar with the computing environments available today. Modules are taught using a remote synchronous virtual classroom system, where lectures are recorded. Additionally, there are on-site activities (such as lectures or conferences) delivered once every four weeks (during weekends). Apart from the core modules, the students can choose between an internship in a company or a research methodology course, depending on their preference in terms of their future career (company-oriented or pursuing a Ph.D.). Students who complete this Master may apply for a Ph.D., including the Ph.D. program on Industrial and Computer Science Technologies at Universidad Nebrija.<br />\r\n&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": "Alfonso S\u00e1nchez",
                "second": "quantum@nebrija.es"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "Spanish"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Quantum Simulation"
        ],
        "org": [
            "Universidad Nebrija"
        ],
        "city": [],
        "country": [
            "Spain"
        ],
        "target": [
            "MSc students"
        ],
        "type": [],
        "id": "7a85279e-ca0c-4080-b27c-a9082b5740bc"
    },
    {
        "title": "QWorld",
        "summary": "QWorld (Association) is a non-profit global organization that brings quantum computing researchers & enthusiasts together. Our main goal is to popularize quantum technologies and software. Also, through education and skill development opportunities, QWorld is training the next generation of quantum scientists.",
        "description": "<p>QWorld conducts its activities within five departments.<br />\r\nQCousins implements one of the critical strategies of QWorld, i.e., to establish active collaborations through quantum groups located in different countries. These groups organize events in their regions, often communicating in the native language.<br />\r\nQEducation is tasked with developing tutorials and designing hands-on workshops based on them. In the future, we would like to establish academic curriculums and train educators.<br />\r\nQResearch\u2019s goal is to bring together researchers to foster collaboration and match students with mentors to develop a short-term research project.<br />\r\nQWorld is also committed to increase women\u2019s representation in the STEM field, and for this reason, QWomen was created.<br />\r\nFinally, the QJunior program is focused on high school students.<br />\r\n<br />\r\n&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Jibran Rashid",
                "second": "qeducation@qworld.net"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education",
            "Lifelong learning and (re)training",
            "Outreach"
        ],
        "lang": [],
        "topic": [
            "Quantum Computing",
            "Quantum Information",
            "Quantum Technology",
            "Programming",
            "Teaching"
        ],
        "org": [
            "QWorld"
        ],
        "city": [],
        "country": [
            "Latvia"
        ],
        "target": [
            "Entrepreneurs",
            "Managers",
            "Investors",
            "Professionals",
            "Technicians",
            "Primary school students",
            "Secondary school students",
            "BSc students",
            "MSc students"
        ],
        "type": [],
        "id": "e70f8b05-0295-49ec-8028-36eb93d7af0c"
    },
    {
        "title": "Courses in Post-Quantum Cryptography",
        "summary": "The E\u00f6tv\u00f6s Lor\u00e1nd University is developing new course on post-quantum cryptography encompassing all of its current major branches, including lattice-based, multivariate, code-based, hash-based and isogeny-based cryptography. This will be one of the first such Master / Phd courses in Europe on this increasingly important topic, and it will be offered first in the spring semester (the course will most likely be split into two semesters). The university also plans to hire PhD students pursuing related research.",
        "description": "<p>The E\u00f6tv\u00f6s Lor\u00e1nd University is developing new course on post-quantum cryptography encompassing all of its current major branches, including lattice-based, multivariate, code-based, hash-based and isogeny-based cryptography. This will be one of the first such Master / Phd courses in Europe on this increasingly important topic, and it will be offered first in the spring semester (the course will most likely be split into two semesters). The university also plans to hire PhD students pursuing related research.<br />\r\n&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": "P\u00e9ter Kutas",
                "second": "kutasp@gmail.com"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English",
            "Hungarian"
        ],
        "topic": [
            "Quantum Computing",
            "Programming"
        ],
        "org": [
            "E\u00f6tv\u00f6s Lor\u00e1nd University"
        ],
        "city": [],
        "country": [
            "Hungary"
        ],
        "target": [
            "MSc students",
            "PhD students"
        ],
        "type": [],
        "id": "c87533b5-e30a-4df2-b3cf-f65afe12c6af"
    },
    {
        "title": "Course in Quantum Computing",
        "summary": "The Alfr\u00e9d R\u00e9nyi Institute is developing a new Masters course in Quantum Computing in the hope of attracting strong PhD candidates to this topic. The novel aspect of its new course will be to approach the theory of quantum algorithms from the perspective of the recent \u201cGrand Unification of Quantum Algorithms\u201d.",
        "description": "<p>The Alfr\u00e9d R\u00e9nyi Institute is developing a new Masters course in Quantum Computing in the hope of attracting strong PhD candidates to this topic. The novel aspect of its new course will be to approach the theory of quantum algorithms from the perspective of the recent \u201cGrand Unification of Quantum Algorithms\u201d.<br />\r\n&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": "Andr\u00e1s Gily\u00e9n",
                "second": "gilyen@cantab.net"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English",
            "Hungarian"
        ],
        "topic": [
            "Quantum Computing",
            "Programming"
        ],
        "org": [
            "Alfr\u00e9d R\u00e9nyi Institute"
        ],
        "city": [],
        "country": [
            "Hungary"
        ],
        "target": [
            "MSc students",
            "PhD students"
        ],
        "type": [],
        "id": "0223ff79-f59e-4c9b-8a4a-297b08a85290"
    },
    {
        "title": "Introduction in Quantum Information",
        "summary": "The course will introduce master's level engineering students to quantum information. Quantum algorithms and quantum communications protocols will be introduced.",
        "description": "<p>The class will start with the basics of quantum mechanics, which will be introduced via worked out examples. Based upon this introduction, will be introduced quantum algorithms and quantum communications protocols. The labs will have two parts. One will be the introduction of qubit operations, algorithms using tools such as Quantum Odyssey, and Uranium, developed in Romania. The second part of the lab will consist in optical experiments including quantum key distribution.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": "Liviu Zarbo",
                "second": "liviu.zarbo@itim-cj.ro"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "Romanian"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Engineering"
        ],
        "org": [
            "Technical University of Cluj-Napoca"
        ],
        "city": [],
        "country": [
            "Romania"
        ],
        "target": [
            "MSc students"
        ],
        "type": [],
        "id": "a927d968-214a-4abc-b1ec-20fda19d5719"
    },
    {
        "title": "Chances with Quantum",
        "summary": "A 6-week course on quantum computing for high school students.",
        "description": "<p>We offer a six-week course on quantum computing for high school students. In the first part of the course, we build up concepts for quantum computing from physical principles. We use polarization to introduce the qubit, compare the qubit to the classical bit, build up a set of quantum gates, present a simple quantum algorithm and give an outlook on quantum computing applications. The second part of the course consists of practical assignments. Students discover more algorithms, cryptography, advanced math, societal implications, and more. Please reach out to the contact person for more information about the course.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": "Henk Buisman",
                "second": "buisman@physics.leidenuniv.nl"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "Dutch"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Physics",
            "Quantum Simulation",
            "Programming",
            "Soft Skills"
        ],
        "org": [
            "Leiden University"
        ],
        "city": [],
        "country": [
            "The Netherlands"
        ],
        "target": [
            "Secondary school students"
        ],
        "type": [],
        "id": "181c36a3-a5d9-4baf-8e1d-eb6d4ff696a2"
    },
    {
        "title": "MSc in Quantum Science and Technology",
        "summary": "This MSc focuses on the theoretical and software aspects of this technology. Specifically, it focuses on an unique blend of quantum information science, the physics of quantum hardware and quantum materials. It will also enable you to develop key skills in the area, such as how to write programs for quantum computers and to network with like-minded students who are interested in pursuing further studies in this area. Several scholarship prizes funded by Microsoft available for outstanding female applicants.",
        "description": "<p>This blended MSc focuses on quantum information theory, quantum computing and the physics of quantum hardware. Teaching will be led by the School of Physics staff who are recognised as international experts in the quantum science and technologies field. The programme is designed with both online and face-to-face components (blended) and incorporates an exciting range of industrial experts to speak about this rapidly growing area. This will allow students of the programme to gain a unique perspective on a diverse range of research and its implementation in the quantum industry. The course syllabus covers many key areas in quantum information science including open quantum systems, quantum material science, physical implementation of quantum technology, quantum computation and algorithms. This MSc also includes a research project that can be undertaken either in the School of Physics or as an internship in an industrial setting. This is one of the first programmes of its kind internationally and is distinctive in its structure, offering students a unique opportunity to combine knowledge and research expertise in quantum information science and material science. More information available <a href=\"https://www.tcd.ie/Physics/quantumtech/assets/brochure/TCD-MSc-Quantum-Science.pdf\">here</a>!<br />\r\n&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": "Prof John Goold",
                "second": "quantum@tcd.ie"
            }
        ],
        "level": [
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Programming"
        ],
        "org": [
            "Trinity College Dublin"
        ],
        "city": [],
        "country": [
            "Ireland"
        ],
        "target": [
            "Technicians",
            "MSc students"
        ],
        "type": [],
        "id": "deec9a44-3db9-41d6-8c08-22f825890828"
    },
    {
        "title": "Modern Cryptography",
        "summary": "Students will obtain theoretical and practical knowledge on current modern cryptography and its concrete applications. In particular, the course focuses on post-quantum cryptography, cloud computing, secure data processing, e-voting, cryptocurrencies, and data privacy.  By passing the course, students will be able to develop modern cryptographic systems based on the topics explained in the course.",
        "description": "<p>Curriculum:</p>\r\n\r\n<ol>\r\n\t<li>Post-quantum cycles: Lattice-based Cryptography</li>\r\n\t<li>Post-quantum cycles: LWE and RLWE problems</li>\r\n\t<li>Post-quantum cycles: Fiat-Shamir with Abort and Dilithium signatures</li>\r\n\t<li>Post-quantum cycles: Code-based Cryptography and McEliece cryptosystem</li>\r\n\t<li>Secure computation cycles: Homomorphic encryption</li>\r\n\t<li>Secure computation cycles: Homomorphic encryption in Cloud Computing</li>\r\n\t<li>Secure computation cycles: Secret Sharing and Secure Multiparty Computation</li>\r\n\t<li>Secure computation cycles: Secure Multiparty Computation in e-voting and cloud computing</li>\r\n\t<li>Decentralized systems cycles: Blockchain and Smart Contracts</li>\r\n\t<li>Decentralized systems cycles: Cryptocurrencies</li>\r\n\t<li>Data Privacy cycles: Data Anonymization</li>\r\n\t<li>Data Privacy cycles: Differential Privacy, k-anonymity and Record Linkage</li>\r\n</ol>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": "Jan Hajny",
                "second": "hajny@feec.vutbr.cz"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Programming"
        ],
        "org": [
            "Brno University of Technology"
        ],
        "city": [],
        "country": [
            "Czech Republic"
        ],
        "target": [
            "MSc students"
        ],
        "type": [],
        "id": "769ba772-40b4-42e3-9b09-10981111e765"
    },
    {
        "title": "QBronze",
        "summary": "QBronze is QWorld\u2019s introductory level workshop series (16 to 20 hours) on the basics of quantum computing and quantum programming created in October 2018.",
        "description": "<p>QBronze is QWorld\u2019s introductory level workshop series (16 to 20 hours) on the basics of quantum computing and quantum programming created in October 2018. Bronze is a collection of Jupyter notebooks, and each notebook has many programming tasks to provide hands-on experiences. We see Bronze as a laboratory where you can learn the basics of quantum computing and quantum programming by doing. As a pedagogical strategy, we skip to use complex numbers to keep the tutorial simpler.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Abuzer Yakaryilmaz",
                "second": "abuzer.yakaryilmaz@gmail.com"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Programming"
        ],
        "org": [
            "QWorld"
        ],
        "city": [],
        "country": [
            "Czech Republic"
        ],
        "target": [
            "Secondary school students"
        ],
        "type": [],
        "id": "a6bdb5ab-af48-4319-a24b-d8a420a2e110"
    },
    {
        "title": "Quantum Investor Mentorship Programme",
        "summary": "The Quantum Investor Mentorship Programme is the world\u2019s first programme to provide training and mentorship to prospective investors in quantum technologies. It is a unique opportunity for VCs, seasoned angel investors, aspiring investors, and early start-ups, or even established companies to evaluate the investment opportunities in the quantum technologies industry and be part of the quantum ecosystem.",
        "description": "<p>The Quantum Investor Mentorship Programme is the world\u2019s first programme as a major step forwards to provide training and mentorship to prospective investors in quantum technologies. It is a unique opportunity for VCs, seasoned angel investors, or aspiring investors to evaluate the investment opportunities in the quantum technologies industry. The programme will give investors the opportunity to be part of the quantum ecosystem. Furthermore, it is an opportunity for startups and businesses in the quantum industries to secure funding. The Quantum Investor Mentorship Programme has three main components: - Quantum training - Networking with leading experts - Pitch competition.</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Araceli Venegas-Gomez",
                "second": "araceli.venegas-gomez@qureca.com"
            }
        ],
        "level": [
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Physics",
            "Quantum Technology",
            "Business"
        ],
        "org": [
            "QURECA"
        ],
        "city": [],
        "country": [
            "United Kingdom"
        ],
        "target": [
            "Entrepreneurs",
            "Managers",
            "Investors",
            "Other (specify)"
        ],
        "type": [],
        "id": "0709308d-c3b2-4cea-ad93-05f944ab3a68"
    },
    {
        "title": "Online educational series \u201cQuantum Computing for Finance\u201d",
        "summary": "\"Quantum Computing for Finance\" is a 2-course online program designed for learners to have an understanding of the fundamentals of quantitative & computational finance, and quantum algorithms for its implementation on quantum computers in order to realize the true potential of quantum technologies and its use-cases in Finance.",
        "description": "<p>\u201cIntroduction to Quantitative and Computational Finance\u201d provides a basis to step into the world of Quantum Computing for Finance. This introductory course will develop fundamental concepts required for an understanding of quantum algorithms and more advanced topics in computational finance. This course will teach you the basics of derivative products, the Black-Scholes-Merton model for pricing vanilla derivatives, and how to compute the price of exotic options with a computer. This course is designed for all those who wish to develop their skills and start a career in quantitative finance. \u201cQuantum Algorithms for Computational Finance\u201d is an advanced course in the emerging field of quantum computing for finance. This technical course will develop an understanding of quantum algorithms for their implementation on quantum computers and their applications in finance. This course covers several aspects of quantum programming for people already familiar with the basics of quantum programming. This course will benefit all those learners who want to explore the long-term employability of quantum computing in finance.<br />\r\n&nbsp;</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": "Araceli Venegas-Gomez",
                "second": "araceli.venegas-gomez@qureca.com"
            }
        ],
        "level": [
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Technology",
            "Programming"
        ],
        "org": [
            "QURECA"
        ],
        "city": [],
        "country": [
            "United Kingdom"
        ],
        "target": [
            "Entrepreneurs",
            "Professionals"
        ],
        "type": [],
        "id": "03805be4-ed77-4573-90d5-f3ac3c6e2a70"
    },
    {
        "title": "Master in Quantum Computing Technology",
        "summary": "Universidad Polit\u00e9cnica de Madrid, with the collaboration of Accenture as a technology partner, presents the 2nd edition of its online Master in Quantum Computing Technology. The Master's degree has a practical orientation (50% of the contents are directly devoted to lab and applications). and is designed for Graduates in Computer Engineering, Mathematics, Physics and Telecommunications and Industrial Engineering.",
        "description": "<p>The online Master on Quantum Computing Technology is offered by the Universidad Polit\u00e9cnica de Madrid in collaboration with Accenture. Registration for the 2nd edition tool place in September 2021. The Master's degree has a practical orientation, with 50% percent of the contents being lab and applications-oriented, and it is designed for Graduates in Computer Engineering, Mathematics, Physics and Telecommunications, and Industrial Engineering. The purpose of this Master is to train those professionals that companies are beginning to demand in the area of quantum computation and quantum technologies. To achieve this, we (1) provide a solvent basic training in the fundamentals of quantum computing and communication, (2) make sure that students know the challenges and current research lines of quantum technologies and (3) train professionals for companies that work with computing and quantum communication technologies. The main characteristics of the program are: - Online classes - Online assessment - Personal attention online - Materials: Notes on each subject, together with examples - Worksheets and practivcal assignments - Complementary online seminars - Recordings of online classes and complementary seminars.<br />\r\n<br />\r\n&nbsp;</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "category": "Program",
        "contacts": [
            {
                "first": "Luis Pozo",
                "second": "lm.pozo@upm.es"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Quantum Simulation",
            "Quantum Technology",
            "Programming"
        ],
        "org": [
            "Universidad Polit\u00e9cnica de Madrid and Accenture"
        ],
        "city": [],
        "country": [
            "Spain"
        ],
        "target": [
            "MSc students"
        ],
        "type": [],
        "id": "38217771-a03b-49cb-9f39-2f64b4241a73"
    },
    {
        "title": "Post graduate course in QUANTUM TECHNOLOGIES",
        "summary": "The Specialization Course in \u201cQuantum Technologies\u201d is an interdisciplinary thematic course that complements the Master Courses in Physics, Mathematics, Computer Science, Chemistry, Biology, Engineering, enriching the curriculum with transversal skills, addressed in a multidisciplinary and innovative way. The Course aims to provide students of science degrees and workers in industry, the appropriate tools to address the new scenarios opened by quantum technologies. The Course is open to both internal students of Insubria and from other universities and staff of companies interested in quantum technologies.",
        "description": "<p>The Specialization Course in \u201cQuantum Technologies\u201d is an interdisciplinary thematic course that complements the Master Courses in Physics, Mathematics, Computer Science, Chemistry, Biology, Engineering, enriching the curriculum with transversal skills, addressed in a multidisciplinary and innovative way.</p>\r\n\r\n<p>The Course aims to provide students of science degrees and workers in industry, the appropriate tools to address the new scenarios opened by quantum technologies. The Course is open to both internal students of Insubria and from other universities and staff of companies interested in quantum technologies.</p>\r\n\r\n<p>The Specialization Course in \u201cQuantum Technologies\u201d, delivered in English, will take place in January-June 2022, and will include the following courses (for details, see the attached syllabi)</p>\r\n\r\n<ul>\r\n\t<li>Quantum computing</li>\r\n\t<li>Classical and quantum simulation of quantum systems</li>\r\n\t<li>Classical and quantum machine learning</li>\r\n\t<li>Quantum optics for quantum information (experimental course)</li>\r\n</ul>\r\n\r\n<p>All the courses will include extensive tutorials, to allow students to apply the learned concepts to concrete examples. To allow interested students, but with a different background, to fruitfully participate in the lectures, the course will include introductory modules on</p>\r\n\r\n<ul>\r\n\t<li>Linear algebra for quantum mechanics</li>\r\n\t<li>Quantum mechanics formalism</li>\r\n\t<li>Classical logic, algorithmic complexity</li>\r\n\t<li>Security and networks: basic principles</li>\r\n\t<li>Introduction to Python The courses, except for the laboratory hours of the experimental course, can be attended online.</li>\r\n</ul>\r\n\r\n<p>It will be also possible to attend individual courses instead of the whole program.</p>\r\n\r\n<p>Registrations deadline: November 30th, 2021, h. 12.00</p>\r\n\r\n<p>Other contact person: Maria Bondani <a href=\"mailto:maria.bondani@uninsubria.it\"><span>maria</span>.<span>bondani</span>@uninsubria.it</a></p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": "Giuliano Benenti",
                "second": "giuliano.benenti@uninsubria.it"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "Italian"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Simulation",
            "Programming"
        ],
        "org": [
            "Universit\u00e0 degli studi dell'Insubria"
        ],
        "city": [],
        "country": [
            "Italy"
        ],
        "target": [
            "BSc students",
            "MSc students"
        ],
        "type": [],
        "id": "8b3be847-564e-4200-b28c-71972ad3d122"
    },
    {
        "title": "Max-Planck graduate program on Quantum Dynamics",
        "summary": "The International Max Planck Research School for Quantum Dynamics in Physics, Chemistry and Biology (IMPRS-QD) offers excellent research opportunities in the fields of chemical, biomolecular, relativistic and ultra-short quantum dynamics, ultra-cold quantum matter, quantum information and quantum electrodynamics, supervised by leading experts in these disciplines.",
        "description": "<p>Quantum mechanics is the underlying theory which describes the structure as well as the dynamics of matter. The International Max Planck Research School for Quantum Dynamics in Physics, Chemistry and Biology (IMPRS-QD) offers excellent research opportunities in the fields of chemical, biomolecular, relativistic and ultra-short quantum dynamics, ultra-cold quantum matter, quantum information and quantum electrodynamics, supervised by leading experts in these disciplines. The graduate students are trained in all aspects of quantum dynamics with special emphasis on the transition from simple to complex systems. The focus is on the common underlying quantum principles across the various fields, which is the basis of mutual understanding and cross fertilisation between the disciplines. Besides the introductory and advanced level lectures, regular seminars are held. The attendance of workshops and conferences provides the opportunity to PhD students to practice presentational skills and to present significant research results. With its multidisciplinary research and education programme, the school attracts talented and highly motivated students from all over the world.<br />\r\n&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Program",
        "contacts": [
            {
                "first": "J\u00f6rg Evers",
                "second": "imprs-qd@mpi-hd.mpg.de"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Physics"
        ],
        "org": [
            "Max Planck Institute for Nuclear Physics (MPIK)",
            "Heidelberg University"
        ],
        "city": [],
        "country": [
            "Germany",
            "Germany"
        ],
        "target": [
            "PhD students"
        ],
        "type": [],
        "id": "2dee79dc-67d1-4548-a908-3c733f776a7a"
    },
    {
        "title": "Master Program: Applied Superconductors Engineering",
        "summary": "Today, superconductor-based quantum technology plays a key role in many areas of research, society and industry. Examples are energy technology, medical technology, sensor technology or quantum computing. In order to be prepared for future challenges in these areas and to perspectively realize new, today unthinkable applications, a profound knowledge in the field of superconductor-based quantum technology is necessary which students acquire within the scope of this specialization.",
        "description": "<p>As a result of broad and intense research programs over the last decades, superconductor-based quantum technology nowadays plays a key role in many areas of science, society and industry. For example, superconducting systems in energy technology and communications engineering will play a key role in realizing the already initiated and ecologically necessary energy transition or the digitization of society. In addition, superconducting magnet systems form the foundation for diagnostic magnetic resonance imaging in medical technology, advanced NMR spectroscopy in manufacturing technology or enable the construction of the first economically viable nuclear fusion reactor. In the field of sensors and computing, superconductor-based quantum sensors and quantum electronic devices also play a leading role in making it possible to realize applications today that were considered unfeasible with conventional technology yesterday. Students of \u201cApplied Superconductors Engineering\u201d receive a solid overview of the fundamentals and applications of superconductor-based quantum technology in research, society and industry through the offered lectures, seminars and practical courses. Students become experts in one of the main directions of superconductor-based quantum technology through the courses in the elective area: quantum sensing, energy engineering, materials science. The ultimate goal of the program is to form an engineer with deep expertise in one of the areas of applied superconductor-based quantum technology who can become a leader in a promising field of electrical and information engineering.<br />\r\n&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Program",
        "contacts": [
            {
                "first": "Stefan W\u00fcnsch",
                "second": "master-info@etit.kit.edu"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English",
            "German"
        ],
        "topic": [
            "Quantum Physics",
            "Quantum Technology",
            "Engineering"
        ],
        "org": [
            "Karlsruhe Institute for Technology"
        ],
        "city": [],
        "country": [
            "Germany"
        ],
        "target": [
            "MSc students"
        ],
        "type": [],
        "id": "7e88a787-d566-4470-8add-9f39d5016b29"
    },
    {
        "title": "Master Classes",
        "summary": "We try to motivate high school pupils to enter the world of Physics by showing them the newest aspects and applications of Quantum Physics. We organize workshops with diverse topics where the pupils not only perform interesting experiments but also directly interact with the researchers of that topic.",
        "description": "<p>MasterClasses are half-day workshops on current topics in quantum metrology for pupils of the upper secondary school (introductory and qualification phase). Our goal is to motivate the students, especially girls, to later study physics. Therefore, we try to make them familiar with the new aspects and applications of physics. The pupils are introduced to topics of current research based on the skills and knowledge they have acquired in physics and mathematics classes. The MasterClasses are part of the excellence cluster QuantumFrontiers. In the program, pupils can not only experiment and learn about new areas of physics, but they also get an insight into the scientific environment through direct contact with researchers.&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Azadeh Ghanbari ",
                "second": "a.ghanbari@tu-bs.de"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Metrology",
            "Quantum Physics"
        ],
        "org": [
            "Technical University Braunschweig",
            "Leibniz University Hannover"
        ],
        "city": [],
        "country": [
            "Germany",
            "Germany"
        ],
        "target": [
            "Secondary school students"
        ],
        "type": [],
        "id": "3b5ac2c7-b30f-435b-9101-71f625ef9a02"
    },
    {
        "title": "Quantum World Lecture in Pre-service Teacher Education",
        "summary": "The academic teacher education is a didactic course for academic physics students, in order to become a pre-university teachers. Part of this education is a lecture about the didactics of Quantum World.",
        "description": "<p>Part of the Quantum World lecture are - a task to compare schoolbooks on the subject of Quantum - introduction about QM in the secondary school curriculum - presentation of demos and hands-on practical work (including a single-photon-double slit experiment, and a tunneling experiment, suitable for secondary school) - discussion about learning goals in secondary school connected to the subject of QM, and how to achieve this in school<br />\r\n-----------------------------------<br />\r\nOrganization name: University of Twente<br />\r\n-----------------------------------<br />\r\nProgram target: Master,Master course<br />\r\n-----------------------------------<br />\r\nProgram country: Netherlands<br />\r\n-----------------------------------</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": "Henk Pol",
                "second": "h.j.pol@utwente.nl"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [],
        "topic": [
            "Quantum Physics",
            "Teaching"
        ],
        "org": [
            "University of Twente"
        ],
        "city": [],
        "country": [
            "The Netherlands"
        ],
        "target": [
            "MSc students"
        ],
        "type": [],
        "id": "49386075-2be8-4b5c-86f8-0f34ed8d0289"
    },
    {
        "title": "PhD in Quantum Science and Technologies",
        "summary": "The Ph.D. candidate enrolled in this program will receive a state-of-the-art education in the basic ideas of quantum science, in the main material platforms used in experiments, and in the mathematical concepts used for their description, as well as in the information and computation science concepts that aim at exploiting QST for applications. She/he will be expected to carry out cutting-edge research on subjects of interest of the Q@TN consortium, possibly in collaboration with our international project partners.",
        "description": "<p>The Ph.D. candidate enrolled in this program will receive a state-of-the-art education in the basic ideas of quantum science, in the main material platforms used in experiments, and in the mathematical concepts used for their description, as well as in the information and computation science concepts that aim at exploiting QST for applications. She/he will be expected to carry out cutting-edge research on subjects of interest of the Q@TN consortium, possibly in collaboration with our international project partners.</p>\r\n\r\n<p>The Program is open to students of the Doctoral (Ph.D.) Schools/Programmes of Trento University in:</p>\r\n\r\n<ul>\r\n\t<li>Physics</li>\r\n\t<li>Mathematics</li>\r\n\t<li>Materials, Mechatronics and Systems Engineering (MMSE)</li>\r\n\t<li>Information and Communication Technologies (ICT)</li>\r\n\t<li>Civil, Environmental and Mechanical Engineering Ph.D.</li>\r\n</ul>\r\n\r\n<p>Candidates entering the Program are required to gain at least a total of 18 ECTS credits attending the following courses and sustaining the corresponding exams:</p>\r\n\r\n<ul>\r\n\t<li>9 credits are obtained attending the fundamental courses listed in the \u201cManifesto degli studi\u201d concerning basic QST concepts</li>\r\n\t<li>3 credits are obtained following the courses listed in the Manifesto degli studi (emendable yearly by the panel), concerning topics of direct interest for the Program.</li>\r\n\t<li>The remaining credits can be obtained from any other admissible course according to the general rules of the Ph.D. School/Programme where the student is enrolled, which may also include Summer/Winter schools.</li>\r\n</ul>\r\n\r\n<p>At the end of each year, the Ph.D. candidate presents her/his work in front of the Panel.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Program",
        "contacts": [
            {
                "first": "Iacopo Carusotto",
                "second": "iacopo.carusotto@unitn.it"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Physics",
            "Quantum Technology",
            "Engineering"
        ],
        "org": [
            "University of Trento"
        ],
        "city": [],
        "country": [
            "Italy"
        ],
        "target": [
            "PhD students"
        ],
        "type": [],
        "id": "f95c15cf-642e-4704-b530-a8dae325f26d"
    },
    {
        "title": "The mechanics of quantum",
        "summary": "This is an active-learning course on the fundamentals of quantum mechanics designed for the pre-university level. In it, we investigate the double-well system to get as close as possible to what students commonly understand as mechanics: position, velocity (momentum), energy. It is being considered as an online active-engagement course.",
        "description": "<p>This course was developed using the Investigative Science Learning Environment framework. It is designed to offer students the opportunity to make observational experiments via a simulation, identify patterns, build models, and test models with testing experiments. It is designed modularly, with each module covering a certain topic. Some modules are independent, while others build on prerequisite modules. The first part employs the double-well pseudo-two-state system to explore the fundamentals of quantum mechanics. It covers indeterminism (probability), superposition, measurement, incompatibility (uncertainty principle), time evolution, and trajectory. It introduces Dirac formalism along with some alternative representations of complex coefficients. The second part expands upon the basics built in the first part. It introduces multiple position states, limiting to infinity and the wave function description. The wave function description, it explains the electron orbitals and cycles back to the double-well and the covalent bond. The course has been administered online due to covid restrictions and is being considered as an online course for all interested students either in Slovene or English.</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": "Sergej Faleti\u010d",
                "second": "sergej.faletic@fmf.uni-lj.si"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "English",
            "Slovene"
        ],
        "topic": [
            "Quantum Physics",
            "Soft Skills"
        ],
        "org": [
            "University of Ljubljana Faculty of Mathematics and Physics"
        ],
        "city": [],
        "country": [
            "Slovenia"
        ],
        "target": [
            "Secondary school students"
        ],
        "type": [],
        "id": "52782821-bdca-43ed-8cf1-acb9ebc2f51c"
    },
    {
        "title": "Master in Quantum Science and Technology",
        "summary": "This 60 credits research-oriented Master that can be considered a step toward doctoral studies. The one-year programme, finalized with a research-based Master Thesis, is available for up to 20 students per year.  The courses (compulsory and by choice) are taught in English by professors and researchers with proven track record in both teaching and research. The courses include fundamental quantum theory (from condensed matter to quantum field and gravitation) and its various applications in information processing and other technologies.",
        "description": "<p>This Master\u2019s program recognizes the central role of quantum physics in modern science and engineering by providing a solid foundation in several facets of quantum science and technology. Teaching and mentoring responsibilities are undertaken by professors and researchers with proven track record in both teaching and research. Our objective is to bring students to the level of knowledge and experience that allows them to choose academic or professional careers inside or outside physics, acquiring the capability to undertake research at the forefront of quantum physics and technology. This research-oriented Master can be considered a step towards doctoral studies. The students can choose one of two possible research paths (or their superposition): - Fundamental Physics (Gravitation, Cosmology, Condensed Matter, Quantum Optics, and Quantum Field Theory) and - Quantum Information and Technology (including Machine Learning and Neural Networks) The schedule includes sufficient time to produce a research-based Master Thesis. The program provides students with transferable skills in acquisition, creation and presentation of knowledge, with special emphasis in individual work and initiative within a research group.<br />\r\n<br />\r\nProgram target: Master's programme<br />\r\n-----------------------------------<br />\r\nProgram country: Spain<br />\r\n-----------------------------------</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Program",
        "contacts": [
            {
                "first": "Evgeny Sherman",
                "second": "evgeny.sherman@ehu.eus"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Information",
            "Quantum Metrology",
            "Quantum Physics",
            "Quantum Simulation"
        ],
        "org": [
            "University of the Basque Country UPV/EHU"
        ],
        "city": [],
        "country": [
            "Spain"
        ],
        "target": [
            "MSc students"
        ],
        "type": [],
        "id": "17db9a24-daf2-44b7-8186-162d5c4e72b4"
    },
    {
        "title": "Quantum Information Processing",
        "summary": "Introductory university course on hands-on quantum computing. One goal is to introduce quantum information theory and computing. Another goal is to provide hands-on experience in programming an actual quantum computer. That is, the basic concepts, gadgets, algorithms, etc., should be implemented and run by the students themselves, partly during the lectures, partly as homework. We will use the quantum computers of the IBM Quantum Experience project, which are available via the cloud for anyone.",
        "description": "<p>Lectures -- Lectures combine conventional, frontal presentation, and programming exercises.</p>\r\n\r\n<p>Assignments -- At each lecture, a number of programming exercises are assigned. Students have to submit the solution as a jupyter notebook.</p>\r\n\r\n<p>Resources -- The main resources used for the course are the online documentation of (1) the quantum computers available through the IBM Quantum Experience project, https://quantum-computing.ibm.com, and (2) the Qiskit quantum computing framework, https://qiskit.org.</p>\r\n\r\n<p>Evaluation -- There is an exam at the end of the semester. You'll get a few exercises that you have to solve on the spot on your own in a 90-minute time frame. Using online resources is allowed. The exercises will be similar to those on the exercises assigned at the lectures. We suggest that you solve all exercises before the exam as preparation. You'll get a grade based on the quality and quantity of the solutions you prepare during the exam, and based on your competence revealed at a short discussion after the exercise session.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": "Andras Palyi",
                "second": "palyi.andras@ttk.bme.hu"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [],
        "topic": [
            "Quantum Computing",
            "Quantum Physics",
            "Programming"
        ],
        "org": [
            "Institute of Physics, Budapest University of Technology and Economics"
        ],
        "city": [],
        "country": [
            "Hungary"
        ],
        "target": [
            "MSc students"
        ],
        "type": [],
        "id": "f387e29f-61e3-466d-ad87-654fd6b658c6"
    },
    {
        "title": "Explore quantum technologies",
        "summary": "In our project \"Quantenphysikalische Inhalte aus der modernen Forschung\" we offer high school students multiple experiments concerning current research, including basic principles of quantum physics and applications. They have the opportunity to work in an authentic laboratory environment with state-of-the-art equipment. The project includes topics like the double-slit experiment or the quantum eraser to convey basic principles of quantum physics. The students can setup a solid-state laser, work with an optical tweezer or test the functionality of quantum cryptography. To introduce high school students to current research on ultracold atoms we recently completed a magneto-optical trap for rubidium, a highlight for any school lab. Furthermore, we develop education projects in the field of quantum technologies, like the functionality of atomic clocks.",
        "description": "<p>In our project \"Quantenphysikalische Inhalte aus der modernen Forschung\" we offer high school students multiple experiments concerning current research, including basic principles of quantum physics and applications. They have the opportunity to work in an authentic laboratory environment with state-of-the-art equipment. The project includes topics like the double-slit experiment or the quantum eraser to convey basic principles of quantum physics. The students can setup a solid-state laser, work with an optical tweezer or test the functionality of quantum cryptography. To introduce high school students to current research on ultracold atoms we recently completed a magneto-optical trap for rubidium, a highlight for any school lab. Futhermore we develop education projects in the field of quantum technologies, like the functionality of atomic clocks. Please reach out via the contact information if you are interested in further details about this project. All information and contact data can also be found via the link above: <a href=\"https://www.min.uni-hamburg.de/min-schulportal/light-and-schools/besuch-im-physikschullabor/versuche/angebote-oberstufe/quantenphysik.html\">https://www.min.uni-hamburg.de/min-schulportal/light-and-schools/besuch-im-physikschullabor/versuche/angebote-oberstufe/quantenphysik.html</a><br />\r\n&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Bastian Besner",
                "second": "lschools@physnet.uni-hamburg.de"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "English",
            "German"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Physics",
            "Quantum Technology"
        ],
        "org": [
            "Universit\u00e4t Hamburg"
        ],
        "city": [
            "Hamburg"
        ],
        "country": [
            "Germany"
        ],
        "target": [
            "Secondary school students"
        ],
        "type": [],
        "id": "69700ee1-aaff-4862-9605-2ecffb955246"
    },
    {
        "title": "Quantum Information Science (QIS)",
        "summary": "Quantum Information Science (QIS) programs from High School to PhD.  Online and in-person.",
        "description": "<p>Master in Information Systems and Engineering Management \u2013 Concentration in Quantum Information Science (QIS)</p>\r\n\r\n<p>This is a two-year online and possibly some in-person (negotiable) program that aims to prepare individuals for joining the quantum-enabled workforce. In particular, the program prepares those that see work in the quantum industry, but without plans for a terminal degree. This program is particularly suited for those that strive to be in a supportive role of PhD experts in quantum organization, or for individual who expect to be a consumer of quantum computing technology \u2013 end-user who must communicate with the experts, for example.<br />\r\n&nbsp;</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "category": "Program",
        "contacts": [
            {
                "first": "Terrill Frantz",
                "second": "TFrantz@HarrisburgU.edu"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Information",
            "Quantum Simulation",
            "Quantum Technology",
            "Business",
            "Programming",
            "Soft Skills"
        ],
        "org": [
            "Harrisburg University of Science and Technology"
        ],
        "city": [],
        "country": [
            "United States"
        ],
        "target": [
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [],
        "id": "eb25603a-4438-4a69-b8ae-4172b4e69e89"
    },
    {
        "title": "QSilver",
        "summary": "QSilver is QWorld\u2019s intermediate level workshop series (16 to 20 hours) on quantum computing and programming focusing on complex numbers, QFT and Shor\u2019s Algorithm completed in 2021. Prior completion of QBronze is recommended.",
        "description": "<p>Silver is a collection of Jupyter notebooks, and each notebook having many programming tasks to provide hands-on experiences. Silver is a laboratory where you can learn about the essential quantum algorithms by doing. Silver materials assume knowledge of Bronze.<br />\r\n&nbsp;</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Aur\u00e9l G\u00e1bris",
                "second": "aurel.gabris@qworld.net"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Lifelong learning and (re)training"
        ],
        "lang": [],
        "topic": [
            "Quantum Computing",
            "Programming"
        ],
        "org": [
            "QWorld"
        ],
        "city": [],
        "country": [
            "Czech Republic"
        ],
        "target": [
            "Entrepreneurs",
            "Managers",
            "Investors",
            "Professionals",
            "Technicians",
            "Secondary school students"
        ],
        "type": [],
        "id": "88281695-0486-46a6-b325-7aede2ac4cb6"
    },
    {
        "title": "Quantum Programming in Python",
        "summary": "From basics of quantum computing to Shor's algorithm. Live-online course built on python basics. 16 hours, in 2022 May. In Hungarian.",
        "description": "<p>See the course description on the <a href=\"https://hamiltonconsulting.hu/course.html\">page</a>&nbsp;in Hungarian (the language of the course).</p>\r\n\r\n<p>Tov\u00e1bbi r\u00e9szletek magyarul a kurzus <a href=\"https://hamiltonconsulting.hu/course.html\">honlapj\u00e1n</a>.</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Andras Palyi",
                "second": "palyi.andras@ttk.bme.hu"
            }
        ],
        "level": [
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "Hungarian"
        ],
        "topic": [
            "Quantum Computing",
            "Programming"
        ],
        "org": [
            "Hamilton Consulting"
        ],
        "city": [],
        "country": [
            "Hungary"
        ],
        "target": [
            "Professionals",
            "Technicians"
        ],
        "type": [],
        "id": "7e9b1984-66f1-451a-afe1-32b5e47c5c23"
    },
    {
        "title": "Master of Quantum Science Pilot Project",
        "summary": "Pilot Program for a Master in Quantum Science",
        "description": "<p>The departments of math, physics and computer science at the University of Copenhagen are running a pilot project to develop a future joint Master of Quantum Science. The envisioned official Master education will also involve the Technical University of Denmark. The pilot phase started in the Fall term of 2019. This informal interdisciplinary full-time pilot project in English for four semesters comprises a workload of 120 ECTS credit points.<br />\r\n-----------------------------------<br />\r\nProgram target: Master,Master's programme<br />\r\n&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Program",
        "contacts": [
            {
                "first": "Albert Werner",
                "second": "werner@math.ku.dk"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Quantum Metrology",
            "Quantum Physics",
            "Quantum Sensing",
            "Quantum Simulation",
            "Quantum Technology",
            "Programming"
        ],
        "org": [
            "University of Copenhagen"
        ],
        "city": [],
        "country": [
            "Denmark"
        ],
        "target": [
            "MSc students"
        ],
        "type": [],
        "id": "365d7ff9-5cbb-4689-9634-e3ba48d12f16"
    },
    {
        "title": "Quantum physics for high school students",
        "summary": "This course, designed for high school students, is based on the model of Discipline-Culture. It starts with basic concepts in quantum physics (e.g., wavity of matter, superposition, state, measurement, probability, etc.), and through active learning and using multiple representations, it develops students\u2019 skills of quantitative problem-solving.",
        "description": "<p>This course is designed to teach the concepts of quantum physics to 12th-grade students without losing its quantitative nature while overcoming the lack of high mathematical background. It does not follow a historical path but rather addresses a hierarchical structure of fundamental physical theories termed Discipline-Culture. In this framework, every part of the theory is attributed either in the nucleus\u2014the basic principles (like superposition, uncertainty, and probability) the body of the theory\u2014implementation and examples (like the no-cloning theorem) or in the periphery, alternative concepts that compete with the nucleus. The first part is a brief introduction of classical waves of light and matter, the photoelectric effect, the Bohr model of the atom, the Compton effect, and De-Broglie wavelength. The second part is interactive learning for the conceptual understanding of wavity of matter, spin, state, superposition, probability, wave function, measurement, and the uncertainty principle. This is done using the CLMS environment, which holds worksheets, simulations, etc. The third part is aimed at more quantitative understanding. Using Dirac notation, students develop the ability to solve quantitative problems, which regard several implementations like the BB84 protocol cryptography.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Avraham Merzel",
                "second": "Avraham.Merzel@mail.huji.ac.il"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [],
        "topic": [
            "Quantum Physics"
        ],
        "org": [
            "The Hebrew Universtiy of Jerusalem Israel"
        ],
        "city": [],
        "country": [
            "Israel"
        ],
        "target": [
            "Primary school students"
        ],
        "type": [],
        "id": "19555324-7e8c-4c14-bc08-3c3140608822"
    },
    {
        "title": "Teachers training for teaching quantum physics in high school",
        "summary": "This workshop is aimed to aid teachers in teaching quantum physics to students at the high school level. In this workshop for teachers, they experience learning activities as students and develop their own materials with the aid of physicists and physics educators.",
        "description": "<p>This workshop is designed for in-service physics teachers. It has two parts: In the first part, teachers learn QP- experiencing pre-planned activities as learners, discuss the physics content arranged in Discipline-Culture framework, relevant pedagogy, stressing students\u2019 potential difficulties. It includes components of different levels of abstraction, supporting conceptual and quantitative understanding. In addition, it includes raising ideas for other options to teach this content. In the second part, the teachers are asked to plan new activities, alone, in pairs, or in groups of three teachers. They could get advice from researchers on content knowledge and pedagogical issues. They present their activities to their peers in the first experience of teaching and learning. The activities are uploaded to a joint website.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Avraham Merzel",
                "second": "avraham.merzel@mail.huji.ac.il"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [],
        "topic": [
            "Quantum Physics",
            "Teaching"
        ],
        "org": [
            "The Hebrew Universtiy of Jerusalem Israel"
        ],
        "city": [],
        "country": [
            "Israel"
        ],
        "target": [
            "Secondary school teachers"
        ],
        "type": [],
        "id": "a25fdcd1-9b42-4d9c-b7cd-a08566678db0"
    },
    {
        "title": "European Spring School in Quantum Science and Technology",
        "summary": "Get an overview of the cutting edge in quantum science and technology with talks and lectures by international experts and industry leaders.",
        "description": "<p>The first European Spring School in Quantum Science and Technologies (10-14 April, 2022) will bring together students, researchers and internationally recognised experts from across Europe and across scientific domains to exchange and engage with quantum science and technologies. The school will target an audience of approximately 50 Master students and 30 PhD researchers in QST and its interfaces to other fields. The 5 day programme has been designed for students \u2013 by students, to provide international exposure to cutting-edge research and new applications, and help to broaden the students\u2019 vision beyond their core subjects. Lectures from international experts (academia and industry) have been carefully selected provide introductory and in-depth lectures bridging key subjects such as physics, materials and nano science, and quantum technology. Every student will have the opportunity to present their own research projects in three dedicated sessions for student talks and two poster sessions. By actively involving students in their own training this school will increase their exposure to international research and networking opportunities and empower them for their future careers.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Shannon Whitlock",
                "second": "whitlock@unistra.fr"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Physics",
            "Quantum Technology"
        ],
        "org": [
            "University of Strasbourg"
        ],
        "city": [
            "Strasbourg"
        ],
        "country": [
            "France"
        ],
        "target": [
            "MSc students",
            "PhD students"
        ],
        "type": [],
        "id": "837a2574-39cf-460a-bc4b-9da012ec3678"
    },
    {
        "title": "Quantum Industry Placement Fellowship",
        "summary": "Accelerate your career in quantum technologies! Our Quantum Industry Placement Fellowship Programme brings together talented and curious quantum enthusiasts in a cohort-based environment to accelerate quantum learning and placements in startups and innovative companies for work experience.",
        "description": "<p>Quantum Industry Placement Fellowship Programme is the world\u2019s first training and recruitment program in quantum technologies. It is a unique opportunity to support the future quantum workforce. The fellowship enables the mobility of talented students, researchers, and engineers from industry and academia in order to move between the sectors. These secondments support the fellow's development, foster exchange of knowledge, and stimulate collaborative links between the academic and industrial organizations worldwide.</p>\r\n\r\n<p>Timeline:</p>\r\n\r\n<ul>\r\n\t<li>Jan 2022 - Announcement&nbsp;</li>\r\n\t<li>Feb 2022 - Application Process</li>\r\n\t<li>Mar 2022 -&nbsp;Fellows&nbsp;Announced</li>\r\n\t<li>Apr 2022 -&nbsp;Online Training&nbsp;Session</li>\r\n\t<li>May 2022 -&nbsp;Portfolio&nbsp;Project</li>\r\n\t<li>July 2022 -&nbsp;Career&nbsp;Event</li>\r\n</ul>\r\n\r\n<p>Who can apply?</p>\r\n\r\n<ul>\r\n\t<li>Individuals from various disciplines looking for a career in quantum technologies anywhere from the world.</li>\r\n\t<li>Startups, Enterprises and other industries looking to integrate quantum technologies in their businesses.</li>\r\n</ul>\r\n\r\n<p>Eligibility &amp; Requirements</p>\r\n\r\n<ul>\r\n\t<li>Masters, or PhD students.</li>\r\n\t<li>Register to apply for the program with a non-refundable fee of \u20a4100.</li>\r\n\t<li>The fee for the full-time program will be payable when selected.</li>\r\n\t<li>Financial aid (income sharing agreement or private loans) is also available for the deserving candidates, including a special diversity scholarship for female candidates.</li>\r\n</ul>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": true,
        "category": "Training",
        "contacts": [
            {
                "first": "Araceli Venegas-Gomez",
                "second": "info@qureca.com"
            }
        ],
        "level": [
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Business",
            "Innovation & Entrepreneurship"
        ],
        "org": [
            "QURECA"
        ],
        "city": [],
        "country": [
            "United Kingdom"
        ],
        "target": [
            "Entrepreneurs",
            "Managers",
            "Investors",
            "Professionals",
            "Technicians",
            "MSc students",
            "PhD students"
        ],
        "type": [],
        "id": "1606d21f-09e8-48d4-9f2e-9ed9da598af3"
    },
    {
        "title": "Quantum Courses in teacher education",
        "summary": "In collaboration with different universities, quantum mechanics courses are developed using wave approach and approaches of two-state systems too. Since 2007 there has been a PhD program for teachers \"Physics Education\" that also includes quantum mechanical topics. Recently, the University has launched a pilot project incorporated in the first lessons on the introductory quantum mechanics lecture designed to understand two state systems. This is based on specifically selected examples and the knowledge of the students acquired years ago in relation to two by two matrices and their spectral properties which also support the discovery of quantum computing.",
        "description": "<p>The E\u00f6tv\u00f6s Lor\u00e1nd University pays attention to physics teachers education.<br />\r\nIn collaboration with different universities, quantum mechanics courses are developed using wave approach and approaches of two-state systems too. Since 2007 there has been a PhD programme for teachers \"Physics Education\" that also includes quantum mechanical topics.<br />\r\nRecently, the University has launched a pilot project incorporated in the first lessons on the introductory quantum mechanics lecture designed to understand two state systems. This is based on specifically selected examples and the knowledge of the students acquired years ago in relation to two by two matrices and their spectral properties which also support the discovery of quantum computing.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": "Krist\u00f3f T\u00f3th",
                "second": "tothk0711@gmail.com"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "Hungarian"
        ],
        "topic": [
            "Quantum Physics",
            "Quantum Technology",
            "Teaching"
        ],
        "org": [
            "E\u00f6tv\u00f6s Lor\u00e1nd University (ELTE)"
        ],
        "city": [],
        "country": [
            "Hungary"
        ],
        "target": [
            "Secondary school teachers"
        ],
        "type": [],
        "id": "f9160903-58c5-4106-be74-a7d30072e503"
    },
    {
        "title": "Student Lab \"PhotonLab\"",
        "summary": "At the students lab \"PhotonLab\" we present 20 different experiments from simple to more difficult  (analogy) experiments in quantum physics. The visiting students get an introduction talk, a lab visit at Max-Planck-Institute of Quantum Optics and then they can perform their own experiments. We also have interactive online material to prepare for  the visit: https://photonlab.h5p.com/content/1291314958702865067.",
        "description": "<p>The students lab \"PhotonLab\" exists since 10 years. A visiting school class first gets an introduction talk about the basics of lasers and light (https://www.youtube.com/watch?v=N7NYLG-OAPU&amp;list=PLDZL-uqr2Ss5FtFBsUugwh6KIC4QPOjLX). Afterwards they get a look into a real science lab and the they continue with the \"PhotonLab\". There we start with laser safety and continue with an open Helium-Neon-Laser. Then every student can select one of 20 experiments. The instructions are on iPads. For the quantum physics experiments Quantum Random Number Generator, Bomb Tester, Quantum Eraser and Quantum Cryptography we also offer interactive books (https://photonlab.h5p.com/content/1291314958702865067.). These are used by the students before the visit to get a deeper insight into the experiments and follow the flipped classroom concept.</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Silke St\u00e4hler-Sch\u00f6pf",
                "second": "staehler-schoepf@mpq.mpg.de"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "German",
            "English"
        ],
        "topic": [
            "Quantum Physics",
            "Quantum Technology"
        ],
        "org": [
            "Max-Planck-Institute of Quantum Optics"
        ],
        "city": [],
        "country": [
            "Germany"
        ],
        "target": [
            "Secondary school students"
        ],
        "type": [],
        "id": "6e62c4a6-3dc2-4fd3-8d55-5e978957eb77"
    },
    {
        "title": "Teacher professional development on quantum technologies",
        "summary": "The Department of Physics at the University of Pavia offers a professional training course on quantum technologies for  high school physics teachers. The course was held in 2020/21 in distance learning, and will be replicated in 2021/22 starting in early spring 2022, presumably still at least partially in distance learning.",
        "description": "<p>The purpose of the course is to enhance physics teachers\u2019 knowledge and awareness of topics related to quantum computation and quantum information, and of their relevance for technological advancement. Besides their objective importance, also stressed by several authors and projects, the choice of topics not traditionally covered in the final year physics curricula also arises from the concrete possibility of developing a multidisciplinary path, able to represent under a unified perspective several subjects treated in secondary school physics and mathematics.<br />\r\nThe project is realized in the context of the Italian PLS (Plan for Science Degrees) and the education section of the Quantum Flagship. Due to the current limitations it was entirely delivered in the form of synchronous distance learning and its first edition was attended by around 30 teachers. .<br />\r\nThe Educational path has a total duration of about 30 hours and is structured according to the following steps</p>\r\n\r\n<p>1) introduction to physics problem of classical computation;<br />\r\n2) building the quantum logic language and the origin of quantum algorithms;<br />\r\n3) introduction to entanglement and development of quantum protocols.</p>\r\n\r\n<p>The final part of the course will be devoted to discussing and designing individual projects of teachers for bringing quantum technologies to their classrooms.</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Massimiliano Malgieri",
                "second": "massimiliano.malgieri@unipv.it"
            }
        ],
        "level": [
            "Primary and Secondary School"
        ],
        "lang": [
            "Italian"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Information",
            "Quantum Technology",
            "Teaching"
        ],
        "org": [
            "University of Pavia"
        ],
        "city": [
            "Pavia"
        ],
        "country": [
            "Italy"
        ],
        "target": [
            "Secondary school teachers"
        ],
        "type": [],
        "id": "508ebe48-1a3d-4078-b3c1-dfce21955088"
    },
    {
        "title": "Postgraduate Course in Quantum Engineering",
        "summary": "Are you ready to enter the exciting world of quantum technologies and be at the forefront of the next technological revolution? Look no further, with this 130 hours postgraduate course you will get ready for the era of quantum technologies. It is specially designed to equip you with the rigorous knowledge and skills needed to understand the latest developments in quantum technology and its potential future market.\r\nThe course has a dual format and can be taken live or online.\r\n",
        "description": "<p><span><span><span><span lang=\"EN-GB\">Get ready for the era of quantum technologies with these 130 hours postgraduate course, specially designed for engineers and professionals working in the areas of information technology (ICT), who wish to enter the emerging field of <strong>quantum technologies</strong>.</span></span></span></span></p>\r\n\r\n<p><span><span><span><span lang=\"EN-GB\">The postgraduate program offers the ideal framework to make the leap into these novel technologies. It provides a rigorous knowledge to understand the technological development within the quantum paradigm but with a focus on the potential future market.</span></span></span></span></p>\r\n\r\n<p><span><span><span><span lang=\"EN-GB\">The graduate curriculum begins by introducing the basic notions of <strong>quantum mechanics</strong> necessary to understand the four pillars of quantum technologies: computation, sensing, communications and simulations. It includes as well a market development of quantum technologies leaded by the local and European start-ups and companies. The development of a project tutored by recognized experts on the field is a central task of the course.</span></span></span></span></p>\r\n\r\n<p><span><span><span><span lang=\"EN-GB\">The postgraduate course is a coordinated activitiy leaded by the Universitat Polit\u00e8cnica de Catalunya (UPC), together with the Universitat Aut\u00f2noma de Barcelona (UAB), the Universitat de Barcelona (UB), the Institut de Ci\u00e8ncies Fot\u00f2niques (ICFO), the Barcelona Supercomputing Center (BSC) and the Institut de F\u00edsica d'Altes Energies (IFAE), and with the collaboration of IBM.</span></span></span></span></p>\r\n\r\n<p><span><span><span><span lang=\"EN-GB\">The course has a dual format, so you can choose if to take it live or online, the way that suits you best.</span></span></span></span></p>\r\n\r\n<p><span><span><span><span lang=\"EN-GB\">Whether you're a busy professional looking to upskill or an ambitious student eager to expand your knowledge, this course is the perfect opportunity to take your career to the next level. Enroll now in our postgraduate course and get ready to be part of the era of quantum technologies!</span></span></span></span></p>\r\n\r\n<p><a href=\"https://bit.ly/3KukNGF\"><strong>ADMISSION INFORMATION</strong></a></p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": " Olga Garr\u00e1n Gonz\u00e1lez",
                "second": "olga.garran@talent.upc.edu"
            }
        ],
        "level": [
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Technology",
            "Engineering"
        ],
        "org": [
            "UPC School"
        ],
        "city": [
            "Barcelona"
        ],
        "country": [
            "Spain"
        ],
        "target": [
            "Professionals",
            "MSc students",
            "Other (specify)"
        ],
        "type": [],
        "id": "879c895c-cb1f-494a-b664-4829a623c579"
    },
    {
        "title": "Fun in Theory",
        "summary": "Fun in Theory is an innovative outreach approach, which combines introducing participants to theoretical physics world with games, and is aimed to spark the interest in fundamental theories of physics like quantum mechanics and cosmology.Fun in Theory approach is used in the Fun in Theory event, which is intended to develop good attitude towards theoretical physics, usually thought as difficult, abstract and hard to understand.The participants notice that studying quantum mechanics, cosmology, quantum field theory and quantum optics can be understandable, fun and interactive.",
        "description": "<p>The Fun in Theory event is provided in three parts:</p>\r\n\r\n<ol>\r\n\t<li>Theory part: 45 min \u2013 1 hour introductory lecture to increase participants' motivation and curiosity to learn more about different theoretical physics branches, and to show participants the relevance of quantum mechanics, and other theories, in their everyday life, society and future.</li>\r\n\t<li>Fun part: 2 hours long game, where participants continue familiarizing themselves with theoretical physics world while carrying out small game tasks and competing with each other for Fun in Theory prizes.</li>\r\n\t<li>Socializing: free format part, where members of Theoretical Physics and Quantum Optics Laboratories together with the participants have free discussions, eat snacks, and the winners of Fun in Theory game get prizes.</li>\r\n</ol>\r\n\r\n<p>The Fun in Theory as the approach and event is created and organized by the laboratories of Theoretical Physics and Quantum Optics in the University of Turku, Finland. The beauty of this approach is high adaptivity to different audiences and different \"Theory\" or \"Game\" parts. The approach can be successfully used to kids, high school students, university students or any other audience, and during the event participants can learn about theoretical physics in general, or about one specific topic, like quantum technologies. Each event has its own theme and is modified according to it. The crucial part of the Fun in Theory approach is the game, which also resonates with the theme. The game is conducted via smaller tasks, which vary from event to event. During the small tasks participants can learn new concepts or the general overviews on different theories, or the tasks can be planned just to create associations with different subjects.<br />\r\n&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Other (specify)",
        "contacts": [
            {
                "first": "Daria Anttila",
                "second": "dariale@utu.fi"
            }
        ],
        "level": [
            "Lifelong learning and (re)training",
            "Outreach"
        ],
        "lang": [
            "English",
            "Finnish"
        ],
        "topic": [
            "Quantum Physics",
            "Quantum Technology",
            "Soft Skills"
        ],
        "org": [
            "University of Turku"
        ],
        "city": [
            "Turku"
        ],
        "country": [
            "Finland"
        ],
        "target": [
            "Primary school students",
            "Secondary school students",
            "BSc students"
        ],
        "type": [],
        "id": "df6dbe65-d755-40ff-84aa-d43825c1a693"
    },
    {
        "title": "Quantum Computing for Chemistry The Next Revolution",
        "summary": "Leverage the transformative potential of quantum computing and its applications to chemistry, innovative materials and beyond, learning from theory to hands-on coding.",
        "description": "<h2>What to expect</h2>\r\n\r\n<ul>\r\n\t<li>Lectures on quantum computing and its applications by experts</li>\r\n\t<li>Example use cases from different industries</li>\r\n\t<li>Hands-on coding of quantum algorithms</li>\r\n\t<li>A workshop to ideate and discuss use cases</li>\r\n\t<li>Ample opportunities to create lasting partnerships</li>\r\n</ul>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Shannon Whitlock",
                "second": "whitlock@unistra.fr"
            },
            {
                "first": "Elena Yndurain",
                "second": "elena@qunasys.com"
            },
            {
                "first": "Karim Essafi",
                "second": "karim@qunasys.com"
            }
        ],
        "level": [
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Engineering",
            "Programming",
            "Other (specify)"
        ],
        "org": [
            "University of Strasbourg & QunaSys Inc."
        ],
        "city": [
            "Strasbourg"
        ],
        "country": [
            "France"
        ],
        "target": [
            "Entrepreneurs",
            "Managers",
            "Professionals",
            "Technicians"
        ],
        "type": [],
        "id": "08550728-88f0-424b-bb66-b5d80478210f"
    },
    {
        "title": "MSc in Quantum Computing and Quantum Technologies",
        "summary": "The Electrical and Computer Engineering Department of the Democritus University of Thrace in cooperation with the Institute of Nanoscience and Nanotechnology and the Institute Informatics and Telecommunications of the National Centre for Scientific Research \u201cDemokritos\u201d organized the, first in Greece, international postgraduate program in Quantum Computers and Quantum Technologies. All courses are taught in English and the program is suitable for scientists and engineers.",
        "description": "<p><span><span><span><span><span>The three-semester MSc program in Quantum Computing and Quantum Technologies will provide postgraduate students with cutting-edge knowledge in Quantum Mechanics, Quantum Computing and Quantum Technologies, as well as skills and abilities that will enable them to program quantum computers and develop novel quantum algorithms.&nbsp; Graduates of this program will also be able to use and apply the acquired knowledge not only in science and research but also to tackle problems that companies face in their operation as well as to create new enterprises. </span></span></span></span></span></p>\r\n\r\n<p><span><span><span>&nbsp;T<span><span>he MSc program curriculum includes courses such as: \u201cQuantum computing\u201d, \u201cQuantum algorithms and quantum information\u201d, \u201cQuantum devices\u201d, \u201cQuantum bit (Qubit) devices\u201d, \u201cQuantum Solid-state devices\u201d, \u201cQuantum communications\u201d, \u201cQuantum algorithms\u201d, \u201cQuantum machine learning\u201d and \u201cAdvanced Topics in quantum technologies\u201d.&nbsp; The curriculum also includes courses in the field of which Quantum Computing and Quantum Technologies are expected to make a great impact: \u201cNatural and Unconventional computing\u201d, \u201cComputational Biology\u201d, \u201cArtificial Intelligence\u201d and \u201cBig Data Handling\". More details can be found at: https://quantum.ee.duth.gr/</span></span></span></span></span></p>\r\n\r\n<p>&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Program",
        "contacts": [
            {
                "first": "Ioannis Karafyllidis",
                "second": "ykar@ee.duth.gr"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Quantum Simulation",
            "Quantum Technology"
        ],
        "org": [
            "Democritus University of Thrace, Department of Electrical and Computer Engineering",
            "National Centre of Scientific Research \u201cDemokritos\u201d"
        ],
        "city": [
            "Xanthi",
            "Athens"
        ],
        "country": [
            "85",
            "85"
        ],
        "target": [
            "MSc students"
        ],
        "type": [],
        "id": "cedb5ca0-bcf2-4e33-abf9-d875d68515eb"
    },
    {
        "title": "Quantum Science and Engineering ",
        "summary": "The revolution promised by quantum technologies requires a wide scientific community with multidisciplinary skills. \r\nTraining will have to ensure the functioning of the entire supply chain from basic research to the competitiveness of  European and Italian high-tech companies, with an enhancement of people with key skills, startups capable of transferring and implementing new technologies and companies capable of integrating QT into systems and services. \r\nThe Master Degree in Quantum Science and Engineering (QS&E) aims at preparing this new generation of quantum scientists and engineers. All courses will be hold in English and experimental courses will take place in qualified labs available at the University of Napoli Federico II (UNINA) and in international companies collaborating with UNINA and participating to the educational project.\r\n",
        "description": "<p><span><span><span><span><span><span><span><span><span>Quantum </span></span></span></span><span><span><span><span>technologies</span></span></span></span><span><span><span><span> (QT) </span></span></span></span><span><span><span><span>have</span></span></span></span> <span><span><span><span>radically</span></span></span></span><span><span><span><span> innovative </span></span></span></span><span><span><span><span>characteristics</span></span></span></span><span><span><span><span> and </span></span></span></span><span><span><span><span>have</span></span></span></span><span><span><span><span> an </span></span></span></span><span><span><span><span>intersectorial</span></span></span></span><span><span><span><span> impact, in strong </span></span></span></span><span><span><span><span>discontinuity</span></span></span></span><span><span><span><span> with the </span></span></span></span><span><span><span><span>technologies</span></span></span></span> <span><span><span><span>available</span></span></span></span> <span><span><span><span>today</span></span></span></span><span><span><span><span>. The </span></span></span></span><span><span><span><span>transformation</span></span></span></span> <span><span><span><span>that</span></span></span></span> <span><span><span><span>is</span></span></span></span> <span><span><span><span>envisaged</span></span></span></span> <span><span><span><span>is</span></span></span></span><span><span><span><span> disruptive, QT </span></span></span></span><span><span><span><span>having</span></span></span></span> <span><span><span><span>direct</span></span></span></span><span><span><span><span> and far-</span></span></span></span><span><span><span><span>reaching</span></span></span></span> <span><span><span><span>repercussions</span></span></span></span><span><span><span><span> in </span></span></span></span><span><span><span><span>many</span></span></span></span><span><span><span><span> fields, from information </span></span></span></span><span><span><span><span>technology</span></span></span></span><span><span><span><span> to </span></span></span></span><span><span><span><span>biology</span></span></span></span><span><span><span><span>, from </span></span></span></span><span><span><span><span>telecommunications</span></span></span></span><span><span><span><span> to engineering, from </span></span></span></span><span><span><span><span>chemistry</span></span></span></span><span><span><span><span> to </span></span></span></span><span><span><span><span>pharmaceuticals</span></span></span></span><span><span><span><span>, from medicine to the </span></span></span></span><span><span><span><span>environment</span></span></span></span><span><span><span><span>. Some quantum </span></span></span></span><span><span><span><span>solutions</span></span></span></span><span><span><span><span> are </span></span></span></span><span><span><span><span>already</span></span></span></span><span><span><span><span> on the market. At national </span></span></span></span><span><span><span><span>level</span></span></span></span><span><span><span><span> the </span></span></span></span><span><span><span><span>great</span></span></span></span> <span><span><span><span>interest</span></span></span></span> <span><span><span><span>is</span></span></span></span> <span><span><span><span>testified</span></span></span></span><span><span><span><span> by special </span></span></span></span><span><span><span><span>measures</span></span></span></span> <span><span><span><span>dedicated</span></span></span></span><span><span><span><span> to QT in the National </span></span></span></span><span><span><span><span>Research</span></span></span></span><span><span><span><span> Plan (PNR) 2021-2027 and in the Piano nazionale ripresa resilienza (PNRR) under the framework of </span></span></span></span><span><span><span><span>both</span></span></span></span><span><span><span><span> the National Center C1 on High Performance Computing, with a special </span></span></span></span><span><span><span><span>spoke</span></span></span></span> <span><span><span><span>dedicated</span></span></span></span><span><span><span><span> to Quantum </span></span></span></span><span><span><span><span>Computation</span></span></span></span><span><span><span><span>, and the Partnership PE4, </span></span></span></span><span><span><span><span>entirely</span></span></span></span> <span><span><span><span>devoted</span></span></span></span><span><span><span><span> to Quantum Technologies. Building on </span></span></span></span><span><span><span><span>continental</span></span></span></span> <span><span><span><span>scientific</span></span></span></span> <span><span><span><span>excellence</span></span></span></span><span><span><span><span>, the </span></span></span></span><span><span><span><span>European</span></span></span></span><span><span><span><span> Commission </span></span></span></span><span><span><span><span>launched</span></span></span></span><span><span><span><span> the 10-year Quantum </span></span></span></span><span><span><span><span>Flagship</span></span></span></span> <span><span><span><span>program</span></span></span></span> <span><span><span><span>funded</span></span></span></span><span><span><span><span> with 1 </span></span></span></span><span><span><span><span>billion</span></span></span></span> <span><span><span><span>euros</span></span></span></span><span><span><span><span> in 2018 for </span></span></span></span><span><span><span><span>research</span></span></span></span><span><span><span><span> and </span></span></span></span><span><span><span><span>development</span></span></span></span><span><span><span><span> projects under Horizon 2020. The </span></span></span></span><span><span><span><span>revolution</span></span></span></span> <span><span><span><span>promised</span></span></span></span><span><span><span><span> by quantum </span></span></span></span><span><span><span><span>technologies</span></span></span></span> <span><span><span><span>requires</span></span></span></span><span><span><span><span> a wide </span></span></span></span><span><span><span><span>scientific</span></span></span></span><span><span><span><span> community with multidisciplinary</span></span></span></span><span><span><span><span> skills. </span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span>Admission</span></span></span></span> <span><span><span><span>Requisites</span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span>For the </span></span></span></span><span><span><span><span>admission</span></span></span></span><span><span><span><span> to the Master Degree in QS&amp;E </span></span></span></span><span><span><span><span>it</span></span></span></span> <span><span><span><span>is</span></span></span></span> <span><span><span><span>necessary</span></span></span></span><span><span><span><span> to </span></span></span></span><span><span><span><span>have</span></span></span></span><span><span><span><span> a </span></span></span></span><span><span><span><span>bachelor\u2019s</span></span></span></span><span><span><span><span> degree or an </span></span></span></span><span><span><span><span>equivalent</span></span></span></span> <span><span><span><span>title</span></span></span></span><span><span><span><span>, with a study plan </span></span></span></span><span><span><span><span>where</span></span></span></span><span><span><span><span> credits </span></span></span></span><span><span><span><span>have</span></span></span></span> <span><span><span><span>been</span></span></span></span> <span><span><span><span>achieved</span></span></span></span><span><span><span><span> in the following </span></span></span></span><span><span><span><span>disciplines</span></span></span></span><span><span><span><span>:</span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span>- 24 ECTS Credits in Math; (</span></span></span></span></span></span></span></span>60 ECTS credits correspond to 1 full-time year)</span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span>- 12 Credits in </span></span></span></span><span><span><span><span>Physics</span></span></span></span><span><span><span><span>;</span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span>- 6 Credits in Engineering;</span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span>- 12 </span></span></span></span><span><span><span><span>additional Credits in&nbsp; Physics</span></span></span></span><span><span><span><span>;&nbsp; Mathematical </span></span></span></span><span><span><span><span>Physics</span></span></span></span><span><span><span><span>;&nbsp; </span></span></span></span><span><span><span><span>Chemistry</span></span></span></span><span><span><span><span>;&nbsp; Engineering.</span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span>English </span></span></span></span><span><span><span><span>level</span></span></span></span><span><span><span><span> B2 </span></span></span></span><span><span><span><span>is</span></span></span></span> <span><span><span><span>also</span></span></span></span> <span><span><span><span>required</span></span></span></span><span><span><span><span>. </span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p>&nbsp;</p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span><span><strong>Planning of Courses&nbsp; </strong></span></span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span><span><strong>First </strong></span></span></span></span><span><span><span><span><strong>Year</strong></span></span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span><span>Foundations</span></span></span></span><span><span><span><span> of Quantum </span></span></span></span><span><span><span><span>Mechanics (12 </span>Credits<span>)</span></span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span><span>Microwave</span></span></span></span> <span><span><span><span>Circuits and Technologies&nbsp; (6 </span>Credits<span>)</span></span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span><span>Digital Electronics for Quantum Applications (6 </span>Credits<span>)</span></span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span><span>Principles</span></span></span></span><span><span><span><span> of Quantum </span></span></span></span><span><span><span><span>Communication&nbsp; (6 </span>Credits<span>)</span></span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span><span>Quantum </span></span></span></span><span><span><span><span>Computation (12 </span>Credits<span>)</span></span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span><span>Applied Quantum Systems (9 </span>Credits<span>)</span></span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span><span>Quantum </span></span></span></span><span><span><span><span>circuit</span></span></span></span> <span><span><span><span>electrodynamics and Quantum devices (9 </span>Credits<span>)</span></span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span><strong>Second </strong></span></span></span></span><span><span><span><span><strong>year</strong></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span><span><span>3 </span></span></span></span><span><span><span><span>Additional</span></span></span></span> <span><span><span><span>courses</span></span></span></span><span><span><span><span> to be </span></span></span></span><span><span><span><span>chosen</span></span></span></span><span><span><span><span> in the list </span></span></span></span><span><span><span><span>below (18 </span>Credits<span>)</span></span></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span>3 </span></span></span></span><span><span><span><span>Additional</span></span></span></span> <span><span><span><span>courses</span></span></span></span><span><span><span><span> to be </span></span></span></span><span><span><span><span>chosen</span></span></span></span><span><span><span><span> by the </span></span></span></span><span><span><span><span>student&nbsp; (18 <span>Credits</span>)</span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span>Additional training activities&nbsp; (3 <span>Credits</span>)</span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span>Final test (21 <span>Credits</span>)</span></span></span></span></span></span></span></span></p>\r\n\r\n<p>&nbsp;</p>\r\n\r\n<p><span><span><span><span><span><span><span><span><strong>Additional</strong></span></span></span></span><span><span><span><span><strong> Courses</strong></span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span>Physics</span></span></span></span><span><span><span><span> of quantum information</span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span>Quantum </span></span></span></span><span><span><span><span>optics</span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span>Quantum simulators</span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span>Quantum </span></span></span></span><span><span><span><span>materials</span></span></span></span><span><span><span><span> and </span></span></span></span><span><span><span><span>solid</span></span></span></span><span><span><span><span>-state </span></span></span></span><span><span><span><span>qubits</span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span>Advanced computer programming</span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span>Quantum software</span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span>Quantum </span></span></span></span><span><span><span><span>metrology</span></span></span></span><span><span><span><span> and </span></span></span></span><span><span><span><span>sensors</span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span>Advanced Quantum </span></span></span></span><span><span><span><span>Communication</span></span></span></span><span><span><span><span> Networks</span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span>Quantum detectors for </span></span></span></span><span><span><span><span>fundamental</span></span></span></span><span><span><span><span> science</span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span>Superconducting</span></span></span></span><span><span><span><span> Quantum Technologies</span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span>Quantum </span></span></span></span><span><span><span><span>chemistry</span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span>Nanoscale Processing and </span></span></span></span><span><span><span><span>Characterization</span></span></span></span><span><span><span><span> for Advanced Devices</span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span>Nonlinear</span></span></span></span><span><span><span><span> systems</span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span>Quantum </span></span></span></span><span><span><span><span>Measurement</span></span></span></span><span><span><span><span> Theory</span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span>Quantum </span></span></span></span><span><span><span><span>Algorithms</span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span>Quantum detectors for </span></span></span></span><span><span><span><span>applied</span></span></span></span><span><span><span><span> science</span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span>Mathematics</span></span></span></span><span><span><span><span> of quantum </span></span></span></span><span><span><span><span>mechanics</span></span></span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span><span>Mathematical </span></span></span></span><span><span><span><span>methods</span></span></span></span><span><span><span><span> for quantum information</span></span></span></span></span></span></span></span></p>\r\n\r\n<p>&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": true,
        "category": "Program",
        "contacts": [
            {
                "first": "Francesco Tafuri",
                "second": "francesco.tafuri@unina.it"
            }
        ],
        "level": [
            "Higher education"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Quantum Metrology",
            "Quantum Physics",
            "Quantum Sensing",
            "Quantum Simulation",
            "Quantum Technology",
            "Engineering",
            "Programming"
        ],
        "org": [
            "Universit\u00e0 di Napoli Federico II"
        ],
        "city": [
            "Napoli"
        ],
        "country": [
            "Italy"
        ],
        "target": [
            "MSc students"
        ],
        "type": [],
        "id": "73d54806-6f2a-4213-a409-e56d87f141c1"
    },
    {
        "title": "Quantum Computing for Chemistry The Next Revolution",
        "summary": "This intensive five day industry training is targeted to industry professionals to provide them with an early advantage to leverage the transformative potential of quantum computing and its applications to chemistry, innovative materials and associated sectors. It will provide in-depth training on quantum computing, including lectures covering the foundational concepts of quantum computing and its application to chemistry, example use cases from different industries, hands-on coding of quantum algorithms, and a workshop to ideate and discuss use cases.",
        "description": "<p>Register for the industry training event Quantum Computing for Chemistry - the Next Revolution, Strasbourg (France) <strong>24-28 October, 2022</strong>.</p>\r\n\r\n<p>This intensive five day industry training is targeted to industry professionals to provide them with an early advantage to leverage the transformative potential of quantum computing and its applications to chemistry, innovative materials and associated sectors. It will provide in-depth training on quantum computing, including lectures covering the foundational concepts of quantum computing and its application to chemistry, example use cases from different industries, hands-on coding of quantum algorithms, and a workshop to ideate and discuss use cases.</p>\r\n\r\n<p><strong>Certified training for technology strategists, computational chemists, industry experts, anyone interested in practical quantum computing</strong></p>\r\n\r\n<ul>\r\n\t<li><span>Lectures on quantum computing and its applications by experts</span></li>\r\n\t<li><span>Example use cases from different industries</span></li>\r\n\t<li><span>Hands-on coding of quantum algorithms</span></li>\r\n\t<li><span>A workshop to ideate and discuss use cases</span></li>\r\n\t<li><span>Ample opportunities to create lasting partnerships</span></li>\r\n</ul>\r\n\r\n<p>The event will take place at the ISIS institute of the University of Strasbourg and the CNRS - one of the leading research institutes in France and internationally. Founded in 2002 by Nobel Prize Laureate Mr Jean-Marie Lehn, it focuses on developing and promoting top level multidisciplinary fundamental and applied research at the interface between Chemistry, Physics and Biology.</p>\r\n\r\n<p>Quantum Computing for Chemistry - The Next Revolution is co-organised by Qunasys the EquipEx+/PEPR Quantique project aQCess of the University of Strasbourg, as part of the QAREER pilot programme of the QTEdu coordination and support action of the EU Quantum flagship. Supported by the IdEx initiative of Excellence of the University of Strasbourg and the Foundation for Research in Chemistry.</p>\r\n\r\n<p>&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Shannon Whitlock",
                "second": "whitlock@unistra.fr"
            },
            {
                "first": "Elena Yndurain",
                "second": "elena@qunasys.com"
            }
        ],
        "level": [
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Technology",
            "Innovation & Entrepreneurship",
            "Programming",
            "Other (specify)"
        ],
        "org": [
            "University of Strasbourg",
            "QunaSys"
        ],
        "city": [
            "Strasbourg"
        ],
        "country": [
            "France",
            "Japan"
        ],
        "target": [
            "Entrepreneurs",
            "Managers",
            "Investors",
            "Professionals",
            "Technicians"
        ],
        "type": [],
        "id": "0207c3fd-e491-4572-9749-8d664e14c177"
    },
    {
        "title": "Quantum Game Jam",
        "summary": "Quantum Game Jam is an annual, over-the-weekend event, where games and interactive art pieces are created according to a quantum physics related theme. ",
        "description": "<p>Quantum Game Jam is a particular type of a <em>Science Game Jam</em>. A science game jam is a game jam where the collaboration between game makers and scientists is facilitated in order to produce games contributing to scientific work, directly (such as helping to solve research questions) or indirectly (such as building awareness or teaching a scientific topic).</p>\r\n\r\n<p>At a Quantum Game Jam a theme related to quantum physics is revealed at the start of the event together with short introductory lectures on quantum physics and game development. Through these talks the theme is opened up even to the participant that might not have heard about quantum physics or game development before. The event thrives to facilitate for people of all backgrounds and in particular bring them together through the creative process of game development.</p>\r\n\r\n<h4>THE STRUCTURE OF A QUANTUM GAME JAM</h4>\r\n\r\n<p>Quantum Game Jam is an international, online event hosted on discord. Feel free to join our quantum game enthusiast community at&nbsp;<a href=\"https://discord.gg/c4f5eX6bA6\">https://discord.gg/c4f5eX6bA6</a>&nbsp;(Game-Set-Quanta)!&nbsp;<br />\r\n<br />\r\nThe event is supported with an open stream through twitch.tv. Signing up for the event happens through an itch.io event page created specifically for the year. The event itself usually last over a single weekend. You join our jam on Friday, we tell a bit about quantum physics and games and then reveal the THEME of the jam. After this you have a little time to brainstorm an idea for a game around this theme and propose it to others and/or just listen to the ideas of others. We then help you find a team, create a channel for you and off you go!&nbsp;You have until Sunday to develop the game together with your team and present it then to the world.&nbsp; All games will be published through&nbsp;<u>the itch.io event page</u>&nbsp;together with an accompanying video and screenshots.<br />\r\n<br />\r\nCurious about Quantum Games?&nbsp;<a href=\"https://kiedos.art/quantum-games/\">https://kiedos.art/quantum-games/</a><br />\r\nWant to learn more about Quantum Game Jams?&nbsp;<a href=\"https://kiedos.art/quantum-game-jam/\">https://kiedos.art/quantum-game-jam&nbsp;</a></p>\r\n",
        "isOnline": true,
        "isFree": true,
        "isInternship": false,
        "category": "Other (specify)",
        "contacts": [
            {
                "first": "Natasha Skult",
                "second": "natasha.skult@igda.fi"
            }
        ],
        "level": [
            "Higher education",
            "Lifelong learning and (re)training",
            "Outreach"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Physics",
            "Innovation & Entrepreneurship",
            "Programming",
            "Soft Skills"
        ],
        "org": [
            "Aalto University",
            "Kiedos.ART",
            "International Game Developers Association (IGDA) Finland"
        ],
        "city": [
            "Espoo",
            "Helsinki",
            "Turku"
        ],
        "country": [
            "Finland",
            "Finland",
            "Finland"
        ],
        "target": [
            "Entrepreneurs",
            "Managers",
            "Investors",
            "Professionals",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [],
        "id": "744dc48c-61bc-4484-914e-5d9d139af83d"
    },
    {
        "title": "Training for industry",
        "summary": "QURECA integrates learning directly into any organisation to teach the required skills and knowledge, laying the foundation for a more inclusive and engaged workforce.\r\n",
        "description": "<p>QURECA is ready to assist any company with every stage of the training process, from hiring the best talent to building a fulfilling workforce, from early evaluations to in-depth education.&nbsp;</p>\r\n\r\n<p>QURECA offers different training packages, from 1-day awareness sessions to more technical workshops about quantum technologies over several weeks.</p>\r\n\r\n<p>https://qureca.com/quantum-training-for-industry/</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Araceli Venegas-Gomez",
                "second": "araceli.venegas-gomez@qureca.com"
            }
        ],
        "level": [
            "Lifelong learning and (re)training"
        ],
        "lang": [],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Quantum Metrology",
            "Quantum Physics",
            "Quantum Sensing",
            "Quantum Simulation",
            "Quantum Technology",
            "Business",
            "Engineering",
            "Innovation & Entrepreneurship",
            "Programming",
            "Soft Skills",
            "Teaching"
        ],
        "org": [
            "QURECA"
        ],
        "city": [],
        "country": [
            "United Kingdom"
        ],
        "target": [
            "Entrepreneurs",
            "Managers",
            "Investors",
            "Professionals",
            "Technicians"
        ],
        "type": [],
        "id": "f8638f00-9fae-4b7a-9da0-985ac918fc5b"
    },
    {
        "title": "Qureka! Box",
        "summary": "The most tangible and engaging educational tool for teaching and learning quantum computing!",
        "description": "<p>Now more than ever, we need a workforce that is ready for the quantum revolution. QURECA is dedicated to supporting the development of the quantum talent workforce. Our focus is to provide the necessary skills and knowledge to individuals and businesses around the world.</p>\r\n\r\n<p>The Qureka! Box is the solution for speeding and simplifying the learning of quantum computing. The Qureka! Box is based on the ENSAR proven methodology for teaching and learning new concepts when there are no previous knowledge. This methodology has been applied to introduce Quantum Computing in the most tangible, simple and fun experience. The Qureka! Box provides all the resources required for the five- module interactive course, which includes hands-on experiences in each module. All the tangible tools provided in the Qureka! Box has been carefully designed and constructed for learning Quantum Computing with the minimal need of abstract thinking.</p>\r\n\r\n<p>The Qureka! Box evokes a sense of quantum knowledge, generates curiosity for deeper learning and is fun for individuals of all ages.</p>\r\n",
        "isOnline": false,
        "isFree": true,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Maninder Kaur",
                "second": "maninder.kaur@qureca.com"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education",
            "Outreach"
        ],
        "lang": [
            "English",
            "Spanish",
            "French"
        ],
        "topic": [
            "Quantum Computing",
            "Programming",
            "Teaching"
        ],
        "org": [
            "QURECA"
        ],
        "city": [
            "Barcelona"
        ],
        "country": [
            "Spain"
        ],
        "target": [
            "Primary school students",
            "Primary school teachers",
            "Secondary school students",
            "Secondary school teachers",
            "BSc students"
        ],
        "type": [],
        "id": "60094fe3-cad4-4765-9a58-bd665eb30a66"
    },
    {
        "title": "Quantum Technology for Policymakers",
        "summary": "The Quantum Flagship is offering a series of training sessions on Quantum Technology (QT), addressing policymakers at EU and national levels. The training has been designed in collaboration with EC policymakers accounting for their interests and needs.",
        "description": "<p><strong>The Quantum Flagship</strong>&nbsp;is offering a series of training sessions on Quantum Technology (QT), addressing policymakers at EU and national levels. The training has been designed in collaboration with EC policymakers accounting for their interests and needs and will allow participants to:</p>\r\n\r\n<ul>\r\n\t<li>gain the necessary knowledge to make informed decisions during the performance of their duties,</li>\r\n\t<li>cooperate with peers from other countries,</li>\r\n\t<li>and sustain a conversation on QT topics with experts.</li>\r\n</ul>\r\n\r\n<p>The monthly series will consist of six dedicated online sessions, each 40 minutes long with a 20-minute presentation from experts and a 20-minute Q&amp;A session. The sessions will be recorded and be made available on this page.</p>\r\n\r\n<p>The topics will cover:</p>\r\n\r\n<ul>\r\n\t<li><a href=\"https://qt.eu/events/quantum-technology-training-for-policymakers#session-1\">European QT Ecosystem and Roadmap (June&nbsp;2023)</a></li>\r\n\t<li><a href=\"https://qt.eu/events/quantum-technology-training-for-policymakers#session-2\">Efforts and investments in QT beyond the EU (July 2023)</a></li>\r\n\t<li>Use Cases: Quantum Sensing &amp; Metrology (September 2023)</li>\r\n\t<li>Use cases: Quantum Communication (October 2023)</li>\r\n\t<li>Use Cases: Quantum Computing (November 2023)</li>\r\n\t<li>QT state-of-the-art and future use cases (December 2023)</li>\r\n</ul>\r\n",
        "isOnline": true,
        "isFree": true,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Costanza Toninelli",
                "second": "costanza.toninelli@ino.cnr.it"
            }
        ],
        "level": [
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Information",
            "Quantum Metrology",
            "Quantum Physics",
            "Quantum Sensing",
            "Quantum Simulation",
            "Quantum Technology",
            "Business"
        ],
        "org": [
            "QUCATS",
            "Italian National Institute of Optics CNR-INO"
        ],
        "city": [
            "Trieste, Florence"
        ],
        "country": [
            "Italy"
        ],
        "target": [
            "Entrepreneurs",
            "Managers",
            "Investors",
            "Other (specify)"
        ],
        "type": [],
        "id": "5d6e64cd-d04c-48a5-bf26-2fb2653a9503"
    },
    {
        "title": "Quantum Programming - Core",
        "summary": "This hands-on training allows you to identify and clarify problems that can benefit from quantum computing, then start solving those problems using D-Wave\u2019s quantum annealing computers and hybrid solvers. You\u2019ll learn how to break down an optimization problem into its objectives and constraints, develop mathematical models of the problem, write programs to run on D-Wave\u2019s solvers, and interpret returned solutions.",
        "description": "<p><span><span><span><span>This one-week, online course includes recorded presentations, quizzes, and coding assignments, along with live office hours with an expert instructor. Throughout the course, you\u2019ll have access to the Leap community to share new ideas and skills.</span></span></span></span></p>\r\n\r\n<p><span><span><span><span>Quantum Programming - Core includes access to D-Wave\u2019s Leap<sup>TM</sup> Quantum Cloud Service for the duration of the course. Upgrading to <strong>Quick Start Leap Access</strong> gives you a <em>full month</em> of real-time access to our Advantage<sup>TM</sup> quantum computers and hybrid solver services! Start your end-to-end quantum journey with the support of our software development kit, demos, Jupyter notebooks with live code, and a vibrant developer community.</span></span></span></span></p>\r\n\r\n<p>&nbsp;</p>\r\n\r\n<p><span><span><span><span>After successfully completing this course, you will be able to:</span></span></span></span></p>\r\n\r\n<ul>\r\n\t<li><span><span><span><span>Examine different problems in your area of interest for suitability for D-Wave\u2019s products.</span></span></span></span></li>\r\n\t<li><span><span><span><span>Break down an optimization problem into distinct objectives and constraints.</span></span></span></span></li>\r\n\t<li><span><span><span><span>Formulate an optimization problem as a quadratic model.</span></span></span></span></li>\r\n\t<li><span><span><span><span>Write an Ocean program to run on D-Wave\u2019s quantum computer and hybrid solvers.</span></span></span></span></li>\r\n</ul>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Kelly Novic",
                "second": "knovic@dwavesys.com"
            }
        ],
        "level": [
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "Python"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Technology",
            "Programming"
        ],
        "org": [
            "D-Wave Systems"
        ],
        "city": [
            "Burnaby"
        ],
        "country": [
            "Canada"
        ],
        "target": [
            "Professionals",
            "Technicians",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [],
        "id": "f3190dc6-95b7-484f-824c-4e313e16c591"
    },
    {
        "title": "Introduction to Quantum Software Development",
        "summary": "The general goal of the program is to present the fundamentals of software development for quantum computers, paying special attention to quantum gates, their main applications and quantum services, as an introduction to quantum software engineering.",
        "description": "<p>Specific objectives<br />\r\n- To know the fundamentals of quantum software development.<br />\r\n- To know the main quantum gates and their use.<br />\r\n- To know the main applications of current quantum software.<br />\r\n- To know the use of quantum algorithms in service-oriented software.<br />\r\n- To be able to use the tools currently available for both simulation and access to quantum computers. and access to real quantum computers.<br />\r\n- To be able to develop basic quantum software for any of the current platforms.<br />\r\n- Obtain an overview of main lines of research, with particular emphasis on quantum software engineering.</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "category": "Program",
        "contacts": [
            {
                "first": "Jos\u00e9 Manuel Garc\u00eda Alonso",
                "second": "jgaralo@unex.es"
            }
        ],
        "level": [
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "Spanish",
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Information",
            "Engineering",
            "Programming"
        ],
        "org": [
            "University of Extremadura"
        ],
        "city": [
            "C\u00e1ceres"
        ],
        "country": [
            "Spain"
        ],
        "target": [
            "Entrepreneurs",
            "Professionals",
            "Technicians",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [],
        "id": "3c7c2270-039f-4dae-9e5a-74bc17a99b7e"
    },
    {
        "title": "Professional Learning Network Quantum",
        "summary": "The Professional Learning Network (PLN) Quantum brings together physics teachers to strengthen their knowledge and teaching of quantum physics. Through workshops, material sharing, and access to university labs, teachers build their skills and a regional support network. This community is built around a series of seven afternoon sessions per year, where teachers collaborate with experts from the University of Twente (NL) to explore various facets of quantum physics.",
        "description": "<p><span><span><span><span><span><span>The PLN Quantum is a development program for regional physics teachers focused on quantum physics education. Teachers meet in 7 afternoon workshops per year to collaborate with university experts on engaging curriculum, experiments, and interpretations of quantum concepts.</span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span>Participants in the PLN Quantum will have the opportunity to delve into different perspectives on quantum physics, including its historical development, technical aspects, and philosophical implications. Within a community of peers, teachers share practical tips, critique lesson materials, and test new ideas. This comprehensive approach ensures that teachers are well-equipped to bring these complex topics to life in their classrooms.</span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span>One of the key features of the PLN Quantum is its focus on practicality. Participants will not only gain theoretical knowledge, but also practical tips that they can immediately apply in their classrooms. They will have access to tested teaching materials and an online concept test to gauge their students' understanding of the quantum world.</span></span></span></span></span></span></p>\r\n\r\n<p><span><span><span><span><span><span><span>Moreover, the program offers hands-on experience in the student lab at the University of Twente, where participants can try out various quantum practicals. They will also have the opportunity to visit the university's laboratories where cutting-edge quantum technology research is being conducted.</span></span></span></span></span></span></span></p>\r\n\r\n<p>&nbsp;</p>\r\n\r\n<p><span><span><span><span><span><span><span>By participating in the PLN Quantum, teachers build their knowledge, teaching skills, and a regional support network. They leave equipped with practical strategies and tools to make quantum physics accessible and exciting for their students. The program aims to strengthen physics education in the region by empowering teachers.</span></span></span></span></span></span></span></p>\r\n\r\n<p>&nbsp;</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Kirsten Stadermann",
                "second": "h.k.e.stadermann@utwente.nl"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education"
        ],
        "lang": [
            "Dutch"
        ],
        "topic": [
            "Quantum Physics",
            "Quantum Technology",
            "Teaching"
        ],
        "org": [
            "University of Twente"
        ],
        "city": [
            "Enschede"
        ],
        "country": [
            "The Netherlands"
        ],
        "target": [
            "Secondary school teachers",
            "Other (specify)"
        ],
        "type": [],
        "id": "234bfb15-0eae-4477-aea6-fe59750318dc"
    },
    {
        "title": "Quantum Technologies - Distance learning programme M.Sc. ",
        "summary": "Transferring quantum technologies successfully into industrial applications requires many highly qualified specialists today and in the future. The programme provides in-depth basic knowledge from the field of quantum technologies, specialisations in four pillars of quantum technology as well as lab courses to prepare students on an academic level for their future professional career.\r\nThe conceptualisation, development and evaluation of the content was funded as part of the BMBF-funded QuanTUK project in cooperation with the Fraunhofer Institute for Industrial Mathematics and the German Research Center for Artificial Intelligence. The scientific director of the programme is the award-winning quantum physicist Professor Artur Widera.",
        "description": "<p><span><span><span><strong><span lang=\"EN-GB\"><span><span>Distance and Independent Studies Center (DISC) of the University of Kaiserslautern-Landau</span></span></span></strong></span></span></span></p>\r\n\r\n<p><span><span><span><span lang=\"EN-GB\">The Distance and Independent Studies Center is one of the central academic facilities of the University of Kaiserslautern-Landau (RPTU). It offers part-time continuing education distance learning programmes in the fields of social sciences, economics, law, natural sciences, and engineering. This includes Master\u2018s programmes and Certificate programmes and courses in German and English.</span></span></span></span></p>\r\n\r\n<p><span><span><span><strong><span lang=\"EN-GB\"><span><span>Quantum Technologies, M.Sc.</span></span></span></strong></span></span></span></p>\r\n\r\n<p><span><span><span><span lang=\"EN-GB\">The distance learning programme \u201cQuantum Technologies\u201d is accredited to award the academic degree Master of Science (M.Sc.). The English-\u200blanguage Master's programme has a standard period of study of six semesters (part-\u200btime). </span></span></span></span></p>\r\n\r\n<p><span><span><span><a><strong><span lang=\"EN-GB\">Objective and Target Group</span></strong></a></span></span></span></p>\r\n\r\n<p><span><span><span><a><span lang=\"EN-GB\">The distance learning programme provides in-depth basic knowledge from the field of quantum technologies, specialisations in four pillars of quantum technology as well as lab courses to prepare students on an academic level for their future professional career.</span></a></span></span></span></p>\r\n\r\n<p><span><span><span><span lang=\"EN-GB\">The programme is aimed at individuals who are already active in the field of quantum technologies or related fields and want to deepen their knowledge through a solid foundation of techniques and methods on a scientific basis.</span></span></span></span></p>\r\n\r\n<p><span><span><span><strong><span lang=\"EN-GB\">Teaching-Learning-Format</span></strong></span></span></span></p>\r\n\r\n<p><span><span><span><span lang=\"EN-US\">The teaching-learning-format consists of </span><span lang=\"EN-GB\">comprehensive, scientifically sound and practice-oriented self-study materials that have been developed by experts especially for distance learning, an online campus as an interactive learning platform and on-campus phases to consolidate the knowledge that is acquired through self-study in theory and practice.</span> <span lang=\"EN-US\">Mandatory on-campus phases take place once per semester over a (long) weekend in Kaiserslautern.&nbsp;</span></span></span></span></p>\r\n\r\n<p><span><span><span><strong><span lang=\"EN-GB\">Structure</span></strong></span></span></span></p>\r\n\r\n<p><span><span><span><span lang=\"EN-GB\">The curriculum is divided into ten compulsory and eight compulsory elective modules, which consist of major and minor subjects.</span> <span>Among others, t</span><span lang=\"EN-GB\">he modules focus on</span></span></span></span></p>\r\n\r\n<ul>\r\n\t<li><span><span><span><span lang=\"EN-GB\">an introduction to quantum technology,</span></span></span></span></li>\r\n\t<li><span><span><span><span lang=\"EN-GB\">the mathematical, physical and technical foundations of quantum technologies,</span></span></span></span></li>\r\n\t<li><span><span><span><span lang=\"EN-GB\">quantum computing,</span></span></span></span></li>\r\n\t<li><span><span><span><span lang=\"EN-GB\">quantum simulation,</span></span></span></span></li>\r\n\t<li><span><span><span><span lang=\"EN-GB\">quantum communication,</span></span></span></span></li>\r\n\t<li><span><span><span><span lang=\"EN-GB\">quantum sensing, </span></span></span></span></li>\r\n</ul>\r\n\r\n<p><span><span><span><span lang=\"EN-GB\">and includes basis and specialization quantum technology labs.</span></span></span></span></p>\r\n\r\n<p><span><span><span><strong><span lang=\"EN-GB\">Costs</span></strong></span></span></span></p>\r\n\r\n<p><span><span><span><span lang=\"EN-GB\">At the moment, the tuition fees amount to EUR 2,100 per semester, plus a social contribution. Not included are travel and accommodation expenses or meal allowances during the on-campus phases. For more information please visit our website.</span></span></span></span></p>\r\n\r\n<p><span><span><span><strong><span lang=\"EN-GB\">Admission Requirements and Application</span></strong></span></span></span></p>\r\n\r\n<p><span><span><span><span lang=\"EN-GB\">The distance learning programme starts in the winter semester (October) of every year. The application phase usually opens in mid-May of the respective year. For information on the admission requirements and the application process please visit our </span><a href=\"https://fernstudium.rptu.de/en/distance-learning-programmes/technology-engineering-and-natural-sciences/quantum-technologies\"><span lang=\"EN-GB\">website</span></a><span lang=\"EN-GB\">. </span></span></span></span></p>\r\n\r\n<p>&nbsp;</p>\r\n\r\n<p>&nbsp;</p>\r\n\r\n<p>&nbsp;</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "category": "Program",
        "contacts": [
            {
                "first": "Programme Management Quantum Technologies",
                "second": "fernstudium-qt@rptu.de"
            }
        ],
        "level": [
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Physics",
            "Quantum Sensing",
            "Quantum Simulation"
        ],
        "org": [
            "Distance and Independent Studies Center (DISC) of the University of Kaiserslautern-Landau"
        ],
        "city": [
            "Kaiserslautern"
        ],
        "country": [
            "Germany"
        ],
        "target": [
            "Entrepreneurs",
            "Managers",
            "Investors",
            "Professionals",
            "Technicians"
        ],
        "type": [],
        "id": "d84651ac-82bb-4f48-8d45-17f8362afc44"
    },
    {
        "title": "Introduction to Quantum Computing",
        "summary": "Introduction to Quantum Computing is an engaging an highly informative training designed to equip those new to quantum physics with the basic understanding of core concepts related to quantum computing as well as other quantum technologies. With a strong focus on practical use-cases, the training offers learners insight into how this emerging technology is poised to shape the future of many industry verticals. Training can be delivered virtually or in-person upon request.",
        "description": "<h2>About the course</h2>\r\n\r\n<p>This Introduction to Quantum Computing online course is the first step for learners to grasp the fundamentals of quantum computing, designed to demystify the core principles and practical applications of this revolutionary technology. The course delves into the core pillars of quantum technologies \u2014computing, communications, simulation, and sensing\u2014 alongside a deep dive into the linear algebra essential for understanding quantum states and operations. With an emphasis on practical applications, the course covers the basics of quantum computing architecture, including quantum phenomena, the comparison of classical and quantum computing, basic quantum computing algorithms as well as the currently available quantum hardware and software technologies. Through engaging lectures and case studies, students will gain insights into the use-cases of quantum computing across various sectors like finance, healthcare, and logistics, preparing them for the advancements in the second quantum revolution.</p>\r\n\r\n<h2>What skills you will learn</h2>\r\n\r\n<p><strong>Technical Skills:</strong>&nbsp;Acquire a comprehensive foundation in quantum mechanics, computing fundamentals, linear algebra, quantum phenomena, algorithms, hardware technologies, and software development to navigate the evolving landscape of quantum technologies.</p>\r\n\r\n<p><strong>Business Skills:</strong>&nbsp;Gain strategic insights and understand the practical applications of quantum computing across various sectors, preparing for market trends, investment opportunities, and the integration of hybrid quantum-computing models into business operations.</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Dr Araceli Venegas-Gomez",
                "second": "araceli.venegas-gomez@qureca.com"
            }
        ],
        "level": [
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Communication",
            "Quantum Computing",
            "Quantum Sensing",
            "Quantum Simulation",
            "Quantum Technology"
        ],
        "org": [
            "QURECA"
        ],
        "city": [
            "Glasgow"
        ],
        "country": [
            "United Kingdom"
        ],
        "target": [
            "Entrepreneurs",
            "Managers",
            "Investors",
            "Professionals",
            "Technicians",
            "Other (specify)",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [],
        "id": "af802791-9237-42d5-bae5-7a31f8e0aea3"
    },
    {
        "title": "Quantum Training for Business",
        "summary": "Quantum Training for Business provides business leaders and CXOs with an introduction to quantum physics and the technologies emerging in the second quantum revolution. As part of QURECA's customisable training packages, the course can be tailored to suit the needs, interest and prior quantum-awareness of any business interested in becoming part of the quantum ecosystem and gaining competitive advantage in this rapidly evolving technology landscape. The training can be delivered virtually or in-person upon request.",
        "description": "<h2>Workshop Overview:</h2>\r\n\r\n<p>Quantum Training for Business is an introductory training program for business leaders and CXOs to introduce concepts of quantum computing and technologies, and the first steps for businesses to join the quantum ecosystem.</p>\r\n\r\n<p>This training provides an overview of quantum technologies, the quantum ecosystem, various industrial use-cases, and quantum-safe security. It is meant for all business, management, and technical professionals irrespective of their prior knowledge in quantum.</p>\r\n\r\n<h2>Learning Objectives:</h2>\r\n\r\n<ul>\r\n\t<li>Understanding quantum computing fundamentals, history, and motivations.</li>\r\n\t<li>Assess quantum technology readiness and Integration within a business.</li>\r\n\t<li>Recognise countries, businesses, and resources in the quantum ecosystem.</li>\r\n\t<li>Identifying business use-cases for quantum technologies.</li>\r\n</ul>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "category": "Training",
        "contacts": [
            {
                "first": "Araceli Venegas-Gomez",
                "second": "araceli.venegas-gomez@qureca.com"
            }
        ],
        "level": [
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Business",
            "Innovation & Entrepreneurship"
        ],
        "org": [
            "QURECA"
        ],
        "city": [
            "Glasgow"
        ],
        "country": [
            "United Kingdom"
        ],
        "target": [
            "Entrepreneurs",
            "Managers",
            "Professionals",
            "Technicians",
            "Other (specify)",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [],
        "id": "222cb8ac-de20-4d06-b64b-9b94e2a5c7f6"
    },
    {
        "title": "Quantum Bootcamp",
        "summary": "Join an immersive journey into the world of quantum mechanics and computing! This intensive program is designed to equip participants with the knowledge, skills, and practical experience needed to harness the transformative potential of quantum computing.",
        "description": "<h2>Program Overview:</h2>\r\n\r\n<p>The Quantum Computing Bootcamp is a hands-on training program that provides a comprehensive introduction to quantum computing principles, algorithms, and applications. Participants will learn from leading experts in the field and engage in a series of interactive workshops, coding sessions, and collaborative projects aimed at demystifying quantum computing and exploring its real-world implications.</p>\r\n\r\n<h2>Program Objectives:</h2>\r\n\r\n<ul>\r\n\t<li>Gain a solid understanding of the fundamental principles of quantum mechanics and quantum computing.</li>\r\n\t<li>Learn how to design and implement quantum algorithms using industry-standard tools and programming languages.</li>\r\n\t<li>Explore practical applications of quantum computing in fields such as optimization, cryptography, and machine learning.</li>\r\n\t<li>Develop critical thinking and problem-solving skills through hands-on exercises and group projects.</li>\r\n\t<li>Network with peers and industry professionals to exchange ideas and insights on quantum computing trends and developments.</li>\r\n</ul>\r\n\r\n<h2>Program Structure:</h2>\r\n\r\n<p>The Quantum Computing Bootcamp is structured as a multi-day program consisting of lectures, tutorials, and practical exercises. Participants will engage in a combination of individual and group activities, culminating in a final project where they will apply their newly acquired skills to solve a real-world problem using quantum computing techniques.</p>\r\n\r\n<h2>Topics Covered:</h2>\r\n\r\n<ul>\r\n\t<li>Introduction to Quantum Mechanics and Quantum Computing</li>\r\n\t<li>Quantum Gates and Quantum Circuits</li>\r\n\t<li>Quantum Algorithms: Grover\u2019s Search, Shor\u2019s Factoring, and more</li>\r\n\t<li>Quantum Machine Learning and Optimization</li>\r\n\t<li>Quantum Cryptography and Secure Communication</li>\r\n\t<li>Quantum Error Correction and Fault-Tolerance</li>\r\n\t<li>Hands-on Programming with Quantum Development Frameworks (Qiskit, Cirq, etc.)</li>\r\n</ul>\r\n\r\n<h2>Who Should Attend:</h2>\r\n\r\n<p>The Quantum Computing Bootcamp is suitable for individuals from diverse backgrounds, including students, researchers, software developers, and business professionals. Whether you\u2019re a newcomer to quantum computing or an experienced practitioner looking to deepen your knowledge, this bootcamp offers something for everyone.</p>\r\n\r\n<h2>Why Attend:</h2>\r\n\r\n<ul>\r\n\t<li>Gain a competitive edge in the rapidly evolving field of quantum computing.</li>\r\n\t<li>Learn from leading experts and practitioners with hands-on experience in quantum technologies.</li>\r\n\t<li>Network with peers and industry professionals to explore collaboration opportunities and stay abreast of the latest advancements in quantum computing.</li>\r\n\t<li>Acquire practical skills and experience that can be immediately applied to real-world projects and initiatives.</li>\r\n</ul>\r\n\r\n<p>Join us for an unforgettable learning experience and unlock the power of quantum computing at the Quantum Computing Bootcamp. Are you ready to take the quantum leap? Let\u2019s embark on this exciting journey together!</p>\r\n",
        "isOnline": false,
        "isFree": false,
        "isInternship": false,
        "category": "Program",
        "contacts": [
            {
                "first": "Araceli Venegas-Gomez",
                "second": "araceli.venegas-gomez@qureca.com"
            }
        ],
        "level": [
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Programming",
            "Other (specify)"
        ],
        "org": [
            "QURECA"
        ],
        "city": [
            "Glasgow"
        ],
        "country": [
            "United Kingdom"
        ],
        "target": [
            "Entrepreneurs",
            "Managers",
            "Investors",
            "Professionals",
            "Technicians",
            "Other (specify)",
            "BSc students",
            "MSc students",
            "PhD students",
            "Other (specify)"
        ],
        "type": [],
        "id": "adc19acc-d6da-4164-b1cd-13c4ad8cbb83"
    },
    {
        "title": "Quantum Strategy for Business",
        "summary": "Quantum Strategy for Business (QS4B) course equips you with tools and frameworks essential for crafting a competitive business strategy aimed at securing a quantum advantage for you and your organisation. By learning how to maximise your strategic leverage, you can achieve long-term business goals and objectives through an in-depth strategy formulation and its effective implementation.",
        "description": "<h3>About the course</h3>\r\n\r\n<p>QS4B integrates the latest in artificial intelligence tools, including text-to-video, voice emulation, and professional image creation, to enrich the learning experience with unique, expert content from your instructor. These generative AI solutions augment the course material, providing a seamless and engaging educational journey. As a pioneering platform in the use of artificial intelligence tools for education, QURECA offers this course as its first offering in a series dedicated to leveraging AI for educational enhancement. For those interested in further exploring the realm of quantum, additional e-learning courses are available on the&nbsp;<a href=\"https://platform.qureca.com/\">QURECA training platform</a>.</p>\r\n\r\n<h3>Learning Objectives</h3>\r\n\r\n<p>The Quantum Strategy for Business course is designed to guide students through the complexities of integrating quantum technologies into their organisations, offering a comprehensive roadmap across 11 modules for gaining competitive advantage in quantum computing, communications, and cryptography. It emphasises the importance of creating a well-thought-out quantum roadmap and identifying clear use cases, which are crucial for justifying quantum investments and tailoring them to the organisation\u2019s and customers\u2019 needs. The course covers practical aspects such as :</p>\r\n\r\n<ul>\r\n\t<li>Emphasise creating a detailed quantum roadmap and identifying specific use cases to justify investments.</li>\r\n\t<li>Cover the selection of quantum hardware, software, and services using benchmarks for comparison.</li>\r\n\t<li>Teach integration of quantum technologies with existing infrastructure for optimal performance.</li>\r\n\t<li>Discuss planning for scalability and security of quantum solutions.</li>\r\n\t<li>Address the need for leadership and resource management to build a quantum-skilled team.</li>\r\n\t<li>Highlight the importance of education, training, and investing in innovation.</li>\r\n\t<li>Prepare business leaders and technologists to leverage quantum technologies for competitive advantage.</li>\r\n</ul>\r\n\r\n<h3>Specify the Skillset</h3>\r\n\r\n<p><strong>Technical Skills:</strong>&nbsp;Gain a foundational understanding of quantum technologies including computing, communications, and cryptography, and learn how to evaluate and select appropriate quantum hardware, software, or services. Acquire skills in integrating quantum technologies with classical systems for optimal performance, along with methods for ensuring the scalability and security of quantum solutions.</p>\r\n\r\n<p><strong>Business skills:</strong>&nbsp;Learn to identify practical quantum use cases across various industries to benefit organizations and their customers, and prepare to make quantum technology an organisational priority by balancing investments between traditional and quantum technologies. Understand how the early adoption of quantum technologies can lead to a real-world competitive advantage, supported by global examples of quantum successes.</p>\r\n\r\n<p><strong>Management skills:</strong>&nbsp;Develop the ability to create detailed roadmaps and assessments for prioritising quantum investments, understand necessary roles and strategies for staffing a future-ready quantum organisation, and review options for quantum training to upskill your workforce. Master the strategic integration of quantum technologies into your business model to achieve competitive advantages, positioning yourself as an adept quantum strategist.</p>\r\n\r\n<h3>Course Structure</h3>\r\n\r\n<ul>\r\n\t<li>\r\n\t<h4>The Market Today</h4>\r\n\t</li>\r\n\t<li>\r\n\t<h4>Roadmaps, Planning &amp; Assessments</h4>\r\n\t</li>\r\n\t<li>\r\n\t<h4>Use-cases</h4>\r\n\t</li>\r\n\t<li>\r\n\t<h4>Hardware &amp; Software</h4>\r\n\t</li>\r\n\t<li>\r\n\t<h4>Infrastructure</h4>\r\n\t</li>\r\n\t<li>\r\n\t<h4>Security Strategy</h4>\r\n\t</li>\r\n\t<li>\r\n\t<h4>Leadership</h4>\r\n\t</li>\r\n\t<li>\r\n\t<h4>Education &amp; Training</h4>\r\n\t</li>\r\n\t<li>\r\n\t<h4>Investment</h4>\r\n\t</li>\r\n\t<li>\r\n\t<h4>Real World Competitive Advantage</h4>\r\n\t</li>\r\n</ul>\r\n\r\n<h3>Course Prerequisites</h3>\r\n\r\n<p>There is no prerequisite for taking this course.</p>\r\n\r\n<h3>Duration</h3>\r\n\r\n<p>The estimated duration to complete this course is approximately 4 hours.</p>\r\n\r\n<h3>Course assessment</h3>\r\n\r\n<p>Pass the Final Quiz after you complete the course by scoring at least 80% and earn your certificate upon completion.</p>\r\n",
        "isOnline": true,
        "isFree": false,
        "isInternship": false,
        "category": "Course",
        "contacts": [
            {
                "first": "Araceli Venegas-Gomez",
                "second": "araceli.venegas-gomez@qureca.com"
            }
        ],
        "level": [
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Physics",
            "Quantum Sensing",
            "Quantum Technology",
            "Business"
        ],
        "org": [
            "QURECA"
        ],
        "city": [
            "Glasgow"
        ],
        "country": [
            "United Kingdom"
        ],
        "target": [
            "Entrepreneurs",
            "Managers",
            "Investors",
            "Professionals",
            "Technicians",
            "Other (specify)",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [],
        "id": "ccaf8aa4-bf65-40cc-8e3d-bf554c0ee4ea"
    },
    {
        "title": "Introduction to the Quantum Ecosystem",
        "summary": "As part of QTIndu's General Introduction and Transversal quantum technology content, this module will present an overview of the ecosystem being built around quantum computing, providing a solid foundation to understand the potential, opportunities, and strategies surrounding quantum technologies.",
        "description": "<h3>Learning objectives</h3>\r\n\r\n<ul>\r\n\t<li>Assess the investment landscape of the quantum industry, including start-ups, venture capital, and key players.</li>\r\n\t<li>Understand the differences between classical and quantum computers abilities.</li>\r\n\t<li>Identify and articulate the potential applications and opportunities for quantum computing</li>\r\n</ul>\r\n\r\n<h3>Course Structure</h3>\r\n\r\n<ol>\r\n\t<li>Why Quantum</li>\r\n\t<li>Opportunities and Strategies</li>\r\n\t<li>Investment Landscape</li>\r\n\t<li>Shaping the Next Generation</li>\r\n</ol>\r\n\r\n<h3>Course Prerequisites</h3>\r\n\r\n<p>There is no prerequisite for taking this course.</p>\r\n\r\n<h3>Duration</h3>\r\n\r\n<p>The estimated duration to complete this course is approximately 1.5 hours.</p>\r\n",
        "isOnline": true,
        "isFree": true,
        "isInternship": false,
        "category": "Other (specify)",
        "contacts": [
            {
                "first": "Araceli Venegas-Gomez",
                "second": "araceli.venegas-gomez@qureca.com"
            }
        ],
        "level": [
            "Primary and Secondary School",
            "Higher education",
            "Lifelong learning and (re)training"
        ],
        "lang": [
            "English"
        ],
        "topic": [
            "Quantum Computing",
            "Quantum Information",
            "Quantum Physics",
            "Quantum Sensing",
            "Quantum Technology",
            "Innovation & Entrepreneurship"
        ],
        "org": [
            "QTIndu"
        ],
        "city": [
            "Glasgow"
        ],
        "country": [
            "United Kingdom"
        ],
        "target": [
            "Entrepreneurs",
            "Managers",
            "Investors",
            "Professionals",
            "Technicians",
            "Other (specify)",
            "Secondary school students",
            "Secondary school teachers",
            "BSc students",
            "MSc students",
            "PhD students"
        ],
        "type": [],
        "id": "83b855d3-8d45-437f-81f4-e4404f6b03de"
    }
]